import { createSvgIcon } from './svg-icon';

export const ArchiveFileCheckIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M33.7657 10.3555 22 22.1212l-6.7688-6.7688 2.1213-2.1213L22 17.8785l9.6444-9.6444zM4 38V28h40v10c0 3.3137-2.6863 6-6 6H10c-3.3137 0-6-2.6863-6-6m17-2h6c1.1046 0 2-.8954 2-2s-.8954-2-2-2h-6c-1.1046 0-2 .7568-2 1.8614S19.8954 36 21 36"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.5607 3.318A4.5 4.5 0 0 1 20.7426 2H35c2.7614 0 5 2.2386 5 5v18h-3V7c0-1.1046-.8954-2-2-2H20.7426a1.5 1.5 0 0 0-1.0606.4393l-8.2427 8.2427A1.5 1.5 0 0 0 11 14.7426V25H8V14.7426a4.5 4.5 0 0 1 1.318-3.1819z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'ArchiveFileCheck',
  48
);

export const AtmMachineCreditCardIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M47 2v17.5h-5v-3h2V5H4v11.5h2v3H1V2z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 7v29c0 2.7614 2.2386 5 5 5h13V7zm5 0h3v7h-3z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M33 7v34h1c2.7614 0 5-2.2386 5-5V7z"
      key="2"
    />,
  ],
  'AtmMachineCreditCard',
  48
);

export const AuditTrailIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 12c0-4.4183 3.5817-8 8-8s8 3.5817 8 8-3.5817 8-8 8-8-3.5817-8-8"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M46.1497 30h-18.995l-5.7391 11H14v3h24.8453z"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M24 23c-9.8828 0-18 7.5723-18 17.0375v.7548l.731.1724a78 78 0 0 0 4.269.882V41c0-1.6569 1.3431-3 3-3h5.597l4.8979-9.3877A3 3 0 0 1 27.1547 27h8.4327C32.4482 24.5003 28.399 23 24 23"
      key="2"
    />,
  ],
  'AuditTrail',
  48
);

export const AwardCertificateIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M33.2451 18.9349C34.0817 17.7692 35.4445 17 37 17s2.9183.7692 3.7549 1.9349c1.4159-.2327 2.9234.187 4.0233 1.2869s1.5195 2.6074 1.2869 4.0233C47.2308 25.0817 48 26.4445 48 28c0 1.5554-.7692 2.9182-1.9349 3.7549.2327 1.4158-.187 2.9234-1.2869 4.0232-1.0999 1.1-2.6075 1.5197-4.0234 1.287C39.9182 38.2308 38.5555 39 37 39s-2.9182-.7692-3.7548-1.9349c-1.4159.2327-2.9235-.187-4.0234-1.287-1.0999-1.0998-1.5195-2.6074-1.2869-4.0232C26.7692 30.9183 26 29.5554 26 28s.7692-2.9183 1.9349-3.7549c-.2326-1.4159.187-2.9234 1.2869-4.0233s2.6074-1.5195 4.0233-1.2869M41 28c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m30.8947 39.9603-1.1059 6.3733L37 44.5308l7.2112 1.8028-1.106-6.3733a7.7 7.7 0 0 1-1.0889.1502C40.685 41.2781 38.9346 42 37 42s-3.685-.7219-5.0163-1.8895a7.7 7.7 0 0 1-1.089-.1502"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2C8.6863 2 6 4.6863 6 8v30c0 3.3137 2.6863 6 6 6h15.1464c.3385-1.983.6298-3.7466.8794-5.3116a7.64 7.64 0 0 1-.9253-.7889c-1.368-1.3681-2.0952-3.1162-2.2109-4.8832C23.7219 31.685 23 29.9346 23 28s.7219-3.685 1.8896-5.0164c.1157-1.7669.8429-3.5151 2.2109-4.8831s3.1162-2.0952 4.8831-2.2109C33.315 14.7219 35.0654 14 37 14c1.9267 0 3.6707.716 5 1.8753V8c0-3.3137-2.6863-6-6-6zm0 8v3h10v-3zm13 3h5v-3h-5zm-7 3v3h-6v-3z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'AwardCertificate',
  48
);

export const BagChartPieIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 4c-3.3137 0-6 2.6863-6 6v6h-3v-6c0-4.9706 4.0294-9 9-9s9 4.0294 9 9v6h-3v-6c0-3.3137-2.6863-6-6-6m19 32h-9v-9h2l4.5 2.5L43 34z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M34 29c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7m-10 7c0-5.5228 4.4772-10 10-10s10 4.4772 10 10-4.4772 10-10 10-10-4.4772-10-10"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M39.0001 13H8.9678v10.8967l-2.689 12.8768C5.5006 40.5001 8.345 44 12.152 44h11.6002C22.0278 41.7941 21 39.0171 21 36c0-7.1797 5.8203-13 13-13 1.7808 0 3.4779.358 5.0233 1.0061l-.0232-.1103z"
      key="2"
    />,
  ],
  'BagChartPie',
  48
);

export const BagCheckIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 4c-3.3137 0-6 2.6863-6 6v6h-3v-6c0-4.9706 4.0294-9 9-9s9 4.0294 9 9v6h-3v-6c0-3.3137-2.6863-6-6-6m19.5 32c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5 4.2533-9.5 9.5-9.5 9.5 4.2533 9.5 9.5m-3.8811-2.6009-2.2198-2.018-4.9508 5.4459L30 34.3787 27.8787 36.5l4.673 4.673z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M39.0001 13H8.9678v10.8967l-2.689 12.8768C5.5006 40.5001 8.345 44 12.152 44h12.2428C22.5874 41.8322 21.5 39.0431 21.5 36c0-6.9036 5.5964-12.5 12.5-12.5 1.8359 0 3.5794.3958 5.1498 1.1067l-.1497-.7109z"
      key="1"
    />,
  ],
  'BagCheck',
  48
);

export const BagFastIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.5 26h13v3h-13zM24 4c-3.3137 0-6 2.6863-6 6v6h-3v-6c0-4.9706 4.0294-9 9-9s9 4.0294 9 9v6h-3v-6c0-3.3137-2.6863-6-6-6"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M38.9999 13H8.9676v10.8967L7.9019 29h7.098v3H7.2754l-.9969 4.7735C5.5004 40.5001 8.3449 44 12.152 44h23.6858c3.8111 0 6.6564-3.5068 5.8713-7.2361L39 23.8958zm-27.5 22h-1.5v3h10v-3zm11.5 0h4v3h-4z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'BagFast',
  48
);

export const BagPlusIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 4c-3.3137 0-6 2.6863-6 6v6h-3v-6c0-4.9706 4.0294-9 9-9s9 4.0294 9 9v6h-3v-6c0-3.3137-2.6863-6-6-6m19.5 32c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5 4.2533-9.5 9.5-9.5 9.5 4.2533 9.5 9.5m-8-5h-3v3.5H29v3h3.5V41h3v-3.5H39v-3h-3.5z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M39.0001 13H8.9678v10.8967l-2.689 12.8768C5.5006 40.5001 8.345 44 12.152 44h12.2428C22.5874 41.8322 21.5 39.0431 21.5 36c0-6.9036 5.5964-12.5 12.5-12.5 1.8359 0 3.5794.3958 5.1498 1.1067l-.1497-.7109z"
      key="1"
    />,
  ],
  'BagPlus',
  48
);

export const BagRefreshIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 4c-3.3137 0-6 2.6863-6 6v6h-3v-6c0-4.9706 4.0294-9 9-9s9 4.0294 9 9v6h-3v-6c0-3.3137-2.6863-6-6-6m5.5 42.5v-4h4v-3h-7v7z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.7785 41.7624a10 10 0 0 1-.1462-.2614l2.6291-1.4448.1226.2189c1.1295 1.932 3.2229 3.2249 5.6161 3.2249 3.3136 0 6.05-2.4808 6.4497-5.6856l.1856-1.4885 2.9769.3712-.1856 1.4885c-.5845 4.6878-4.5809 8.3144-9.4266 8.3144-2.9761 0-5.631-1.3689-7.3716-3.5074l-.1223.0685zm1.5864-4.0883.1856-1.4885c.3996-3.2048 3.1361-5.6856 6.4496-5.6856 2.4182 0 4.5303 1.32 5.6511 3.2854l.084.1517 2.6327-1.4381a9 9 0 0 0-.1001-.1811l-.7227-1.3054-.117.0648c-1.7394-2.1786-4.4196-3.5773-7.428-3.5773-4.8457 0-8.842 3.6266-9.4266 8.3144l-.1856 1.4885z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M40.5 27.5v4h-4v3h7v-7z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      d="M39.0001 13H8.9678v10.8967l-2.689 12.8768C5.5006 40.5001 8.345 44 12.152 44H23.5v-4.3652c-.7776-.6308-1.222-1.6364-1.0889-2.7032l.1856-1.4884c.7694-6.17 6.025-10.9432 12.4035-10.9432 1.3032 0 2.5597.1998 3.7404.5699a3 3 0 0 1 .4499-.2697l-.1904-.9044z"
      key="3"
    />,
  ],
  'BagRefresh',
  48
);

export const BarcodeScanIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M36 24v14h2V24zm0-14v11h2V10zm-9 14v14h2V24zm0-14v11h2V10zM16 24v14h2V24zm0-14v11h2V10zm9 14v14h2V24zm0-14v11h2V10zM14 24v14h2V24zm0-14v11h2V10zm6 14v14h2V24zm0-14v11h2V10zm12 14v14h2V24zm0-14v11h2V10zM10 24v14h2V24z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M44 24H4v3h40zM10 10v11h2V10z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 10c0-3.3137 2.6863-6 6-6h9v3h-9c-1.6569 0-3 1.3431-3 3v9H4zm0 28c0 3.3137 2.6863 6 6 6h9v-3h-9c-1.6569 0-3-1.3431-3-3v-8H4zM38 4c3.3137 0 6 2.6863 6 6v9h-3v-9c0-1.6569-1.3431-3-3-3h-9V4zm0 40c3.3137 0 6-2.6863 6-6v-8h-3v8c0 1.6569-1.3431 3-3 3h-9v3z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'BarcodeScan',
  48
);

export const BillIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M30 44.0001H4v-6c0-3.3137 2.6863-6 6-6h3V4h31v36c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4v-3c0-1.6479-1.3286-2.9854-2.9731-2.9999-1.645 0-3.0269 1.3438-3.0269 3zm-2.6586-9a5.99 5.99 0 0 0-.3414 2v4H7v-3c0-1.6568 1.3431-3 3-3zM20 16.5h17v3H20zm0-6.5v3h10v-3zm13 0h4v3h-4zM20 23v3h6v-3z"
    clipRule="evenodd"
  />,
  'Bill',
  48
);

export const BoltSpeedIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m30.6274 3.2146-1.277 15.876h15.9472L21.3728 44.7857l1.277-15.8761H6.7026zM11 8h7v3h-7zM5 8h3.01v3H5z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 37h11v3H7zm0-19H1v-3h6z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'BoltSpeed',
  48
);

export const BookOpenIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M22.5 9.5069C16.0073 6.5202 8.8316 6.8672 2.4976 10.5476L2 10.8367v30.4007l1.5024-.8729c6.0414-3.5104 12.8741-3.6924 18.9976-.5459zM7.6638 16.3914c3.1979-.7382 6.4755-.7383 9.6734 0l1.4616.3375-.6749 2.9231-1.4616-.3375c-2.7538-.6357-5.5698-.6357-8.3237.0001l-1.4615.3374-.6749-2.9231zm9.6746 10.5003c-3.1987-.7387-6.4772-.7386-9.6759 0l-1.4615.3375.675 2.9231 1.4615-.3375c2.7546-.6361 5.5713-.6361 8.3258 0l1.4616.3375.675-2.9231zM25.5 9.507c6.4926-2.9867 13.6684-2.64 20.0024 1.0404l.4976.2892v30.401l-1.5024-.873c-6.0414-3.5103-12.8742-3.6923-18.9976-.5458zm5.1615 17.3851c3.1992-.7389 6.4782-.7389 9.6774 0l1.4615.3375-.6751 2.9231-1.4615-.3376c-2.755-.6363-5.5722-.6363-8.3272 0l-1.4615.3376-.6752-2.9231zm9.676-10.5003c-3.1984-.7385-6.4766-.7385-9.675 0l-1.4615.3375.6749 2.923 1.4616-.3374c2.7543-.636 5.5707-.636 8.325 0l1.4616.3374.6749-2.923z"
    clipRule="evenodd"
  />,
  'BookOpen',
  48
);

export const BooksIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 4h12v31H5zm4.5 19h3V10h-3zM17 11h12v28H17zm4.5 19h3V17h-3zm12.2985 16.6035L28.3164 4.9628l11.8973-1.5663 5.4821 41.6407zm1.3882-23.8855 2.9743-.3916-1.6969-12.8887-2.9743.3915z"
      clipRule="evenodd"
      key="0"
    />,
    <path fill="currentColor" d="M5 38h12v8H5zm12 4h12v4H17z" key="1" />,
  ],
  'Books',
  48
);

export const BoxIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M19 19.5H4V38c0 3.3137 2.6863 6 6 6h28c3.3137 0 6-2.6863 6-6V19.5H29V28H19zM21.1731 4H8.6637L4.4971 16.5h14.7171zm18.1631 0 4.1666 12.5H28.7857L26.8528 4z"
  />,
  'Box',
  48
);

export const Calculator2Icon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M4 25.5V38c0 3.3137 2.6863 6 6 6h12.5V25.5zm15 10h-4.5V40h-2v-4.5H8v-2h4.5V29h2v4.5H19zm25-13H25.5V4H38c3.3137 0 6 2.6863 6 6zM31 8.5858l3.5 3.5 3.5-3.5L39.4142 10l-3.5 3.5 3.5 3.5001L38 18.4143l-3.5-3.5001-3.5 3.5L29.5858 17l3.5-3.5-3.5-3.5zM22.5 4v18.5H4V10c0-3.3137 2.6863-6 6-6zM9 12.5v2h9v-2zM38 44H25.5V25.5H44V38c0 3.3137-2.6863 6-6 6m-8-13h9v2h-9zm0 5v2h9v-2z"
    clipRule="evenodd"
  />,
  'Calculator2',
  48
);

export const CalculatorIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M35 2c3.3137 0 6 2.6863 6 6v32c0 3.3137-2.6863 6-6 6H13c-3.3137 0-6-2.6863-6-6V8c0-3.3137 2.6863-6 6-6zM12 7h24v13H12zm0 16h6v3h-6zm0 5v3h6v-3zm0 5h6v3h-6zm0 5v3h6v-3zm9-15h6v3h-6zm9 0v3h6v-3zm-9 5h6v3h-6zm0 5v3h6v-3zm0 5h6v3h-6zm9-10h6v13h-6z"
    clipRule="evenodd"
  />,
  'Calculator',
  48
);

export const CalendarAddIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M33 3a1.5 1.5 0 0 1 1.5 1.5V6H39c.7957 0 1.5585.3163 2.1211.879A3 3 0 0 1 42 9v17.5566a12.1 12.1 0 0 0-3.9951-.6767c-6.6964 0-12.125 5.4286-12.125 12.125 0 1.4001.2402 2.7439.6767 3.9951H9a3 3 0 0 1-2.121-.8789A3 3 0 0 1 6 39V9c0-.7957.3163-1.5585.879-2.121A3 3 0 0 1 9 6h4.5V4.5c0-.3978.1581-.7792.4395-1.0606A1.5 1.5 0 0 1 15 3a1.5 1.5 0 0 1 1.5 1.5V6h15V4.5c0-.3978.1581-.7792.4395-1.0606A1.5 1.5 0 0 1 33 3M9 9v6h30V9h-4.5v1.5c0 .3978-.1581.7792-.4395 1.0605a1.4994 1.4994 0 0 1-2.121 0A1.5 1.5 0 0 1 31.5 10.5V9h-15v1.5c0 .3978-.1581.7792-.4395 1.0605a1.4994 1.4994 0 0 1-2.121 0A1.5 1.5 0 0 1 13.5 10.5V9z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M47.5049 38.005c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5 4.2533-9.5 9.5-9.5 9.5 4.2533 9.5 9.5m-8-5h-3v3.5h-3.5v3h3.5v3.5h3v-3.5h3.5v-3h-3.5z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'CalendarAdd',
  48
);

export const CalendarCheckIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M33 3a1.5 1.5 0 0 1 1.5 1.5V6H39c.7957 0 1.5585.3163 2.1211.879A3 3 0 0 1 42 9v17.5566a12.1 12.1 0 0 0-3.9951-.6767c-6.6964 0-12.125 5.4286-12.125 12.125 0 1.4001.2402 2.7439.6767 3.9951H9a3 3 0 0 1-2.121-.8789A3 3 0 0 1 6 39V9c0-.7957.3163-1.5585.879-2.121A3 3 0 0 1 9 6h4.5V4.5c0-.3978.1581-.7792.4395-1.0606A1.5 1.5 0 0 1 15 3a1.5 1.5 0 0 1 1.5 1.5V6h15V4.5c0-.3978.1581-.7792.4395-1.0606A1.5 1.5 0 0 1 33 3M9 9v6h30V9h-4.5v1.5c0 .3978-.1581.7792-.4395 1.0605a1.4994 1.4994 0 0 1-2.121 0A1.5 1.5 0 0 1 31.5 10.5V9h-15v1.5c0 .3978-.1581.7792-.4395 1.0605a1.4994 1.4994 0 0 1-2.121 0A1.5 1.5 0 0 1 13.5 10.5V9z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M47.5 38.5c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5S32.7533 29 38 29s9.5 4.2533 9.5 9.5m-3.8811-2.6009-2.2198-2.018-4.9508 5.4459L34 36.8787 31.8787 39l4.673 4.673z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'CalendarCheck',
  48
);

export const CalendarClockIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M33 3a1.5 1.5 0 0 1 1.5 1.5V6H39c.7957 0 1.5585.3163 2.1211.879A3 3 0 0 1 42 9v17.5566a12.1 12.1 0 0 0-3.9951-.6767c-6.6964 0-12.125 5.4286-12.125 12.125 0 1.4001.2402 2.7439.6767 3.9951H9a3 3 0 0 1-2.121-.8789A3 3 0 0 1 6 39V9c0-.7957.3163-1.5585.879-2.121A3 3 0 0 1 9 6h4.5V4.5c0-.3978.1581-.7792.4395-1.0606A1.5 1.5 0 0 1 15 3a1.5 1.5 0 0 1 1.5 1.5V6h15V4.5c0-.3978.1581-.7792.4395-1.0606A1.5 1.5 0 0 1 33 3M9 9v6h30V9h-4.5v1.5c0 .3978-.1581.7792-.4395 1.0605a1.4994 1.4994 0 0 1-2.121 0A1.5 1.5 0 0 1 31.5 10.5V9h-15v1.5c0 .3978-.1581.7792-.4395 1.0605a1.4994 1.4994 0 0 1-2.121 0A1.5 1.5 0 0 1 13.5 10.5V9z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M38 48c5.2467 0 9.5-4.2533 9.5-9.5S43.2467 29 38 29s-9.5 4.2533-9.5 9.5S32.7533 48 38 48m1.425-10.2333V33.75h-2.85v5.4833l5.0813 3.6296 1.6566-2.3192z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'CalendarClock',
  48
);

export const CalendarDaysIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="currentColor"
        d="M39 6h-4.5V4.5a1.5 1.5 0 1 0-3 0V6h-15V4.5a1.5 1.5 0 1 0-3 0V6H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h30a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3M15.75 34.5a2.2502 2.2502 0 0 1-1.591-3.841A2.25 2.25 0 1 1 15.75 34.5m8.25 0a2.2502 2.2502 0 0 1-1.591-3.841A2.25 2.25 0 1 1 24 34.5m0-7.5a2.2502 2.2502 0 0 1-1.591-3.841A2.25 2.25 0 1 1 24 27m8.25 7.5a2.2502 2.2502 0 0 1-1.591-3.841A2.25 2.25 0 1 1 32.25 34.5m0-7.5a2.2502 2.2502 0 0 1-1.591-3.841A2.25 2.25 0 1 1 32.25 27M39 15H9V9h4.5v1.5a1.5001 1.5001 0 1 0 3 0V9h15v1.5a1.5001 1.5001 0 1 0 3 0V9H39z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'CalendarDays',
  48
);

export const CalendarEditIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M33 3a1.5 1.5 0 0 1 1.5 1.5V6H39c.7957 0 1.5585.3163 2.1211.879A3 3 0 0 1 42 9v15.0488c-1.6606.1853-3.2725.9132-4.5459 2.1866L24.6035 39.0869 24.3564 42H9a3 3 0 0 1-2.121-.8789A3 3 0 0 1 6 39V9c0-.7957.3163-1.5585.879-2.121A3 3 0 0 1 9 6h4.5V4.5c0-.3978.1581-.7792.4395-1.0606A1.5 1.5 0 0 1 15 3a1.5 1.5 0 0 1 1.5 1.5V6h15V4.5c0-.3978.1581-.7792.4395-1.0606A1.5 1.5 0 0 1 33 3M9 9v6h30V9h-4.5v1.5c0 .3978-.1581.7792-.4395 1.0605a1.4994 1.4994 0 0 1-2.121 0A1.5 1.5 0 0 1 31.5 10.5V9h-15v1.5c0 .3978-.1581.7792-.4395 1.0605a1.4994 1.4994 0 0 1-2.121 0A1.5 1.5 0 0 1 13.5 10.5V9z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M39.5759 28.3568c1.8091-1.8091 4.7422-1.8091 6.5513 0s1.809 4.7422 0 6.5513l-12.076 12.0761-7.1594.6079.6081-7.1593z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'CalendarEdit',
  48
);

export const CalendarMoveIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M33 3a1.5 1.5 0 0 1 1.5 1.5V6H39c.7957 0 1.5585.3163 2.1211.879A3 3 0 0 1 42 9v23.5332l-4.2881-3.2158V29l-.2119.1582L37.2881 29v.3174L23 40.0342 25.6211 42H9a3 3 0 0 1-2.121-.8789A3 3 0 0 1 6 39V9c0-.7957.3163-1.5585.879-2.121A3 3 0 0 1 9 6h4.5V4.5c0-.3978.1581-.7792.4395-1.0606A1.5 1.5 0 0 1 15 3a1.5 1.5 0 0 1 1.5 1.5V6h15V4.5c0-.3978.1581-.7792.4395-1.0606A1.5 1.5 0 0 1 33 3M9 15h30V9h-4.5v1.5c0 .3978-.1581.7792-.4395 1.0605a1.4994 1.4994 0 0 1-2.121 0A1.5 1.5 0 0 1 31.5 10.5V9h-15v1.5c0 .3978-.1581.7792-.4395 1.0605a1.4994 1.4994 0 0 1-2.121 0A1.5 1.5 0 0 1 13.5 10.5V9H9z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m28.0001 40.0339 6.7118 5.0339V35zm18.9999 0-6.7119 5.0339V35z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'CalendarMove',
  48
);

export const CalendarRemoveIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M33 3a1.5 1.5 0 0 1 1.5 1.5V6H39c.7957 0 1.5585.3163 2.1211.879A3 3 0 0 1 42 9v17.5566a12.1 12.1 0 0 0-3.9951-.6767c-6.6964 0-12.125 5.4286-12.125 12.125 0 1.4001.2402 2.7439.6767 3.9951H9a3 3 0 0 1-2.121-.8789A3 3 0 0 1 6 39V9c0-.7957.3163-1.5585.879-2.121A3 3 0 0 1 9 6h4.5V4.5c0-.3978.1581-.7792.4395-1.0606A1.5 1.5 0 0 1 15 3a1.5 1.5 0 0 1 1.5 1.5V6h15V4.5c0-.3978.1581-.7792.4395-1.0606A1.5 1.5 0 0 1 33 3M9 9v6h30V9h-4.5v1.5c0 .3978-.1581.7792-.4395 1.0605a1.4994 1.4994 0 0 1-2.121 0A1.5 1.5 0 0 1 31.5 10.5V9h-15v1.5c0 .3978-.1581.7792-.4395 1.0605a1.4994 1.4994 0 0 1-2.121 0A1.5 1.5 0 0 1 13.5 10.5V9z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M47.5 38.5c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5S32.7533 29 38 29s9.5 4.2533 9.5 9.5M33 37v3h10v-3z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'CalendarRemove',
  48
);

export const CalendarSlashIcon = createSvgIcon(
  [
    <g key="0">
      <path
        fill="currentColor"
        d="M42 9v26.1694a.75.75 0 0 1-1.3125.5062L21.9 15H39V9h-4.5v1.5a1.5 1.5 0 0 1-.4732 1.0967A1.5 1.5 0 0 1 32.9025 12 1.534 1.534 0 0 1 31.5 10.4494V9H16.4456l-1.5862-1.7456A.7498.7498 0 0 1 15.4219 6H31.5V4.5a1.5 1.5 0 0 1 .4732-1.0967A1.5 1.5 0 0 1 33.0975 3 1.5337 1.5337 0 0 1 34.5 4.5506V6H39a3 3 0 0 1 3 3m-1.89 30.4912a1.501 1.501 0 0 1 .2616 1.6157A1.5 1.5 0 0 1 39 42H9a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3 1.5 1.5 0 0 1 1.1119.4913zM13.7906 15 9 9.7294V15z"
      />
    </g>,
    <defs key="1"></defs>,
  ],
  'CalendarSlash',
  48
);

export const CalendarIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M33 3a1.5 1.5 0 0 1 1.5 1.5V6H39c.7957 0 1.5585.3163 2.1211.879A3 3 0 0 1 42 9v30a3 3 0 0 1-.8789 2.1211A3 3 0 0 1 39 42H9a3 3 0 0 1-2.121-.8789A3 3 0 0 1 6 39V9c0-.7957.3163-1.5585.879-2.121A3 3 0 0 1 9 6h4.5V4.5c0-.3978.1581-.7792.4395-1.0606A1.5 1.5 0 0 1 15 3a1.5 1.5 0 0 1 1.5 1.5V6h15V4.5c0-.3978.1581-.7792.4395-1.0606A1.5 1.5 0 0 1 33 3M9 9v6h30V9h-4.5v1.5c0 .3978-.1581.7792-.4395 1.0605a1.4994 1.4994 0 0 1-2.121 0A1.5 1.5 0 0 1 31.5 10.5V9h-15v1.5c0 .3978-.1581.7792-.4395 1.0605a1.4994 1.4994 0 0 1-2.121 0A1.5 1.5 0 0 1 13.5 10.5V9z"
  />,
  'Calendar',
  48
);

export const CardRefreshIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M40 6c3.3137 0 6 2.6863 6 6v2H2v-2c0-3.3137 2.6863-6 6-6z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M47 27.5v9h-9v-3h6v-6z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M36.5 30.5c-3.866 0-7 3.134-7 7s3.134 7 7 7c2.1469 0 4.0671-.9647 5.3535-2.4897l.9671-1.1465 2.2931 1.9344-.9672 1.1465C42.3145 46.1165 39.5681 47.5 36.5 47.5c-5.5228 0-10-4.4772-10-10s4.4772-10 10-10c4.1605 0 7.7242 2.5404 9.2311 6.1489l.578 1.3841-2.7683 1.1561-.578-1.3842C41.9059 32.2741 39.4084 30.5 36.5 30.5"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 36V21h44v3.5h-2c-.8873 0-1.6847.3852-2.2339.9976-.063.008-.1263.0161-.1862.0332C40.0197 24.8677 38.3027 24.5 36.5 24.5c-7.1797 0-13 5.8203-13 13 0 1.5819.2825 3.0978.7999 4.5H8c-3.3137 0-6-2.6863-6-6m6-4.5v3h9v-3z"
      clipRule="evenodd"
      key="3"
    />,
  ],
  'CardRefresh',
  48
);

export const CardRefundIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M46 31.7627c-1.6947-1.2719-3.7993-2.0273-6.0811-2.0273h-.6377l-.6083-.5713-5.6993-5.6993c-.3905-.3904-1.0235-.3904-1.414 0L21.4648 33.5596c-.3904.3905-.3904 1.0235 0 1.414L28.4902 42H8c-3.3137 0-6-2.6863-6-6V21h44zM8 34.5h9v-3H8zM40 6c3.3137 0 6 2.6863 6 6v2H2v-2c0-3.3137 2.6863-6 6-6z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m34.4307 29.1641-3.5703 3.5713h9.0585c3.9447 0 7.1433 3.1979 7.1436 7.1425 0 3.9448-3.1987 7.1436-7.1436 7.1436h-2.5507V43.96h2.5507c2.2542 0 4.0821-1.8279 4.0821-4.0821-.0003-2.2539-1.8281-4.081-4.0821-4.081h-9.0595l3.5713 3.5713-2.1641 2.165L25 34.2666 32.2666 27z"
      key="1"
    />,
  ],
  'CardRefund',
  48
);

export const CarouselIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="m42 34.2155 5 2V11.7844l-5 2zm-36 0-5 2V11.7844l5 2z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m40 39.6156 4 1.6V6.7844l-4 1.6zm-32 0-4 1.6V6.7844l4 1.6zM37 44H11V4h26zm-20.5498-9.0498L14 36l2.4502 1.0498L17.5 39.5l1.0498-2.4502L21 36l-2.4502-1.0498L17.5 32.5zm4.7969-13.7031L15 24.2861l6.2471 3.0391 3.039 6.2471 3.0391-6.2471 6.2471-3.0391-6.2471-3.039L24.2861 15zm8.4892-9.7969L27.2861 12.5l2.4502 1.0498L30.7861 16l1.0498-2.4502L34.2861 12.5l-2.4502-1.0498L30.7861 9z"
      key="1"
    />,
  ],
  'Carousel',
  48
);

export const CartCheckIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M11 46c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5M5.3535 2C7.329 2 9.009 3.4427 9.3076 5.3955L9.706 8h31.5538L38.376 20.3633C37.7423 23.0788 35.3207 25 32.5322 25H12.2568l-3.1816 2.7422c-.702.6053-.2736 1.7577.6533 1.7578H25.999a12.48 12.48 0 0 0-1.664 3H9.7285c-3.7079-.0001-5.4197-4.6081-2.6113-7.0293l1.9668-1.6963L6.3418 5.8486A1 1 0 0 0 5.3535 5H2V2z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M45.5 37c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5 4.2533-9.5 9.5-9.5 9.5 4.2533 9.5 9.5m-3.8811-2.6009-2.2198-2.018-4.9508 5.4459L32 35.3787 29.8787 37.5l4.673 4.673z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'CartCheck',
  48
);

export const CartFastIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m8.5 9 .4706 4H18v3H9.3235L10.5 26h22.0324c2.7885 0 5.2094-1.9211 5.8431-4.6366L41.2602 9zM21 13v3h4v-3z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 16h9.9262v3H1z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M11 46c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5m26 0c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5M5.3385 2H2v3h3.3385a1 1 0 0 1 .9895.8556L7.3709 13h3.0318L9.2965 5.4222C9.0096 3.4571 7.3245 2 5.3385 2m5.5022 14H7.8089l1.2803 8.7701-1.9723 1.7003C4.3085 28.8916 6.0207 33.5 9.7287 33.5h32.2714v-3H9.7287c-.927 0-1.355-1.1521-.653-1.7574l3.2199-2.7759z"
      key="2"
    />,
  ],
  'CartFast',
  48
);

export const CartMinusIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M11 46c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M45.5 37c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5 4.2533-9.5 9.5-9.5 9.5 4.2533 9.5 9.5M31 35.5v3h10v-3z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M5.3535 2C7.329 2 9.009 3.4427 9.3076 5.3955L9.706 8h31.5538L38.376 20.3633C37.7423 23.0788 35.3207 25 32.5322 25H12.2568l-3.1816 2.7422c-.702.6053-.2736 1.7577.6533 1.7578H25.999a12.48 12.48 0 0 0-1.664 3H9.7285c-3.7079-.0001-5.4197-4.6081-2.6113-7.0293l1.9668-1.6963L6.3418 5.8486A1 1 0 0 0 5.3535 5H2V2z"
      key="2"
    />,
  ],
  'CartMinus',
  48
);

export const CartPlus1Icon = createSvgIcon(
  <path
    fill="currentColor"
    d="M11 46c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5M5.3535 2C7.329 2 9.009 3.4427 9.3076 5.3955L9.706 8h31.5538L38.376 20.3633C37.7423 23.0788 35.3207 25 32.5322 25H12.2568l-3.1816 2.7422c-.702.6053-.2736 1.7577.6533 1.7578H25.999a12.48 12.48 0 0 0-1.664 3H9.7285c-3.7079-.0001-5.4197-4.6081-2.6113-7.0293l1.9668-1.6963L6.3418 5.8486A1 1 0 0 0 5.3535 5H2V2zm30.6514 25.5049c5.2467 0 9.5 4.2533 9.5 9.5s-4.2533 9.5-9.5 9.5-9.5-4.2533-9.5-9.5 4.2533-9.5 9.5-9.5M36 39c-.9665 0-1.75.7835-1.75 1.75s.7835 1.75 1.75 1.75 1.75-.7835 1.75-1.75S36.9665 39 36 39m-1.5-2h3v-4.9639h-3z"
  />,
  'CartPlus1',
  48
);

export const CartPlusIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M11 46c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5M5.3535 2C7.329 2 9.009 3.4427 9.3076 5.3955L9.706 8h31.5538L38.376 20.3633C37.7423 23.0788 35.3207 25 32.5322 25H12.2568l-3.1816 2.7422c-.702.6053-.2736 1.7577.6533 1.7578H25.999a12.48 12.48 0 0 0-1.664 3H9.7285c-3.7079-.0001-5.4197-4.6081-2.6113-7.0293l1.9668-1.6963L6.3418 5.8486A1 1 0 0 0 5.3535 5H2V2z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M45.5 37c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5 4.2533-9.5 9.5-9.5 9.5 4.2533 9.5 9.5m-8-5h-3v3.5H31v3h3.5V42h3v-3.5H41v-3h-3.5z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'CartPlus',
  48
);

export const CartIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M37 46c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5m-26 0c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5M5.3457 2c1.9809 0 3.6634 1.45 3.956 3.4092L9.838 9h33.2197L39.043 21.4893c-.8641 2.6879-3.3642 4.5106-6.1875 4.5107H11.6768l-2.6016 2.2422c-.702.6053-.2736 1.7577.6533 1.7578H42.5v3H9.7285c-3.7079-.0001-5.4197-4.6081-2.6113-7.0293l1.9697-1.6982-2.752-18.42A1.0005 1.0005 0 0 0 5.3458 5H2V2z"
  />,
  'Cart',
  48
);

export const ChairIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M34 29v9h-3v-9zm-17 0v9h-3v-9zm16-17v8h3V9c0-2.7614-2.2386-5-5-5H17c-2.7614 0-5 2.2386-5 5v11h3v-8z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M37 30v14h3V28c0-2.7614-2.2386-5-5-5H13c-2.7614 0-5 2.2386-5 5v16h3V30z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Chair',
  48
);

export const ChartBarGrowIcon = createSvgIcon(
  [
    <path fill="currentColor" d="m29 15 9.5-12L48 15zM5 30h7v14H5z" key="0" />,
    <path
      fill="currentColor"
      d="M35 14h7v30h-7zM15 24h7v20h-7zm10-5h7v25h-7z"
      key="1"
    />,
  ],
  'ChartBarGrow',
  48
);

export const ChartDonutIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M22.5002 2.0503C11.0494 2.8212 2 12.3538 2 24c0 5.316 1.8855 10.1916 5.0241 13.9945l7.9778-7.6657C13.7407 28.5389 13 26.356 13 24c0-5.5664 4.1346-10.1671 9.5002-10.8986zm3 11.051c4.875.6648 8.7337 4.5236 9.3984 9.3986h11.0511C45.2121 11.545 36.4551 2.788 25.5002 2.0503zM45.9496 25.5H34.8985c-.7316 5.3655-5.3322 9.5-10.8986 9.5-2.6374 0-5.058-.9282-6.953-2.4758l-7.9607 7.6494C13.0067 43.7905 18.2453 46 23.9999 46c11.6462 0 21.1787-9.0493 21.9497-20.5"
  />,
  'ChartDonut',
  48
);

export const ChartPieIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M16 11.4733v17.1082a2.5 2.5 0 0 0 1.065 2.0471l14.2938 10.0199C28.3481 43.3539 24.3663 45 20 45c-9.3888 0-17-7.6112-17-17 0-8.0111 5.5413-14.7279 13-16.5267"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M40 43c3-4 5-9.5 5-15.1064C45 14.0984 33.5 2.5 19 3v25.5z"
      key="1"
    />,
  ],
  'ChartPie',
  48
);

export const ChatBotIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 39h10v3H17zm25-12v8h-3v-8zM6 35H2v-8h4z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M25 2c-2.2091 0-4 1.7909-4 4v18.8685L28.3028 20H43c2.2091 0 4-1.7909 4-4V6c0-2.2091-1.7909-4-4-4zm4 32c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3m-14 0c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M40 22.7308V38c0 3.3137-2.6863 6-6 6H10c-3.3137 0-6-2.6863-6-6V22c0-3.3137 2.6863-6 6-6h8.6471v3H10c-1.6569 0-3 1.3431-3 3v16c0 1.6569 1.3431 3 3 3h24c1.6569 0 3-1.3431 3-3V22.7308z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'ChatBot',
  48
);

export const CheersGlassesIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M22.5 1h3v5h-3zm9.8485 3.135-2.7511 3.5608-1.1997-.8999-1.1997-.8999 2.7511-3.5609 1.1997.9zm-16.6786-.0107 2.7406 3.5686 2.3994-1.7998-2.7406-3.5686zM9.6947 16.7955l-2.3428 7.9196c-.7977 2.6964.7843 5.5202 3.5004 6.248l1.9645.5264c2.6188.7017 5.3196-.8115 6.0887-3.4113l2.4161-8.1672zm28.575 0 2.3429 7.9196c.7977 2.6964-.7844 5.5202-3.5005 6.248l-1.9645.5264c-2.6188.7017-5.3196-.8115-6.0887-3.4113l-2.4161-8.1672zm-.5001 14.6632 2.847 10.6251-2.8978.7765-2.847-10.6252zm-27.5405 0-2.847 10.6251 2.8978.7765 2.847-10.6252z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M41.5293 24.2393c1.0005 3.734-1.2153 7.5724-4.9492 8.5732-3.7342 1.0006-7.5725-1.2151-8.5733-4.9492l-4.1416-15.4551 13.5235-3.623zm-13.9902-9.71 3.3652 12.5576c.5719 2.1336 2.7648 3.3996 4.8984 2.8281 2.1339-.5717 3.4009-2.7655 2.8291-4.8994L35.2666 12.459z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.1336 12.4082 19.992 27.8633c-1.0007 3.7341-4.8391 5.9498-8.5733 4.9492-3.734-1.0007-5.9497-4.8391-4.9492-8.5732l4.1406-15.4541zM9.367 25.0156c-.5718 2.1338.6944 4.3275 2.8281 4.8994 2.1338.5718 4.3275-.6944 4.8994-2.8281l3.3643-12.5576-7.7276-2.0703z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      d="m44.4512 38.9858.3882 1.4489.3883 1.4489-11.6004 3.1083-.3882-1.4489-.3883-1.4489zm-40.9042-.011-.3883 1.4489-.3882 1.4489 11.6003 3.1083.3883-1.4489.3882-1.4489z"
      key="3"
    />,
  ],
  'CheersGlasses',
  48
);

export const CinemaScreenIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M26 44v-2c0-1.1046.8954-2 2-2h3c1.1046 0 2 .8954 2 2v2zm-5.5-8v-2c0-1.1046.8954-2 2-2h3c1.1046 0 2 .8954 2 2v2zm-11 0v-2c0-1.1046.8954-2 2-2h3c1.1046 0 2 .8954 2 2v2zm22 0v-2c0-1.1046.8954-2 2-2h3c1.1046 0 2 .8954 2 2v2zm5.5 8v-2c0-1.1046.8954-2 2-2h3c1.1046 0 2 .8954 2 2v2zm-22 0v-2c0-1.1046.8954-2 2-2h3c1.1046 0 2 .8954 2 2v2zM4 44v-2c0-1.1046.8954-2 2-2h3c1.1046 0 2 .8954 2 2v2z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M35 27H13V7.0303L35 7z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M44 31h-1.3447L38 28.3105V5.6885L42.6553 3H44zM10 5.709v22.6015L5.3486 31H4V3h1.3506z"
      key="2"
    />,
  ],
  'CinemaScreen',
  48
);

export const CircleDottedUserIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.75 3.7501c0-1.2426 1.0074-2.25 2.25-2.25s2.25 1.0074 2.25 2.25-1.0074 2.25-2.25 2.25-2.25-1.0073-2.25-2.25M44.25 21.75c1.2426 0 2.25 1.0074 2.25 2.25s-1.0074 2.25-2.25 2.25S42 25.2426 42 24s1.0073-2.25 2.25-2.25m-40.5 0C4.9926 21.75 6 22.7574 6 24s-1.0074 2.25-2.25 2.25S1.5 25.2426 1.5 24s1.0074-2.25 2.25-2.25M36.7279 8.0902c.8787-.8787 2.3033-.8787 3.182 0s.8787 2.3032 0 3.1819-2.3033.8787-3.182 0-.8787-2.3033 0-3.182M11.2721 8.09c.8787.8787.8787 2.3033 0 3.182s-2.3033.8787-3.182 0-.8786-2.3033 0-3.182 2.3034-.8786 3.182 0m18.3986-3.6594c.4755-1.148 1.7917-1.6933 2.9397-1.2177 1.1481.4755 1.6933 1.7917 1.2177 2.9397-.4755 1.148-1.7917 1.6933-2.9397 1.2177-1.1481-.4755-1.6933-1.7917-1.2177-2.9397m13.8987 25.24c1.1481.4755 1.6932 1.7917 1.2177 2.9397s-1.7917 1.6933-2.9398 1.2177c-1.148-.4755-1.6932-1.7917-1.2177-2.9397s1.7918-1.6933 2.9398-1.2177M6.1526 14.1719c1.148.4756 1.6933 1.7917 1.2177 2.9398-.4755 1.148-1.7917 1.6932-2.9397 1.2177s-1.6933-1.7917-1.2177-2.9398c.4755-1.148 1.7917-1.6932 2.9397-1.2177m35.6949.0002c1.1481-.4756 2.4643.0696 2.9398 1.2177s-.0696 2.4642-1.2177 2.9397-2.4642-.0696-2.9398-1.2177c-.4755-1.148.0697-2.4642 1.2177-2.9397M4.4303 29.6707c1.148-.4755 2.4643.0697 2.9398 1.2177s-.0697 2.4642-1.2177 2.9398c-1.148.4755-2.4642-.0697-2.9398-1.2177-.4755-1.1481.0697-2.4642 1.2177-2.9398M18.3296 4.4303c.4755 1.148-.0696 2.4643-1.2177 2.9398s-2.4642-.0697-2.9398-1.2177c-.4755-1.148.0697-2.4642 1.2177-2.9398 1.1481-.4755 2.4643.0697 2.9398 1.2177"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M24 29c3.5899 0 6.5-2.9101 6.5-6.5S27.5899 16 24 16s-6.5 2.9101-6.5 6.5S20.4101 29 24 29m13.6735 11.2398-.2942.2257C33.6722 43.3093 29.0321 45 24 45c-5.0129 0-9.6367-1.6778-13.3367-4.502l-.2966-.2264.022-.041C12.9947 35.3696 18.0729 32 24.0001 32c5.9201 0 11.0423 3.332 13.6518 8.1996z"
      key="1"
    />,
  ],
  'CircleDottedUser',
  48
);

export const CircleInfoIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M24 2C11.8497 2 2 11.8497 2 24s9.8497 22 22 22 22-9.8497 22-22S36.1503 2 24 2m2.5 11.5c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5S22.6193 11 24 11s2.5 1.1193 2.5 2.5m-5 5.5H18v3h3.5c.5523 0 1 .4477 1 1v14h3V23c0-2.2091-1.7909-4-4-4"
    clipRule="evenodd"
  />,
  'CircleInfo',
  48
);

export const CircleUserMinusIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M24 29c3.5899 0 6.5-2.9101 6.5-6.5S27.5899 16 24 16s-6.5 2.9101-6.5 6.5S20.4101 29 24 29m13.0593 10.1481C34.3055 34.8508 29.4862 32 23.9998 32s-10.3056 2.8508-13.0594 7.148C14.4444 42.1716 19.0086 44 23.9999 44s9.5555-1.8284 13.0594-4.8519"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M46.5 10c0-4.6944-3.8056-8.5-8.5-8.5s-8.5 3.8056-8.5 8.5 3.8056 8.5 8.5 8.5 8.5-3.8056 8.5-8.5M33 11.5v-3h10v3z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 5C13.5066 5 5 13.5066 5 24s8.5066 19 19 19 19-8.5066 19-19c0-.923-.0657-1.8298-.1925-2.7162l-.2124-1.4849 2.9698-.4248.2124 1.4849A22.2 22.2 0 0 1 46 24c0 12.1503-9.8497 22-22 22S2 36.1503 2 24 11.8497 2 24 2c1.0656 0 2.1144.0759 3.141.2227l1.4849.2124-.4248 2.9698-1.4849-.2124A19.2 19.2 0 0 0 24 5"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'CircleUserMinus',
  48
);

export const CircleUserPlusIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M24 29c3.5899 0 6.5-2.9101 6.5-6.5S27.5899 16 24 16s-6.5 2.9101-6.5 6.5S20.4101 29 24 29m13.0593 10.1481C34.3055 34.8508 29.4862 32 23.9998 32s-10.3056 2.8508-13.0594 7.148C14.4444 42.1716 19.0086 44 23.9999 44s9.5555-1.8284 13.0594-4.8519"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 5C13.5066 5 5 13.5066 5 24s8.5066 19 19 19 19-8.5066 19-19c0-.923-.0657-1.8298-.1925-2.7162l-.2124-1.4849 2.9698-.4248.2124 1.4849A22.2 22.2 0 0 1 46 24c0 12.1503-9.8497 22-22 22S2 36.1503 2 24 11.8497 2 24 2c1.0656 0 2.1144.0759 3.141.2227l1.4849.2124-.4248 2.9698-1.4849-.2124A19.2 19.2 0 0 0 24 5"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M38 1.5c4.6944 0 8.5 3.8056 8.5 8.5s-3.8056 8.5-8.5 8.5-8.5-3.8056-8.5-8.5 3.8056-8.5 8.5-8.5m-5 10h3.5V15h3v-3.5H43v-3h-3.5V5h-3v3.5H33z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'CircleUserPlus',
  48
);

export const CircleUserRadarIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M24 29c3.5899 0 6.5-2.9101 6.5-6.5S27.5899 16 24 16s-6.5 2.9101-6.5 6.5S20.4101 29 24 29m13.0593 10.1481C34.3055 34.8508 29.4862 32 23.9998 32s-10.3056 2.8508-13.0594 7.148C14.4444 42.1716 19.0086 44 23.9999 44s9.5555-1.8284 13.0594-4.8519"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M24 5C13.5066 5 5 13.5066 5 24s8.5066 19 19 19 19-8.5066 19-19h3c0 12.1503-9.8497 22-22 22S2 36.1503 2 24 11.8497 2 24 2c6.1037 0 11.6269 2.4857 15.6125 6.5L37.5 10.6303C34.0567 7.1536 29.2798 5 24 5"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M34.5 9.5c0 2.4853 2.0147 4.5 4.5 4.5s4.5-2.0147 4.5-4.5S41.4853 5 39 5s-4.5 2.0147-4.5 4.5"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'CircleUserRadar',
  48
);

export const CircleUserSearchIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M24 29c3.5899 0 6.5-2.9101 6.5-6.5S27.5899 16 24 16s-6.5 2.9101-6.5 6.5S20.4101 29 24 29m13.0593 10.1481C34.3055 34.8508 29.4862 32 23.9998 32s-10.3056 2.8508-13.0594 7.148C14.4444 42.1716 19.0086 44 23.9999 44s9.5555-1.8284 13.0594-4.8519"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M35.5 1C30.8056 1 27 4.8056 27 9.5s3.8056 8.5 8.5 8.5c1.8054 0 3.4794-.5629 4.856-1.5227L45 21.1213 47.1213 19l-4.644-4.644C43.4371 12.9794 44 11.3054 44 9.5 44 4.8056 40.1944 1 35.5 1M30 9.5C30 6.4624 32.4624 4 35.5 4S41 6.4624 41 9.5 38.5376 15 35.5 15 30 12.5376 30 9.5"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M24.0244 2a17.9 17.9 0 0 0-.7773 3.0156C13.1027 5.411 5 13.7588 5 24c0 10.4934 8.5066 19 19 19 9.8523 0 17.9522-7.499 18.9053-17.1006a17.9 17.9 0 0 0 3.0547-.5918C45.2834 36.8491 35.7113 46 24 46 11.8497 46 2 36.1503 2 24S11.8497 2 24 2z"
      key="2"
    />,
  ],
  'CircleUserSearch',
  48
);

export const CircleUserSparkleIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 5C13.5066 5 5 13.5066 5 24s8.5066 19 19 19 19-8.5066 19-19c0-2.0441-.3223-4.01-.9176-5.8513l-.4615-1.4273 2.8545-.923.4615 1.4273C45.6275 19.3616 46 21.6387 46 24c0 12.1503-9.8497 22-22 22S2 36.1503 2 24 11.8497 2 24 2c2.3615 0 4.6389.3726 6.7749 1.0633l1.4272.4616-.923 2.8544-1.4272-.4615C28.0104 5.3223 26.0443 5 24 5"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m40.5 7.5-3-7-3 7-7 3 7 3 3 7 3-7 7-3zM24 29c3.5899 0 6.5-2.9101 6.5-6.5S27.5899 16 24 16s-6.5 2.9101-6.5 6.5S20.4101 29 24 29m13.0593 10.1481C34.3055 34.8508 29.4862 32 23.9998 32s-10.3056 2.8508-13.0594 7.148C14.4444 42.1716 19.0086 44 23.9999 44s9.5555-1.8284 13.0594-4.8519"
      key="1"
    />,
  ],
  'CircleUserSparkle',
  48
);

export const CircleUserIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M24 2C11.8497 2 2 11.8497 2 24s9.8497 22 22 22 22-9.8497 22-22S36.1503 2 24 2m6.3717 16.3544-.6833 3.233C29.1461 24.1531 26.7653 26 24.0001 26s-5.146-1.8469-5.6883-4.4126l-.6833-3.233C16.8243 14.5497 19.8997 11 24.0001 11s7.1758 3.5497 6.3716 7.3544M24.0001 43c5.9263 0 11.2188-2.7132 14.7033-6.9652l-.2383-.8455c-.7068-2.5077-2.6162-4.637-5.2803-5.2243-5.8362-1.2866-12.5331-1.2867-18.3693-.0001-2.6642.5873-4.5735 2.7166-5.2803 5.2243l-.2383.8456C12.7813 40.2868 18.0738 43 24 43"
    clipRule="evenodd"
  />,
  'CircleUser',
  48
);

export const CircleWarningIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M24 2C11.8497 2 2 11.8497 2 24s9.8497 22 22 22 22-9.8497 22-22S36.1503 2 24 2m1.5 28V10h-3v20zm1 5.5c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5S22.6193 33 24 33s2.5 1.1193 2.5 2.5"
    clipRule="evenodd"
  />,
  'CircleWarning',
  48
);

export const ClappingHandsIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="m44.5171 6.7324.7764 2.8977-3.8952 1.0262-.7765-2.8977zM32.2456 2.4806l2.8978-.7764 1.0418 3.8953-2.8978.7765zm10.1913.3743L40.369 6.4533l-2.5978-1.4999 2.0679-3.5984zM9.3184 21.1732 21.966 8.5256c.7811-.781 2.0474-.781 2.8285 0s.781 2.0474 0 2.8284l-6.7446 6.7446.5303.5303.5304.5303 9.3588-9.3588c.7811-.781 2.0474-.781 2.8285 0s.781 2.0473 0 2.8284l-9.233 9.2329 1.0607 1.0607 7.5227-7.4933c.7815-.7783 2.0456-.777 2.8255.0029.7822.7822.7809 2.0507-.0029 2.8313l-7.5169 7.4875 1.0607 1.0607 4.9301-4.9302c.7811-.781 2.0474-.781 2.8284 0 .7811.7811.7811 2.0474 0 2.8285L22.5314 36.9516c-3.9052 3.9052-10.2369 3.9052-14.1421 0l-1.7014-1.7014a13.228 13.228 0 0 1-2.3528-15.5135l4.188-7.9589a2.47 2.47 0 0 1 1.0277-1.0317c2.1283-1.1303 4.4504 1.1434 3.3651 3.2951zm29.6831-7.3656c.781-.7811 2.048-.7811 2.8291 0 .7809.781.7808 2.0471 0 2.8281l-4.1494 4.1485a5.05 5.05 0 0 0-1.2813-1.4571c.6094-1.0646.7954-2.3053.5586-3.4775zm2.1797 5.6289c.7815-.7783 2.0453-.777 2.8252.0029.782.7822.7808 2.0505-.003 2.8311l-7.5166 7.4873 1.0606 1.0605 4.9297-4.9297c.781-.781 2.048-.781 2.8291 0 .7807.781.7806 2.0472 0 2.8281L33.064 40.9589c-3.5181 3.518-9.0036 3.8644-12.9121 1.044a12.95 12.95 0 0 0 4.501-2.9297L36.895 26.831l.1768-.1865c1.0874-1.2035 1.4849-2.8082 1.1943-4.3057z"
  />,
  'ClappingHands',
  48
);

export const ClonePlusIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M10 4c-3.3137 0-6 2.6863-6 6v18c0 3.3137 2.6863 6 6 6h1V19c0-4.4183 3.5817-8 8-8h15v-1c0-3.3137-2.6863-6-6-6z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 14c-3.3137 0-6 2.6863-6 6v18c0 3.3137 2.6863 6 6 6h18c3.3137 0 6-2.6863 6-6V20c0-3.3137-2.6863-6-6-6zm7.5 23v-6.5H21v-3h6.5V21h3v6.5H37v3h-6.5V37z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'ClonePlus',
  48
);

export const CloudDataDownloadIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M39.7909 14.1879a17.0178 17.0178 0 0 0-28.1503-9.8388A17.018 17.018 0 0 0 6.1289 14.851 9.974 9.974 0 0 0 10 34.0279h28a10 10 0 0 0 1.791-19.84M26 33.9999h-4v-10a2 2 0 0 1 4 0z" />
      <path d="M31 38h-5v-4h-4v4h-5a1 1 0 0 0-.752 1.658l7 8a1 1 0 0 0 1.5 0l7-8a1 1 0 0 0 .1585-1.0692A1 1 0 0 0 31 38" />
    </g>,
    <defs key="1"></defs>,
  ],
  'CloudDataDownload',
  48
);

export const CloudSyncIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="m31.5113 32.5.0392-.3144c.3996-3.2048 3.1361-5.6856 6.4496-5.6856 2.4182 0 4.5302 1.32 5.6511 3.2854l.0839.1517 2.6328-1.4381c-.2682-.4978-.6232-.9539-.9398-1.4217-1.7394-2.1786-4.4196-3.5773-7.428-3.5773-4.8457 0-8.842 3.6266-9.4266 8.3144l-.0855.6856zm12.9777 1h3.0232l-.0855.6856c-.5845 4.6878-4.5809 8.3144-9.4266 8.3144-2.9761 0-5.631-1.3689-7.3716-3.5074-.3385-.49-.7132-.9665-.9962-1.4916l2.6291-1.4448.1227.2189c1.1294 1.932 3.2228 3.2249 5.616 3.2249 3.3136 0 6.05-2.4808 6.4497-5.6856z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M40 30.5h6.5V24zm-4 5h-6.5V42z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M23.2667 6C14.564 6 7.3985 12.5504 6.904 20.8784 3.4514 22.3242 1 25.6398 1 29.5455 1 34.8048 5.4253 39 10.8 39h15.7v-3.3652c-.7776-.6307-1.222-1.6364-1.089-2.7032l.1856-1.4884c.7694-6.17 6.025-10.9432 12.4035-10.9432.5493 0 1.0903.0355 1.6208.1043C38.9879 12.4055 31.8734 6 23.2667 6"
      key="2"
    />,
  ],
  'CloudSync',
  48
);

export const CodeEditorIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.5 43c-2.7614 0-5-2.2386-5-5V10c0-2.7614 2.2386-5 5-5H15v38zM20 12h7v3h-7zm8 9h8v3h-8zm-4 12h6v3h-6zm0-6h12v3H24z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M41 38V10c0-1.6569-1.3431-3-3-3H10c-1.6569 0-3 1.3431-3 3v28c0 1.6569 1.3431 3 3 3h28c1.6569 0 3-1.3431 3-3m3-28v28c0 3.3137-2.6863 6-6 6H10c-3.3137 0-6-2.6863-6-6V10c0-3.3137 2.6863-6 6-6h28c3.3137 0 6 2.6863 6 6"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'CodeEditor',
  48
);

export const CoinsArrowUpIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M40.5 12.5c0 3.5899-2.9101 6.5-6.5 6.5h-5v-3h5c1.933 0 3.5-1.567 3.5-3.5V9h3z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M39 1.3333 45.5 10h-13zM5 23.5v7.4545c0 .3053.3407 1.0718 2.0496 1.8486C8.6232 33.5184 10.9023 34 13.5 34s4.8768-.4816 6.4504-1.1969C21.6593 32.0263 22 31.2598 22 30.9545V23.5h3v7.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C19.146 36.4641 16.4251 37 13.5 37s-5.646-.5359-7.6918-1.4658C3.898 34.6659 2 33.1597 2 30.9545V23.5z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 31.5v6.4545c0 .3053.3407 1.0718 2.0496 1.8486C29.6232 40.5184 31.9023 41 34.5 41s4.8768-.4816 6.4504-1.1969C42.6593 39.0263 43 38.2598 43 37.9545V31.5h3v6.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C40.146 43.4641 37.4251 44 34.5 44s-5.646-.5359-7.6918-1.4658C24.8979 41.6659 23 40.1597 23 37.9545V31.5z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 31.5v6.4545c0 .3053.3407 1.0718 2.0496 1.8486C8.6232 40.5184 10.9023 41 13.5 41s4.8768-.4816 6.4504-1.1969C21.6593 39.0263 22 38.2598 22 37.9545V31.5h3v6.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C19.146 43.4641 16.4251 44 13.5 44s-5.646-.5359-7.6918-1.4658C3.898 41.6659 2 40.1597 2 37.9545V31.5z"
      clipRule="evenodd"
      key="3"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.6454 26.5616C28.7073 25.5798 31.4855 25 34.5 25s5.7927.5798 7.8546 1.5616C44.3419 27.5079 46 29.0107 46 31s-1.6581 3.4921-3.6454 4.4384C40.2927 36.4202 37.5145 37 34.5 37s-5.7927-.5798-7.8546-1.5616C24.6581 34.4921 23 32.9893 23 31s1.6581-3.4921 3.6454-4.4384M31 29.5v3h7v-3zM5.6455 19.5616C7.7073 18.5798 10.4855 18 13.5 18s5.7927.5798 7.8546 1.5616C23.3419 20.5079 25 22.0107 25 24s-1.6581 3.4921-3.6454 4.4384C19.2927 29.4202 16.5145 30 13.5 30s-5.7927-.5798-7.8545-1.5616C3.6582 27.4921 2 25.9893 2 24s1.6582-3.4921 3.6455-4.4384M10 22.5v3h7v-3z"
      clipRule="evenodd"
      key="4"
    />,
  ],
  'CoinsArrowUp',
  48
);

export const CoinsMinusIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 23.5v7.4545c0 .3053.3407 1.0718 2.0496 1.8486C8.6232 33.5184 10.9023 34 13.5 34s4.8768-.4816 6.4504-1.1969C21.6593 32.0263 22 31.2598 22 30.9545V23.5h3v7.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C19.146 36.4641 16.4251 37 13.5 37s-5.646-.5359-7.6918-1.4658C3.898 34.6659 2 33.1597 2 30.9545V23.5z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 31.5v6.4545c0 .3053.3407 1.0718 2.0496 1.8486C29.6232 40.5184 31.9023 41 34.5 41s4.8768-.4816 6.4504-1.1969C42.6593 39.0263 43 38.2598 43 37.9545V31.5h3v6.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C40.146 43.4641 37.4251 44 34.5 44s-5.646-.5359-7.6918-1.4658C24.8979 41.6659 23 40.1597 23 37.9545V31.5z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 31.5v6.4545c0 .3053.3407 1.0718 2.0496 1.8486C8.6232 40.5184 10.9023 41 13.5 41s4.8768-.4816 6.4504-1.1969C21.6593 39.0263 22 38.2598 22 37.9545V31.5h3v6.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C19.146 43.4641 16.4251 44 13.5 44s-5.646-.5359-7.6918-1.4658C3.898 41.6659 2 40.1597 2 37.9545V31.5z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.6454 26.5616C28.7073 25.5798 31.4855 25 34.5 25s5.7927.5798 7.8546 1.5616C44.3419 27.5079 46 29.0107 46 31s-1.6581 3.4921-3.6454 4.4384C40.2927 36.4202 37.5145 37 34.5 37s-5.7927-.5798-7.8546-1.5616C24.6581 34.4921 23 32.9893 23 31s1.6581-3.4921 3.6454-4.4384M31 29.5v3h7v-3zM5.6455 19.5616C7.7073 18.5798 10.4855 18 13.5 18s5.7927.5798 7.8546 1.5616C23.3419 20.5079 25 22.0107 25 24s-1.6581 3.4921-3.6454 4.4384C19.2927 29.4202 16.5145 30 13.5 30s-5.7927-.5798-7.8545-1.5616C3.6582 27.4921 2 25.9893 2 24s1.6582-3.4921 3.6455-4.4384M10 22.5v3h7v-3zM46.5 11c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5 4.2533-9.5 9.5-9.5 9.5 4.2533 9.5 9.5M32 9.5v3h10v-3z"
      clipRule="evenodd"
      key="3"
    />,
  ],
  'CoinsMinus',
  48
);

export const CoinsPercentageIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 23.5v7.4545c0 .3053.3407 1.0718 2.0496 1.8486C8.6232 33.5184 10.9023 34 13.5 34s4.8768-.4816 6.4504-1.1969C21.6593 32.0263 22 31.2598 22 30.9545V23.5h3v7.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C19.146 36.4641 16.4251 37 13.5 37s-5.646-.5359-7.6918-1.4658C3.898 34.6659 2 33.1597 2 30.9545V23.5z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 31.5v6.4545c0 .3053.3407 1.0718 2.0496 1.8486C29.6232 40.5184 31.9023 41 34.5 41s4.8768-.4816 6.4504-1.1969C42.6593 39.0263 43 38.2598 43 37.9545V31.5h3v6.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C40.146 43.4641 37.4251 44 34.5 44s-5.646-.5359-7.6918-1.4658C24.8979 41.6659 23 40.1597 23 37.9545V31.5z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 31.5v6.4545c0 .3053.3407 1.0718 2.0496 1.8486C8.6232 40.5184 10.9023 41 13.5 41s4.8768-.4816 6.4504-1.1969C21.6593 39.0263 22 38.2598 22 37.9545V31.5h3v6.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C19.146 43.4641 16.4251 44 13.5 44s-5.646-.5359-7.6918-1.4658C3.898 41.6659 2 40.1597 2 37.9545V31.5z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.6454 26.5616C28.7073 25.5798 31.4855 25 34.5 25s5.7927.5798 7.8546 1.5616C44.3419 27.5079 46 29.0107 46 31s-1.6581 3.4921-3.6454 4.4384C40.2927 36.4202 37.5145 37 34.5 37s-5.7927-.5798-7.8546-1.5616C24.6581 34.4921 23 32.9893 23 31s1.6581-3.4921 3.6454-4.4384M31 29.5v3h7v-3zM5.6455 19.5616C7.7073 18.5798 10.4855 18 13.5 18s5.7927.5798 7.8546 1.5616C23.3419 20.5079 25 22.0107 25 24s-1.6581 3.4921-3.6454 4.4384C19.2927 29.4202 16.5145 30 13.5 30s-5.7927-.5798-7.8545-1.5616C3.6582 27.4921 2 25.9893 2 24s1.6582-3.4921 3.6455-4.4384M10 22.5v3h7v-3zm36.6213-19L31.5 18.6213 29.3787 16.5 44.5 1.3787z"
      clipRule="evenodd"
      key="3"
    />,
    <path
      fill="currentColor"
      d="M36 4.5C36 2.567 34.433 1 32.5 1S29 2.567 29 4.5 30.567 8 32.5 8 36 6.433 36 4.5m11 11c0-1.933-1.567-3.5-3.5-3.5S40 13.567 40 15.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5"
      key="4"
    />,
  ],
  'CoinsPercentage',
  48
);

export const CoinsPlusIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 23.5v7.4545c0 .3053.3407 1.0718 2.0496 1.8486C8.6232 33.5184 10.9023 34 13.5 34s4.8768-.4816 6.4504-1.1969C21.6593 32.0263 22 31.2598 22 30.9545V23.5h3v7.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C19.146 36.4641 16.4251 37 13.5 37s-5.646-.5359-7.6918-1.4658C3.898 34.6659 2 33.1597 2 30.9545V23.5z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 31.5v6.4545c0 .3053.3407 1.0718 2.0496 1.8486C29.6232 40.5184 31.9023 41 34.5 41s4.8768-.4816 6.4504-1.1969C42.6593 39.0263 43 38.2598 43 37.9545V31.5h3v6.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C40.146 43.4641 37.4251 44 34.5 44s-5.646-.5359-7.6918-1.4658C24.8979 41.6659 23 40.1597 23 37.9545V31.5z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 31.5v6.4545c0 .3053.3407 1.0718 2.0496 1.8486C8.6232 40.5184 10.9023 41 13.5 41s4.8768-.4816 6.4504-1.1969C21.6593 39.0263 22 38.2598 22 37.9545V31.5h3v6.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C19.146 43.4641 16.4251 44 13.5 44s-5.646-.5359-7.6918-1.4658C3.898 41.6659 2 40.1597 2 37.9545V31.5z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.6454 26.5616C28.7073 25.5798 31.4855 25 34.5 25s5.7927.5798 7.8546 1.5616C44.3419 27.5079 46 29.0107 46 31s-1.6581 3.4921-3.6454 4.4384C40.2927 36.4202 37.5145 37 34.5 37s-5.7927-.5798-7.8546-1.5616C24.6581 34.4921 23 32.9893 23 31s1.6581-3.4921 3.6454-4.4384M31 29.5v3h7v-3zM5.6455 19.5616C7.7073 18.5798 10.4855 18 13.5 18s5.7927.5798 7.8546 1.5616C23.3419 20.5079 25 22.0107 25 24s-1.6581 3.4921-3.6454 4.4384C19.2927 29.4202 16.5145 30 13.5 30s-5.7927-.5798-7.8545-1.5616C3.6582 27.4921 2 25.9893 2 24s1.6582-3.4921 3.6455-4.4384M10 22.5v3h7v-3zM46.5 11c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5 4.2533-9.5 9.5-9.5 9.5 4.2533 9.5 9.5m-8-5h-3v3.5H32v3h3.5V16h3v-3.5H42v-3h-3.5z"
      clipRule="evenodd"
      key="3"
    />,
  ],
  'CoinsPlus',
  48
);

export const CoinsXmarkIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 23.5v7.4545c0 .3053.3407 1.0718 2.0496 1.8486C8.6232 33.5184 10.9023 34 13.5 34s4.8768-.4816 6.4504-1.1969C21.6593 32.0263 22 31.2598 22 30.9545V23.5h3v7.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C19.146 36.4641 16.4251 37 13.5 37s-5.646-.5359-7.6918-1.4658C3.898 34.6659 2 33.1597 2 30.9545V23.5z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 31.5v6.4545c0 .3053.3407 1.0718 2.0496 1.8486C29.6232 40.5184 31.9023 41 34.5 41s4.8768-.4816 6.4504-1.1969C42.6593 39.0263 43 38.2598 43 37.9545V31.5h3v6.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C40.146 43.4641 37.4251 44 34.5 44s-5.646-.5359-7.6918-1.4658C24.8979 41.6659 23 40.1597 23 37.9545V31.5z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 31.5v6.4545c0 .3053.3407 1.0718 2.0496 1.8486C8.6232 40.5184 10.9023 41 13.5 41s4.8768-.4816 6.4504-1.1969C21.6593 39.0263 22 38.2598 22 37.9545V31.5h3v6.4545c0 2.2052-1.8979 3.7114-3.8082 4.5797C19.146 43.4641 16.4251 44 13.5 44s-5.646-.5359-7.6918-1.4658C3.898 41.6659 2 40.1597 2 37.9545V31.5z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.6454 26.5616C28.7073 25.5798 31.4855 25 34.5 25s5.7927.5798 7.8546 1.5616C44.3419 27.5079 46 29.0107 46 31s-1.6581 3.4921-3.6454 4.4384C40.2927 36.4202 37.5145 37 34.5 37s-5.7927-.5798-7.8546-1.5616C24.6581 34.4921 23 32.9893 23 31s1.6581-3.4921 3.6454-4.4384M31 29.5v3h7v-3zM5.6455 19.5616C7.7073 18.5798 10.4855 18 13.5 18s5.7927.5798 7.8546 1.5616C23.3419 20.5079 25 22.0107 25 24s-1.6581 3.4921-3.6454 4.4384C19.2927 29.4202 16.5145 30 13.5 30s-5.7927-.5798-7.8545-1.5616C3.6582 27.4921 2 25.9893 2 24s1.6582-3.4921 3.6455-4.4384M10 22.5v3h7v-3zm27-2c5.2467 0 9.5-4.2533 9.5-9.5S42.2467 1.5 37 1.5s-9.5 4.2533-9.5 9.5 4.2533 9.5 9.5 9.5m-2.645-4.7334-2.1214-2.1213L34.8789 11l-2.6437-2.6436 2.1214-2.1213 2.6436 2.6436 2.646-2.646 2.1213 2.1213L39.1215 11l2.6447 2.6448-2.1213 2.1213-2.6447-2.6447z"
      clipRule="evenodd"
      key="3"
    />,
  ],
  'CoinsXmark',
  48
);

export const CoinsIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 29v6.9545c0 .3053.3407 1.0718 2.0496 1.8486C29.6232 38.5184 31.9023 39 34.5 39s4.8768-.4816 6.4504-1.1969C42.6593 37.0263 43 36.2598 43 35.9545V29h3v6.9545c0 2.2052-1.8979 3.7114-3.8082 4.5797C40.146 41.4641 37.4251 42 34.5 42s-5.646-.5359-7.6918-1.4658C24.8979 39.6659 23 38.1597 23 35.9545V29zM5 15v6.9545c0 .3053.3407 1.0718 2.0496 1.8486C8.6232 24.5184 10.9023 25 13.5 25s4.8768-.4816 6.4504-1.1969C21.6593 23.0263 22 22.2598 22 21.9545V15h3v6.9545c0 2.2052-1.8979 3.7114-3.8082 4.5797C19.146 27.4641 16.4251 28 13.5 28s-5.646-.5359-7.6918-1.4658C3.898 25.6659 2 24.1597 2 21.9545V15z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 29v6.9545c0 .3053.3407 1.0718 2.0496 1.8486C8.6232 38.5184 10.9023 39 13.5 39s4.8768-.4816 6.4504-1.1969C21.6593 37.0263 22 36.2598 22 35.9545V29h3v6.9545c0 2.2052-1.8979 3.7114-3.8082 4.5797C19.146 41.4641 16.4251 42 13.5 42s-5.646-.5359-7.6918-1.4658C3.898 39.6659 2 38.1597 2 35.9545V29z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 22v6.9545c0 .3053.3407 1.0718 2.0496 1.8486C8.6232 31.5184 10.9023 32 13.5 32s4.8768-.4816 6.4504-1.1969C21.6593 30.0263 22 29.2598 22 28.9545V22h3v6.9545c0 2.2052-1.8979 3.7114-3.8082 4.5797C19.146 34.4641 16.4251 35 13.5 35s-5.646-.5359-7.6918-1.4658C3.898 32.6659 2 31.1597 2 28.9545V22z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M34.5 23c-3.0145 0-5.7927.5798-7.8546 1.5616C24.6581 25.5079 23 27.0107 23 29s1.6581 3.4921 3.6454 4.4384C28.7073 34.4202 31.4855 35 34.5 35s5.7927-.5798 7.8546-1.5616C44.3419 32.4921 46 30.9893 46 29s-1.6581-3.4921-3.6454-4.4384C40.2927 23.5798 37.5145 23 34.5 23M31 27.5v3h7v-3zM13.5 9c-3.0145 0-5.7927.5798-7.8545 1.5616C3.6582 11.5079 2 13.0107 2 15s1.6582 3.4921 3.6455 4.4384C7.7073 20.4202 10.4855 21 13.5 21s5.7927-.5798 7.8546-1.5616C23.3419 18.4921 25 16.9893 25 15s-1.6581-3.4921-3.6454-4.4384C19.2927 9.5798 16.5145 9 13.5 9M10 13.5v3h7v-3z"
      clipRule="evenodd"
      key="3"
    />,
  ],
  'Coins',
  48
);

export const ConnectionsIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m29.1484 6.6819 1.3973.5456c6.1257 2.3923 10.6215 8.0436 11.3505 14.8295l.1603 1.4914-2.9829.3205-.1602-1.4915c-.6066-5.6465-4.351-10.3606-9.459-12.3554l-1.3973-.5457zm-13.8036 4.9743-1.1359.9797C11.0168 15.3888 9 19.458 9 24c0 .9873.0952 1.951.2765 2.8828l.2864 1.4724-2.9448.5729-.2864-1.4724A18.1 18.1 0 0 1 6 24c0-5.4511 2.4249-10.3374 6.2496-13.636l1.1359-.9796zm21.1903 25.3482-1.1622.9483c-3.0997 2.5294-7.061 4.0474-11.3729 4.0474-2.3064 0-4.515-.4345-6.5456-1.2276l-1.3973-.5456 1.0913-2.7945 1.3973.5457c1.6885.6594 3.5272 1.022 5.4543 1.022 3.5957 0 6.8924-1.2633 9.4762-3.3717l1.1622-.9483z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 9c0-3.866 3.134-7 7-7s7 3.134 7 7-3.134 7-7 7-7-3.134-7-7M2 33c0-3.866 3.134-7 7-7s7 3.134 7 7-3.134 7-7 7-7-3.134-7-7m30 0c0-3.866 3.134-7 7-7s7 3.134 7 7-3.134 7-7 7-7-3.134-7-7"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Connections',
  48
);

export const ContactsIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M35 46c3.3137 0 6-2.6863 6-6V8c0-3.3137-2.6863-6-6-6H13C9.6863 2 7 4.6863 7 8v32c0 3.3137 2.6863 6 6 6zm-6-29c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5m6.2169 17.7542.7812-.1735C35.8805 28.6162 30.4422 24 24 24s-11.8804 4.6162-11.998 10.5807l.7811.1735c7.4757 1.6611 14.9581 1.6611 22.4338 0"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M44 40.8739c1.7252-.444 3-2.0101 3-3.8739V11c0-1.8639-1.2748-3.43-3-3.874zm-40 0C2.2748 40.4299 1 38.8638 1 37V11c0-1.8639 1.2748-3.43 3-3.874z"
      key="1"
    />,
  ],
  'Contacts',
  48
);

export const CreditCardLockIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27 37.5c0-1.933 1.567-3.5 3.5-3.5h13c1.933 0 3.5 1.567 3.5 3.5v6c0 1.933-1.567 3.5-3.5 3.5h-13c-1.933 0-3.5-1.567-3.5-3.5z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M37 29c-1.3807 0-2.5 1.1193-2.5 2.5V36h-3v-4.5c0-3.0376 2.4624-5.5 5.5-5.5s5.5 2.4624 5.5 5.5V36h-3v-4.5c0-1.3807-1.1193-2.5-2.5-2.5"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 21v15c0 3.3137 2.6863 6 6 6h16v-4.5c0-2.8928 1.8897-5.3442 4.502-6.1872C28.6016 26.7049 32.3681 23 37 23s8.3984 3.7049 8.498 8.3128H46V21zm6 13.5v-3h9v3z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      d="M40 6c3.3137 0 6 2.6863 6 6v2H2v-2c0-3.3137 2.6863-6 6-6z"
      key="3"
    />,
  ],
  'CreditCardLock',
  48
);

export const CreditCardStackIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 41V26h44v15c0 3.3137-2.6863 6-6 6H8c-3.3137 0-6-2.6863-6-6m6-4.5v3h9v-3z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M40 13c3.3137 0 6 2.6863 6 6v2H2v-2c0-3.3137 2.6863-6 6-6z"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 10c0-1.6569 1.3431-3 3-3h28c1.6569 0 3 1.3431 3 3zm5-7c0-1.1046.8954-2 2-2h20c1.1046 0 2 .8954 2 2v1H12z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'CreditCardStack',
  48
);

export const CreditCardIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 36V21h44v15c0 3.3137-2.6863 6-6 6H8c-3.3137 0-6-2.6863-6-6m6-4.5v3h9v-3z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M40 6c3.3137 0 6 2.6863 6 6v2H2v-2c0-3.3137 2.6863-6 6-6z"
      key="1"
    />,
  ],
  'CreditCard',
  48
);

export const CutleryIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M40 3v28H29V12c0-4.9706 4.0294-9 9-9zm0 39.666C40 44.5073 38.5073 46 36.666 46c-2.016-.0003-3.5709-1.776-3.3047-3.7744L34.458 34H40zM14.5 4h3v15h-3z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M8 4v15c0 2.7614 2.2386 5 5 5h6c2.7614 0 5-2.2386 5-5V4h-3v13H11V4zm11.3831 38.4561c.0897 1.9298-1.4509 3.5438-3.3828 3.5439-1.9321 0-3.4726-1.614-3.3828-3.5439L13.3362 27h5.3281z"
      key="1"
    />,
  ],
  'Cutlery',
  48
);

export const DataIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M11.6464 11.8144C14.8553 10.6818 19.2231 10 24 10s9.1447.6818 12.3536 1.8144c1.6.5647 2.9659 1.2602 3.9511 2.0823C41.2844 14.7142 42 15.7582 42 17s-.7156 2.2858-1.6953 3.1033c-.9852.8221-2.3511 1.5176-3.9511 2.0823C33.1447 23.3182 28.7769 24 24 24s-9.1447-.6818-12.3536-1.8144c-1.6-.5647-2.9659-1.2602-3.9511-2.0823C6.7156 19.2858 6 18.2419 6 17s.7156-2.2858 1.6953-3.1033c.9852-.8221 2.3511-1.5176 3.9511-2.0823"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M6 34.1001v-12c1.0848 1.0091 2.5582 1.8664 4.2737 2.5671 3.5655 1.4561 8.4186 2.3327 13.7263 2.3327s10.1608-.8766 13.7263-2.3327c1.7155-.7007 3.1889-1.558 4.2737-2.5671v12c-1.0848 1.0091-2.5582 1.8664-4.2737 2.5671-3.5655 1.4561-8.4186 2.3327-13.7263 2.3327s-10.1608-.8766-13.7263-2.3327C8.5582 35.9665 7.0848 35.1092 6 34.1001"
      key="1"
    />,
  ],
  'Data',
  48
);

export const DatabaseIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M11.6464 3.8144C14.8553 2.6818 19.2231 2 24 2s9.1447.6818 12.3536 1.8144c1.6.5647 2.9659 1.2602 3.9511 2.0823C41.2844 6.7142 42 7.7581 42 9s-.7156 2.2858-1.6953 3.1033c-.9852.8221-2.3511 1.5176-3.9511 2.0823C33.1447 15.3182 28.7769 16 24 16s-9.1447-.6818-12.3536-1.8144c-1.6-.5647-2.9659-1.2602-3.9511-2.0823C6.7156 11.2858 6 10.2419 6 9s.7156-2.2858 1.6953-3.1033c.9852-.8221 2.3511-1.5176 3.9511-2.0823M6 29.1002v10.2156c0 1.2211.7473 2.225 1.723 2.9929.988.7776 2.355 1.4354 3.9536 1.97C14.8844 45.3512 19.2462 46 24 46s9.1156-.6488 12.3234-1.7213c1.5986-.5346 2.9657-1.1924 3.9537-1.97C41.2527 41.5408 42 40.5369 42 39.3158V29.1002c-1.0848 1.0091-2.5582 1.8664-4.2737 2.567C34.1608 33.1234 29.3077 34 24 34s-10.1608-.8766-13.7263-2.3328C8.5582 30.9666 7.0848 30.1093 6 29.1002"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M6 26.1002v-12c1.0848 1.0091 2.5582 1.8664 4.2737 2.5671C13.8392 18.1234 18.6923 19 24 19s10.1608-.8766 13.7263-2.3327c1.7155-.7007 3.1889-1.558 4.2737-2.5671v12c-1.0848 1.0091-2.5582 1.8664-4.2737 2.5671C34.1608 30.1234 29.3077 31 24 31s-10.1608-.8766-13.7263-2.3327C8.5582 27.9666 7.0848 27.1093 6 26.1002"
      key="1"
    />,
  ],
  'Database',
  48
);

export const DialIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M27 10.2808 26 23h-4l-1-12.7192C13.5974 11.685 8 18.1888 8 26c0 8.8366 7.1634 16 16 16s16-7.1634 16-16c0-7.8112-5.5974-14.315-13-15.7192"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.5 3v4h-3V3zM5 27.5H1v-3h4zm42 0h-4v-3h4zM13.7989 5.3314l2 3.4641-2.598 1.5-2-3.464zM44.6687 15.799l-3.4641 2-1.5-2.598 3.4641-2zM4.8313 13.201l3.4641 2-1.5 2.598-3.4641-2zM36.799 6.8314l-2 3.4641-2.5981-1.5 2-3.464z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Dial',
  48
);

export const DiscountIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M22.1961 2.436c.984-1.0257 2.624-1.0257 3.608 0l4.8268 5.031a.5.5 0 0 0 .3711.1537l6.9706-.1444c1.421-.0294 2.5807 1.1303 2.5512 2.5513l-.1444 6.9705a.5.5 0 0 0 .1538.3712l5.031 4.8268c1.0256.984 1.0256 2.624 0 3.608l-5.031 4.8268a.5.5 0 0 0-.1538.3712l.1444 6.9705c.0295 1.421-1.1302 2.5807-2.5512 2.5513l-6.9706-.1444a.5.5 0 0 0-.3711.1537l-4.8268 5.031c-.984 1.0257-2.624 1.0256-3.608 0l-4.8268-5.031a.5.5 0 0 0-.3712-.1537l-6.9706.1444c-1.421.0294-2.5806-1.1303-2.5512-2.5513l.1444-6.9705a.5.5 0 0 0-.1537-.3712l-5.031-4.8268c-1.0257-.984-1.0257-2.624 0-3.608l5.031-4.8268a.5.5 0 0 0 .1537-.3712l-.1444-6.9705c-.0294-1.421 1.1303-2.5807 2.5513-2.5513l6.9705.1444a.5.5 0 0 0 .3712-.1537zm-4.696 30.1853L32.6214 17.5l-2.1213-2.1213L15.3788 30.5zm4.5-14.1213c0-1.933-1.567-3.5-3.5-3.5s-3.5 1.567-3.5 3.5 1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5m7.5 7.5c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5 1.567-3.5 3.5-3.5"
    clipRule="evenodd"
  />,
  'Discount',
  48
);

export const DocumentSearchIcon = createSvgIcon(
  [
    <path fill="currentColor" d="M19 18.5v3h12v-3z" key="0" />,
    <path
      fill="currentColor"
      d="M37 20c0-4.4183-3.5817-8-8-8s-8 3.5817-8 8 3.5817 8 8 8 8-3.5817 8-8m3 0c0 6.0751-4.9249 11-11 11s-11-4.9249-11-11S22.9249 9 29 9s11 4.9249 11 11"
      key="1"
    />,
    <path
      fill="currentColor"
      d="m40.1006 28.9795-2.1211 2.1211-3.04-3.0401 2.121-2.121z"
      key="2"
    />,
    <path
      fill="currentColor"
      d="M36 2c3.3137 0 6 2.6863 6 6v6.7949C39.9343 9.6405 34.8925 6 29 6c-4.7572 0-8.9593 2.3734-11.4893 6H11v3h4.9199C15.326 16.5529 15 18.2383 15 20c0 .8533.0764 1.6888.2227 2.5H11v3h5.123c1.4571 3.4069 4.2256 6.1189 7.6719 7.5H11v3h25.7676l3.0957 3.0957a5.8 5.8 0 0 0 2.1181 1.3506C41.753 43.5515 39.1635 46 36 46H12c-3.3137 0-6-2.6863-6-6V8c0-3.3137 2.6863-6 6-6z"
      key="3"
    />,
    <path
      fill="currentColor"
      d="m44.1468 31.1508-1.8351-1.8351c-1.1026-1.1026-2.8902-1.1026-3.9928 0s-1.1026 2.8902 0 3.9928l1.835 1.8351 1.8312 1.8311c1.1026 1.1026 2.8902 1.1026 3.9928.0001s1.1026-2.8903 0-3.9929z"
      key="4"
    />,
  ],
  'DocumentSearch',
  48
);

export const DoorOpenIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M31 4h10v40H31zm-3 42.5993V2.1708L7 6.1726V41.797zM20 23v8h3v-5h2v-3z"
    clipRule="evenodd"
  />,
  'DoorOpen',
  48
);

export const DrinkMenuIcon = createSvgIcon(
  [
    <path fill="currentColor" d="M40 8h3v32h-3z" key="0" />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M37 45.0742 7 42.9307V5.0693l30-2.1435zM15.4297 21.9443c-.2353 3.2971 1.9918 6.1657 5.0703 6.8819V33H16v3h12v-3h-4.5v-4.1738c3.0784-.7163 5.3056-3.5848 5.0703-6.8819L27.9307 13H16.0693z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'DrinkMenu',
  48
);

export const EarthLeafIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M2 24C2 11.8497 11.8497 2 24 2c8.6402 0 16.117 4.9808 19.7159 12.2277L40.9973 15.5a19 19 0 0 0-1.9171-3.0596c-4.4466 3.0095-8.5961 2.8857-11.6601.8982-2.7607-1.7908-4.4755-5.0055-4.6474-8.2996-3.2732.2087-6.3211 1.2462-8.9361 2.9049l2.5258 2.4903a7.216 7.216 0 0 1-1.2383 11.2557l-.3843.2405c-2.3172 1.4501-3.1154 4.4472-1.8262 6.8577l.5236.9789a8.5 8.5 0 0 1-.2347 8.4282l-.6093 1.0011c2.1157 1.5906 4.5743 2.7497 7.245 3.3465L19 45.4293C9.2586 43.1654 2 34.4304 2 24"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M45.2619 20.7397c.2536 1.0956.7502 3.6285.7311 6.6991-.0252 4.066-.9628 9.218-4.7874 13.0426-2.931 2.931-7.3132 3.4772-11.0166 1.8244 4.4209-2.307 9.4089-6.3038 10.1134-11.5634a23.494 23.494 0 0 1-10.2908 9.5521C27.0446 41.7084 25.5 42.6276 25.5 46h-3v-1.481c0-2.3916 1.3041-4.5605 3.3466-5.6988-2.9915-4.0125-2.8943-9.5872.6081-13.0896 1.7431-1.7431 3.6876-2.417 5.679-2.7457 1.9822-.3272 4.0014-.3329 5.9857-.6468 1.6584-.2624 2.9974-.9211 3.9256-1.5199.4628-.2985.8184-.5789 1.0544-.7808.5573-.4767 1.0342-1.0397 1.5396-1.5688.2135.7553.4458 1.5061.6229 2.2711"
      key="1"
    />,
  ],
  'EarthLeaf',
  48
);

export const EnvelopeContentIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m43.0001 18.3235-4.8053-3.0579 1.6106-2.531 6.1947 3.9421V19.5h-3zM5 18.3235l4.8053-3.0579-1.6106-2.531L2 16.6767V19.5h3z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m24 30.0334 20.5039-11.7165L46 18v20c0 3.3137-2.6863 6-6 6H8c-3.3137 0-6-2.6863-6-6V18h1z"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M8 4v16.8905l3 1.7143V7h26v15.6048l3-1.7142V4z"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25 14H15v-3h10zm8 0h-5v-3h5zm0 6H15v-3h18z"
      clipRule="evenodd"
      key="3"
    />,
  ],
  'EnvelopeContent',
  48
);

export const ExhibitionIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M22.5 34v-1h3v1c0 .9606.6196 2.0503 2.083 2.9746 1.4444.9123 3.5327 1.5254 5.917 1.5254s4.4726-.6131 5.917-1.5254C40.8804 36.0503 41.5 34.9606 41.5 34v-1h2v1c0 2.353-.5068 4.2635-2.4814 5.5107C39.0247 40.77 36.3624 41.5 33.5 41.5s-5.5247-.73-7.5186-1.9893C24.0068 38.2635 22.5 36.353 22.5 34"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M4.5 34v-1h2v1c0 .9606.6196 2.0503 2.083 2.9746 1.4444.9123 3.5327 1.5254 5.917 1.5254s4.4726-.6131 5.917-1.5254C21.8804 36.0503 22.5 34.9606 22.5 34v-1h3v1c0 2.353-1.5068 4.2635-3.4814 5.5107C20.0247 40.77 17.3624 41.5 14.5 41.5s-5.5247-.73-7.5185-1.9893C5.0068 38.2635 4.5 36.353 4.5 34"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M22.5 33h3v11h-3zM41 33h3v11h-3zM4 33h3v11H4z"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M44 28c0 .5523-.4477 1-1 1H5c-.5523 0-1-.4477-1-1V5c0-.5523.4477-1 1-1h38c.5523 0 1 .4477 1 1z"
      clipRule="evenodd"
      key="3"
    />,
  ],
  'Exhibition',
  48
);

export const ExportToApplicationIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M40 6c3.3137 0 6 2.6863 6 6v24c0 3.3137-2.6863 6-6 6H29.2441v-3H40c1.6568 0 3-1.3431 3-3V19H5v17c0 1.6569 1.3431 3 3 3h9.7559v3H8c-3.3137 0-6-2.6863-6-6V12c0-3.3137 2.6863-6 6-6zM8.5 10.5c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2m6 0c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.2737 46.1213v-21h-3v21z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 33.7738 23.7738 23l10.7763 10.7763-2.1213 2.1214-8.655-8.6551-8.6525 8.6525z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'ExportToApplication',
  48
);

export const FaceRobotIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.5 41v-9h3v9zm7.5-.5v-8h3v8zm-15 0v-8h3v8zM25.5 1v7h-3V1zM47 19v10h-2V19zM1 19v10h2V19z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M40 6c3.3137 0 6 2.6863 6 6v24c0 3.3137-2.6863 6-6 6H8c-3.3137 0-6-2.6863-6-6V12c0-3.3137 2.6863-6 6-6zM20 22c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5m13 5c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5m-22 6v6h26v-6z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'FaceRobot',
  48
);

export const FileLinkIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M41.778 28.2218c-2.7337-2.7336-7.1658-2.7336-9.8995 0l-1.7677 1.7678 2.1213 2.1213 1.7677-1.7677c1.5621-1.5621 4.0948-1.5621 5.6569 0s1.5621 4.0947 0 5.6568l-1.7678 1.7678 2.1214 2.1213 1.7677-1.7678c2.7337-2.7336 2.7337-7.1658 0-9.8995M26.2216 43.778c-2.7336-2.7337-2.7336-7.1658 0-9.8995l1.7678-1.7677 2.1213 2.1213-1.7678 1.7677c-1.5621 1.5621-1.5621 4.0948 0 5.6569s4.0948 1.5621 5.6569 0l1.7678-1.7678 2.1213 2.1213-1.7678 1.7678c-2.7337 2.7337-7.1658 2.7337-9.8995 0"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m37.8895 34.2325-5.6569 5.6569-2.1213-2.1213 5.6569-5.6569z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.2426 2a4 4 0 0 0-2.8284 1.1716L7.1716 13.4142A4 4 0 0 0 6 16.2422V40c0 3.3137 2.6863 6 6 6h12.2024a9 9 0 0 1-.102-.1006c-3.9052-3.9052-3.9052-10.2369 0-14.1421l5.6569-5.6568C33.0783 22.7795 38.154 22.2827 42 24.61V7.9991C42 4.6851 39.3135 2 36 2zM20 16V5L9 16z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'FileLink',
  48
);

export const FindReplaceIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M46 41c0 2.7614-2.2386 5-5 5H25c-2.7614 0-5-2.2386-5-5V25c0-2.7614 2.2386-5 5-5h16c2.7614 0 5 2.2386 5 5z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M36 2h-4v3h4c1.3807 0 2.5 1.1193 2.5 2.5v4.3786L35.3334 8.712l-2.1214 2.1213L40 17.6213l6.788-6.788-2.1213-2.1213L41.5 11.8787V7.5C41.5 4.4624 39.0376 2 36 2M9.5 36.1212l3.1669 3.1668 2.1213-2.1214-6.788-6.7879-6.788 6.788 2.1213 2.1213L6.5 36.1214V40.5c0 3.0376 2.4624 5.5 5.5 5.5h4.5v-3H12c-1.3807 0-2.5-1.1193-2.5-2.5zM16.5 2C8.4919 2 2 8.4919 2 16.5S8.4919 31 16.5 31q.251 0 .5-.0085V25c0-4.4183 3.5817-8 8-8h5.9915Q31 16.751 31 16.5C31 8.4919 24.5081 2 16.5 2"
      key="1"
    />,
  ],
  'FindReplace',
  48
);

export const FingerprintIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="m7.5353 12.7643-.5617.8343c-2.9363 4.3809-4.1898 9.8824-3.0654 15.459l.189.9872-2.9404.5927-.189-.9872c-1.289-6.3922.1512-12.7035 3.5146-17.7216l.5607-.8343zM19.3516 1.9806C24.7653.889 30.1232 1.7545 34.6855 4.09l.8847.4657-1.3672 2.6709-.8846-.4657c-3.9801-2.0375-8.6489-2.7926-13.3741-1.8399-3.8993.7863-7.3115 2.6293-10.003 5.1699l-.7347.6701L7.148 8.5794l.7348-.67c3.0877-2.9147 7.0035-5.0285 11.4688-5.9288m6.1193 22.7288c1.563 7.7519-.465 15.3958-4.9326 21.205l-.6127.8007-2.378-1.8291.6118-.8006c3.9613-5.1508 5.7543-11.9169 4.3701-18.7822l-.1896-.9834 2.9404-.5927z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M22.6088 18.1348c1.8333-.3698 3.6577-.08 5.166.8886 1.5113.9706 2.591 2.5483 3.0732 4.544 1.6177 6.603.275 14.6708-3.0293 21.0967l-.4706.8908-2.668-1.3721.4707-.8908c3.0381-5.9085 4.1987-13.2379 2.7822-19.0147l-.001-.0058c-.3239-1.3403-.9951-2.2206-1.7783-2.7237-.7863-.5049-1.8015-.7043-2.9512-.4726-2.1766.4389-3.5649 2.4232-3.1191 4.7334 1.3244 6.8635-.7571 13.4899-5.1338 18.2109l-.6813.732-2.2002-2.04.6823-.731c3.7397-4.034 5.5274-9.697 4.3877-15.6035-.7582-3.9291 1.6814-7.478 5.4707-8.2422"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M14.962 28.9003c.3147 4.7212-1.5918 9.197-4.9238 12.2539l-.7303.6781-2.0284-2.21.7313-.679c2.6829-2.4615 4.2094-6.0598 3.9571-9.8438l-.0733-1.0001 2.9932-.2002zm6.5613-16.1502c6.7692-1.3649 13.3625 3.0158 14.7276 9.7851.2672 1.4393.4937 2.8816.6142 4.3418l.0964.9935-2.9893.2461-.0973-.9925c-.1133-1.3726-.3122-2.7361-.585-4.0859-1.0777-5.0938-6.0591-8.379-11.1738-7.3477-4.2041.8479-7.1995 4.351-7.585 8.4141l-.0912 1.0007-2.9863-.2832.0912-1.0007c.5069-5.3432 4.4422-9.9549 9.9785-11.0713m15.4453 18.339-.0401.9981c-.2324 3.9844-1.1052 7.8481-2.5332 11.4639l-.3841.9206-2.79-1.1026.3831-.9196c1.3132-3.325 2.1155-6.8756 2.3291-10.5361l.0401-.9991z"
      key="2"
    />,
    <path
      fill="currentColor"
      d="m20.37 10.4207-.9542.3038c-7.031 2.2438-11.4536 9.3624-10.2129 16.7559l.0996.4893c.7287 3.615-.6432 7.1625-3.2656 9.3847l-.751.665-1.9395-2.2881.751-.6649c1.8714-1.5858 2.7386-4.1035 2.256-6.502-1.8315-9.083 3.5228-17.9441 12.1503-20.6973l.9541-.3039zm3.6288-3.4137c8.0276-.006 15.2485 5.3855 17.375 13.3291l.041.0039.2236 1.1103c1.3093 6.493 1.07 12.942-.4619 18.9629l-.2483.9708-2.9072-.7393.2473-.9717c1.466-5.7621 1.592-11.8037.4268-17.6299-1.4358-7.1212-7.698-12.0413-14.6943-12.0361l-.9971.0009-.002-3z"
      key="3"
    />,
    <path
      fill="currentColor"
      d="M38.9541 6.895c5.4812 4.5223 8.6778 11.4868 8.542 18.584l-.0293 1-2.999-.0576.0283-1c.1183-6.1827-2.6778-12.2729-7.4522-16.212l-.7619-.6435 1.9091-2.3135z"
      key="4"
    />,
  ],
  'Fingerprint',
  48
);

export const GaugeIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M9.5404 11.4188C13.0548 8.3515 17.5533 6.3834 22.5 6.0503V12.5h3V6.0503c4.9467.333 9.4453 2.3013 12.9597 5.3687l-4.5602 4.5602 2.1213 2.1213 4.5602-4.5602c3.0674 3.5144 5.0356 8.0129 5.3686 12.9597H39.5v3h6.4496C45.632 34.2176 43.8271 38.5277 41 41.9652H7C4.1728 38.5277 2.368 34.2176 2.0503 29.5H8.5v-3H2.0503c.333-4.9468 2.3013-9.4454 5.3687-12.9599l11.778 11.778c-.4439.7934-.697 1.7081-.697 2.6819 0 3.0376 2.4624 5.5 5.5 5.5s5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5c-.9737 0-1.8882.253-2.6816.6969z"
    clipRule="evenodd"
  />,
  'Gauge',
  48
);

export const GiftHandIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M36.5273 2.0206c3.7662-.3319 6.5149 3.4887 5.003 6.954l-.71 1.6261-2.75-1.1993.71-1.627c.6011-1.378-.4916-2.8972-1.9893-2.7656a1.9814 1.9814 0 0 0-1.7861 1.6836l-.5205 3.5264-2.9688-.4375.5215-3.5264c.3368-2.2804 2.194-4.032 4.4902-4.2343"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M29.4727 2.0206c-3.7662-.3319-6.5149 3.4887-5.003 6.954l.71 1.6261 2.75-1.1993-.71-1.627c-.6011-1.378.4916-2.8972 1.9893-2.7656a1.9814 1.9814 0 0 1 1.7861 1.6836l.5205 3.5264 2.9688-.4375-.5215-3.5264c-.3368-2.2804-2.194-4.032-4.4902-4.2343"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M46 9v4H20V9zm-.2588 28.7064-16.6705 6.7244a8.79 8.79 0 0 1-4.7524.4145L11 42.3122V31.1731l1.1727-1.0178C13.7763 28.7636 15.8089 28 17.9095 28c2.0777 0 4.0896.7471 5.6857 2.1113l.9048.7733h3.375c2.4838 0 4.4976 2.0639 4.5 4.6109v.5815h-9.5625v.5769l9.2199.9456c1.1519.1181 2.2032-.6794 2.4303-1.8437l.1623-.8327 10.3445-1.0381C46.0722 33.8221 47 34.7223 47 35.8549c0 .8268-.5024 1.5657-1.2588 1.8515M8 28v17H4V28zm23.5-2H22V16h9.5zM44 26h-9.5V16H44z"
      key="2"
    />,
  ],
  'GiftHand',
  48
);

export const GiftIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.0001 8.5762a17.8 17.8 0 0 0-.8223-1.3968C21.5919 4.7527 18.8623 2 14.6667 2 11.3126 2 8.5 4.6351 8.5 8s2.8126 6 6.1667 6h18.6668c3.3541 0 6.1667-2.6351 6.1667-6s-2.8126-6-6.1667-6c-4.1956 0-6.9252 2.7527-8.5111 5.1794a17.8 17.8 0 0 0-.8223 1.3968M11.5 8c0-1.6061 1.3657-3 3.1667-3 2.7079 0 4.6449 1.7473 5.9998 3.8206.4938.7556.8837 1.5175 1.1788 2.1794h-7.1786C12.8657 11 11.5 9.6061 11.5 8m21.8335 3h-7.1787c.2952-.6619.685-1.4238 1.1789-2.1794C28.6885 6.7473 30.6255 5 33.3335 5c1.801 0 3.1667 1.3939 3.1667 3s-1.3657 3-3.1667 3M27 24h15v14c0 3.3137-2.6863 6-6 6h-9zm-6 0H6v14c0 3.3137 2.6863 6 6 6h9z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 11h44v10H2z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Gift',
  48
);

export const GiftcardIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M15.251 24a19 19 0 0 0-.5059.5645c-1.1458 1.3336-2.0498 2.7569-3.0556 4.541-.4066.7215-.1521 1.6361.5693 2.0429s1.6361.1511 2.043-.5703c.9654-1.7124 1.7595-2.941 2.7197-4.0586.5624-.6545 1.1973-1.286 1.9785-1.9619V42H8c-3.3137 0-6-2.6863-6-6V24zM46 36c0 3.3137-2.6863 6-6 6H22V24.3447c.8971.7568 1.6057 1.4523 2.2266 2.1748.9602 1.1176 1.7542 2.3462 2.7197 4.0586.4068.7215 1.3214.977 2.043.5703.7214-.4067.9766-1.3214.5703-2.0429-1.0059-1.7841-1.9108-3.2074-3.0567-4.541A19 19 0 0 0 25.9961 24H46zM19 15.0049a13.5 13.5 0 0 0-.6553-.4863c-1.2007-.8342-2.6386-1.5185-4.208-1.5186C11.1688 13 9 15.6003 9 18.5c0 .8829.202 1.7376.5654 2.5H2v-9c0-3.3137 2.6863-6 6-6h11zM26.8633 16C27.9117 16 29 16.9817 29 18.5S27.9117 21 26.8633 21c-.7031-.0001-1.5381-.3159-2.4961-.9814-.6051-.4205-1.2057-.9438-1.7901-1.5186.5844-.5748 1.185-1.0981 1.7901-1.5186.958-.6655 1.793-.9813 2.4961-.9814M40 6c3.3137 0 6 2.6863 6 6v9H31.4346A5.82 5.82 0 0 0 32 18.5c0-2.8997-2.1688-5.5-5.1367-5.5-1.5694.0001-3.0073.6844-4.208 1.5186a13.5 13.5 0 0 0-.6553.4863V6zM14.1367 16c.7031.0001 1.5381.3159 2.4961.9814.605.4203 1.2049.944 1.7891 1.5186-.5842.5746-1.1841 1.0983-1.7891 1.5186-.958.6655-1.793.9813-2.4961.9814C13.0883 21 12 20.0183 12 18.5s1.0883-2.5 2.1367-2.5"
  />,
  'Giftcard',
  48
);

export const GiftcardStackIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 7h34v3H7zm5-6h24v3H12z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M15.251 30a19 19 0 0 0-.5059.5645c-1.1458 1.3336-2.0498 2.7569-3.0556 4.541-.4066.7215-.1521 1.6361.5693 2.0429s1.6361.1511 2.043-.5703c.9654-1.7124 1.7595-2.941 2.7197-4.0586.5624-.6545 1.1973-1.286 1.9785-1.9619V47H8c-3.3137 0-6-2.6863-6-6V30zM46 41c0 3.3137-2.6863 6-6 6H22V30.3447c.8971.7568 1.6057 1.4523 2.2266 2.1748.9602 1.1176 1.7542 2.3462 2.7197 4.0586.4068.7215 1.3214.977 2.043.5703.7214-.4067.9766-1.3214.5703-2.0429-1.0059-1.7841-1.9108-3.2074-3.0567-4.541A19 19 0 0 0 25.9961 30H46zM19 21.0049a13.5 13.5 0 0 0-.6553-.4863c-1.2007-.8342-2.6386-1.5185-4.208-1.5186C11.1688 19 9 21.6003 9 24.5c0 .8829.202 1.7376.5654 2.5H2v-8c0-3.3137 2.6863-6 6-6h11zM26.8633 22C27.9117 22 29 22.9817 29 24.5S27.9117 27 26.8633 27c-.7031-.0001-1.5381-.3159-2.4961-.9814-.6051-.4205-1.2057-.9438-1.7901-1.5186.5844-.5748 1.185-1.0981 1.7901-1.5186.958-.6655 1.793-.9813 2.4961-.9814M40 13c3.3137 0 6 2.6863 6 6v8H31.4346A5.82 5.82 0 0 0 32 24.5c0-2.8997-2.1688-5.5-5.1367-5.5-1.5694.0001-3.0073.6844-4.208 1.5186a13.5 13.5 0 0 0-.6553.4863V13zm-25.8633 9c.7031.0001 1.5381.3159 2.4961.9814.605.4203 1.2049.944 1.7891 1.5186-.5842.5746-1.1841 1.0983-1.7891 1.5186-.958.6655-1.793.9813-2.4961.9814C13.0883 27 12 26.0183 12 24.5s1.0883-2.5 2.1367-2.5"
      key="1"
    />,
  ],
  'GiftcardStack',
  48
);

export const GlobeIcon = createSvgIcon(
  [
    <path fill="currentColor" d="M21.5 37.5h3V44h-3z" key="0" />,
    <path
      fill="currentColor"
      d="M35.7276 31.728c7.0294-7.0294 7.0294-18.4264 0-25.4558l-1.0607-1.0606 2.9838-2.9838L39.772 4.349l-.9004.9005c7.1621 8.2498 6.8217 20.7554-1.0227 28.5998-7.8444 7.8441-20.3494 8.1839-28.5992 1.022l-.8977.8976-2.1213-2.1213 2.9804-2.9803 1.0606 1.0606c7.0294 7.0294 18.4264 7.0292 25.4559 0M31 42v3H15v-3z"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 4c8.2843 0 15 6.7157 15 15s-6.7157 15-15 15S8 27.2843 8 19 14.7157 4 23 4m-.9033 3.0332a11.93 11.93 0 0 0-4.3955 1.1992l1.1123 1.1543c.924 1.1005 1.3334 2.5913 1.1386 4.0479-.2067 1.5452-1.0634 2.7712-2.3232 3.6416-1.9967 1.3772-1.7068 3.7784-.8242 5.6845.7283 1.8069.5735 3.9069-.4238 5.5645l-.2266.3477-.085.1201c1.7079 1.2108 3.7442 1.9877 5.9512 2.166a4.24 4.24 0 0 1-.0127-.6651c.0877-1.4152.8821-2.8395 2.584-4.164 1.0497-.8169 1.464-1.5959 1.624-2.2969.169-.7409.0818-1.5003-.0654-2.3516-.0692-.3997-.1596-.8606-.2119-1.2832-.0534-.4308-.0809-.9087-.002-1.3847.0819-.4936.2787-.982.6573-1.416.3711-.4256.8703-.7449 1.4765-.9844 1.1328-.4475 2.1915-.5592 3.1807-.3789.9825.1791 1.8268.6334 2.5566 1.209.4153.3275.8057.706 1.1748 1.1113-.1272-2.4006-.9611-4.6128-2.2959-6.4356-2.7778 1.5094-5.3813 1.3466-7.375.0831-1.7335-1.0987-2.8865-2.968-3.2148-4.9688"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'Globe',
  48
);

export const GridLayout1Icon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M21 44c.5523 0 1-.4477 1-1V32c0-.5523-.4477-1-1-1H5c-.5523 0-1 .4477-1 1v11c0 .5523.4477 1 1 1zM43 4c.5523 0 1 .4477 1 1v11c0 .5523-.4477 1-1 1H27c-.5523 0-1-.4477-1-1V5c0-.5523.4477-1 1-1zM21 27c.5523 0 1-.4477 1-1V5c0-.5523-.4477-1-1-1H5c-.5523 0-1 .4477-1 1v21c0 .5523.4477 1 1 1zm22-6c.5523 0 1 .4477 1 1v21c0 .5523-.4477 1-1 1H27c-.5523 0-1-.4477-1-1V22c0-.5523.4477-1 1-1z"
    clipRule="evenodd"
  />,
  'GridLayout1',
  48
);

export const GridPlusIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M33 4h11v11H33zM18.5 4h11v11h-11zm0 14.5h11v11h-11zM4 4h11v11H4zm0 29h11v11H4zm0-14.5h11v11H4zM25.5 33v11h-3V33zM40 33v11h-3V33zm0-14.5v11h-3v-11z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M29.5 40h-11v-3h11zM44 40H33v-3h11zm0-14.5H33v-3h11z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'GridPlus',
  48
);

export const GridIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M34 34h10v10H34zm-15 0h10v10H19zM4 34h10v10H4zm30-15h10v10H34zm-15 0h10v10H19zM4 19h10v10H4zM34 4h10v10H34zM19 4h10v10H19zM4 4h10v10H4z"
    clipRule="evenodd"
  />,
  'Grid',
  48
);

export const HallViewIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 6c-3.3137 0-6 2.6863-6 6v24c0 3.3137 2.6863 6 6 6h32c3.3137 0 6-2.6863 6-6V12c0-3.3137-2.6863-6-6-6zm-3 6c0-1.6569 1.3431-3 3-3h21v30H8c-1.6569 0-3-1.3431-3-3zm28 10.5h9v3h-9zm9-7h-9v3h9zm-9 14h9v3h-9z"
      clipRule="evenodd"
      key="0"
    />,
    <rect
      width="3"
      height="3"
      x="8"
      y="12"
      fill="currentColor"
      rx="1.5"
      key="1"
    />,
    <rect
      width="3"
      height="3"
      x="5"
      y="18"
      fill="currentColor"
      rx="1.5"
      key="2"
    />,
    <rect
      width="3"
      height="3"
      x="5"
      y="30"
      fill="currentColor"
      rx="1.5"
      key="3"
    />,
    <rect
      width="3"
      height="3"
      x="8"
      y="24"
      fill="currentColor"
      rx="1.5"
      key="4"
    />,
    <rect
      width="3"
      height="3"
      x="8"
      y="36"
      fill="currentColor"
      rx="1.5"
      key="5"
    />,
    <rect
      width="3"
      height="3"
      x="14"
      y="12"
      fill="currentColor"
      rx="1.5"
      key="6"
    />,
    <rect
      width="3"
      height="3"
      x="11"
      y="18"
      fill="currentColor"
      rx="1.5"
      key="7"
    />,
    <rect
      width="3"
      height="3"
      x="11"
      y="30"
      fill="currentColor"
      rx="1.5"
      key="8"
    />,
    <rect
      width="3"
      height="3"
      x="14"
      y="24"
      fill="currentColor"
      rx="1.5"
      key="9"
    />,
    <rect
      width="3"
      height="3"
      x="14"
      y="36"
      fill="currentColor"
      rx="1.5"
      key="10"
    />,
    <rect
      width="3"
      height="3"
      x="20"
      y="12"
      fill="currentColor"
      rx="1.5"
      key="11"
    />,
    <rect
      width="3"
      height="3"
      x="17"
      y="18"
      fill="currentColor"
      rx="1.5"
      key="12"
    />,
    <rect
      width="3"
      height="3"
      x="17"
      y="30"
      fill="currentColor"
      rx="1.5"
      key="13"
    />,
    <rect
      width="3"
      height="3"
      x="20"
      y="24"
      fill="currentColor"
      rx="1.5"
      key="14"
    />,
    <rect
      width="3"
      height="3"
      x="20"
      y="36"
      fill="currentColor"
      rx="1.5"
      key="15"
    />,
    <rect
      width="3"
      height="3"
      x="26"
      y="12"
      fill="currentColor"
      rx="1.5"
      key="16"
    />,
    <rect
      width="3"
      height="3"
      x="23"
      y="18"
      fill="currentColor"
      rx="1.5"
      key="17"
    />,
    <rect
      width="3"
      height="3"
      x="23"
      y="30"
      fill="currentColor"
      rx="1.5"
      key="18"
    />,
    <rect
      width="3"
      height="3"
      x="26"
      y="24"
      fill="currentColor"
      rx="1.5"
      key="19"
    />,
    <rect
      width="3"
      height="3"
      x="26"
      y="36"
      fill="currentColor"
      rx="1.5"
      key="20"
    />,
  ],
  'HallView',
  48
);

export const HandHeartIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="m44.7412 35.7064-16.6705 6.7244a8.79 8.79 0 0 1-4.7524.4145L10 40.3122V29.1731l1.1727-1.0178C12.7763 26.7636 14.8089 26 16.9095 26c2.0777 0 4.0896.7471 5.6857 2.1113l.9048.7733h3.375c2.4838 0 4.4976 2.0639 4.5 4.6109v.5815h-9.5625v.5769l9.2199.9456c1.1519.1181 2.2032-.6794 2.4303-1.8437l.1623-.8327 10.3445-1.0381C45.0722 31.8221 46 32.7223 46 33.8549c0 .8268-.5024 1.5657-1.2588 1.8515M7 26v17H3V26zm24.5-2c2.6616-1.2353 12-8.0813 12-14.3566C43.5 5.9746 40.6056 3 37.0392 3c-2.352 0-4.1088 1.517-5.5392 3.2192C30.072 4.5145 28.3128 3 25.9608 3 22.392 3 19.5 5.9746 19.5 9.6434c0 6.2753 9.3384 13.1213 12 14.3566"
  />,
  'HandHeart',
  48
);

export const HandHoldingCardIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M25 43h18v4H25zm11-22-2 8v-7c-2.3416 0-4.4979 1.436-4.5 3.9966V29l-.6702.8043a7.894 7.894 0 0 0 .0381 10.1533h10.6899l1.497-10.1362a6 6 0 0 0-.1886-2.6007l-2.5738-14.5324c-.1691-.9551-.9993-1.6512-1.9693-1.6512H36z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.818 39H18V3h9c3.3121 0 5.9974 2.6837 6 5.9952V19.058c-1.4303.167-2.8516.6988-4.0242 1.6558-1.5068 1.2298-2.4739 3.0709-2.4758 5.2802v1.9199A10.895 10.895 0 0 0 24.818 39M25 8h3v6h-3z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M13 3v36c-3.3137 0-6-2.6863-6-6V9c0-3.3137 2.6863-6 6-6"
      key="2"
    />,
  ],
  'HandHoldingCard',
  48
);

export const HandHoldingCoinsIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28 20c0-4.4183 3.5817-8 8-8s8 3.5817 8 8-3.5817 8-8 8-8-3.5817-8-8m9.5-3h-3v6h3zM10 10c0-4.4183 3.5817-8 8-8s8 3.5817 8 8-3.5817 8-8 8-8-3.5817-8-8m9.5-3h-3v6h3z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M41.8811 36.4122 27.0628 42.24a8 8 0 0 1-4.2243.3592L11 40.4039V30.75l1.0424-.8821a7.8946 7.8946 0 0 1 10.1533-.0381L23 30.5h3c2.2078 0 3.9979 1.7887 4 3.9961V35h-8.5v.5l8.1955.8195c1.0239.1024 1.9584-.5888 2.1602-1.5978L32 34l9.1951-.8997C42.1753 33.0458 43 33.826 43 34.8076a1.71 1.71 0 0 1-1.1189 1.6046M8 28v15H4V28z"
      key="1"
    />,
  ],
  'HandHoldingCoins',
  48
);

export const HistoryIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M36 2c3.3137 0 6 2.6863 6 6v18.5566a12.07 12.07 0 0 0-3-.6367V8c0-1.6569-1.3431-3-3-3H12c-1.6569 0-3 1.3431-3 3v30.5c0 1.3807 1.1193 2.5 2.5 2.5s2.5-1.1193 2.5-2.5V32h13.4736c-1.0119 1.7708-1.5937 3.8193-1.5937 6.0049 0 2.1815.5795 4.2266 1.5879 5.9951H11.5C8.4624 44 6 41.5376 6 38.5V8c0-3.3137 2.6863-6 6-6z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15 24h18v-3H15zm0-7h9v-3h-9zm12 0h6v-3h-6zm11 31c5.2467 0 9.5-4.2533 9.5-9.5S43.2467 29 38 29s-9.5 4.2533-9.5 9.5S32.7533 48 38 48m1.5-14.5h-3v5.7719l5.3487 3.8206 1.7438-2.4412L39.5 37.7281z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'History',
  48
);

export const HoldIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M3.5 14c0 2.587.8562 4.9783 2.2998 6.9004l.9014 1.2002 2.3984-1.8018-.9014-1.1992C7.1312 17.6791 6.5 15.9153 6.5 14c0-4.6944 3.8056-8.5 8.5-8.5s8.5 3.8056 8.5 8.5c0 1.7957-.5552 3.4579-1.5039 4.8291l-.1943.2705-.9014 1.1992 2.3984 1.8018.9014-1.2002.2637-.3652C25.7476 18.6791 26.5 16.4255 26.5 14c0-6.3513-5.1487-11.5-11.5-11.5S3.5 7.6487 3.5 14"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M36 2.5c5.2467 0 9.5 4.2533 9.5 9.5s-4.2533 9.5-9.5 9.5c-2.8468 0-5.3995-1.2537-7.1406-3.2373A14.5 14.5 0 0 0 29.5 14c0-2.4602-.6132-4.777-1.6943-6.8066C29.4563 4.3854 32.5074 2.5 36 2.5m-1.5 10.2715 5.3486 3.8213 1.7442-2.4414L37.5 11.2285V7h-3z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M12.5 13v21h-1l-1-7.8952c-1.7293.4674-3 2.0269-3 3.8789v3.7811c0 1.3926.6034 2.7352 1.3843 3.8202l3.5704 4.3946C13.1034 43 13.5 43.9556 13.5 45l4.0565.5392a40 40 0 0 0 10.7513-.0285L32 45l1.7848-11.5646c.4661-3.02-1.4119-5.9079-4.3615-6.7066L17.5 23.5V13c0-1.3807-1.1193-2.5-2.5-2.5s-2.5 1.1193-2.5 2.5"
      key="2"
    />,
  ],
  'Hold',
  48
);

export const HouseSearchIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m23.9999 2.0972 22.6054 17.6432-1.8458 2.3649L23.9999 5.9028 3.2403 22.1053l-1.8458-2.3649z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M22.5 23.0001c-3.0376 0-5.5 2.4625-5.5 5.5s2.4624 5.5 5.5 5.5 5.5-2.4624 5.5-5.5-2.4624-5.5-5.5-5.5"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 37.5001v-14.329L23.9999 9.9028 41 23.1712v14.3289c0 3.5898-2.9101 6.5-6.5 6.5h-21c-3.5898 0-6.5-2.9102-6.5-6.5m7-9c0-4.6944 3.8056-8.5 8.5-8.5s8.5 3.8056 8.5 8.5c0 1.8054-.5629 3.4794-1.5227 4.856l4.644 4.644L32 40.1214l-4.644-4.644c-1.3766.9598-3.0506 1.5227-4.856 1.5227-4.6944 0-8.5-3.8056-8.5-8.5"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'HouseSearch',
  48
);

export const IdBadgeIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M27 10V5c0-1.6568-1.3431-3-3-3s-3 1.3432-3 3v5z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28 13c1.1046 0 2-.8954 2-2V6h10c3.3137 0 6 2.6863 6 6v24c0 3.3137-2.6863 6-6 6H8c-3.3137 0-6-2.6863-6-6V12c0-3.3137 2.6863-6 6-6h10v5c0 1.1046.8954 2 2 2zm-5.5 6.5c0 2.4853-2.0147 4.5-4.5 4.5s-4.5-2.0147-4.5-4.5S15.5147 15 18 15s4.5 2.0147 4.5 4.5M9 35c0-4.9706 4.0294-9 9-9s9 4.0294 9 9zm21-14.5h9v3h-9zm2 7v3h7v-3z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'IdBadge',
  48
);

export const InputPasswordIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 15.5C2 11.9101 4.9101 9 8.5 9h31c3.5899 0 6.5 2.9101 6.5 6.5v6h-3v-6c0-1.933-1.567-3.5-3.5-3.5h-31C6.567 12 5 13.567 5 15.5v13C5 30.433 6.567 32 8.5 32H24v3H8.5C4.9102 35 2 32.0899 2 28.5z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 19.75c1.2426 0 2.25 1.0074 2.25 2.25s-1.0074 2.25-2.25 2.25-2.25-1.0074-2.25-2.25 1.0073-2.25 2.25-2.25m-10.75 0c1.2426 0 2.25 1.0074 2.25 2.25s-1.0074 2.25-2.25 2.25S11 23.2426 11 22s1.0073-2.25 2.25-2.25M27 32.5c0-1.933 1.567-3.5 3.5-3.5h13c1.933 0 3.5 1.567 3.5 3.5v6c0 1.933-1.567 3.5-3.5 3.5h-13c-1.933 0-3.5-1.567-3.5-3.5z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M37 24c-1.3807 0-2.5 1.1193-2.5 2.5v5h-3v-5c0-3.0376 2.4624-5.5 5.5-5.5s5.5 2.4624 5.5 5.5v5h-3v-5c0-1.3807-1.1193-2.5-2.5-2.5"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'InputPassword',
  48
);

export const InputSearchIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M34.5 24c-4.6944 0-8.5 3.8056-8.5 8.5s3.8056 8.5 8.5 8.5c1.8054 0 3.4794-.5629 4.856-1.5227L44 44.1213 46.1213 42l-4.644-4.644C42.4371 35.9794 43 34.3054 43 32.5c0-4.6944-3.8056-8.5-8.5-8.5M29 32.5c0-3.0376 2.4624-5.5 5.5-5.5s5.5 2.4624 5.5 5.5-2.4624 5.5-5.5 5.5-5.5-2.4624-5.5-5.5"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 15.5C2 11.9101 4.9101 9 8.5 9h31c3.5899 0 6.5 2.9101 6.5 6.5V25h-3v-9.5c0-1.933-1.567-3.5-3.5-3.5h-31C6.567 12 5 13.567 5 15.5v13C5 30.433 6.567 32 8.5 32H23v3H8.5C4.9102 35 2 32.0899 2 28.5z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 19.75c1.2426 0 2.25 1.0074 2.25 2.25s-1.0074 2.25-2.25 2.25-2.25-1.0074-2.25-2.25 1.0073-2.25 2.25-2.25m-10.75 0c1.2426 0 2.25 1.0074 2.25 2.25s-1.0074 2.25-2.25 2.25S11 23.2426 11 22s1.0073-2.25 2.25-2.25"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'InputSearch',
  48
);

export const InvoiceIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M41 2H7v44l5-3.75 4 3 4-3 4 3 4-3 4 3 4-3L41 46zM24 8c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7m-9 21v-3h10v3zm18 0h-5v-3h5zm-12 6v-3h-6v3z"
    clipRule="evenodd"
  />,
  'Invoice',
  48
);

export const KeyHandoffIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M35.7891 5C40.8759 5 45 9.0294 45 14s-4.1241 9-9.2109 9c-3.9524-.0002-7.3231-2.433-8.6299-5.8496h-8.0274l-2.7636 2.6992-2.7627-2.6992H9.9209L9 10.8496h18.1592C28.466 7.433 31.8367 5.0002 35.7891 5M38 11c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3-1.3431-3-3-3"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m45.7412 37.7064-16.6705 6.7244a8.79 8.79 0 0 1-4.7524.4145L11 42.3122V31.1731l1.1727-1.0178C13.7763 28.7636 15.8089 28 17.9095 28c2.0777 0 4.0896.7471 5.6857 2.1113l.9048.7733h3.375c2.4838 0 4.4976 2.0639 4.5 4.6109v.5815h-9.5625v.5769l9.2199.9456c1.1519.1181 2.2032-.6794 2.4303-1.8437l.1623-.8327 10.3445-1.0381C46.0722 33.8221 47 34.7223 47 35.8549c0 .8268-.5024 1.5657-1.2588 1.8515M8 28v17H4V28z"
      key="1"
    />,
  ],
  'KeyHandoff',
  48
);

export const KeyboardIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.5 2v2.5a.5.5 0 0 0 .5.5h9c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4h-9a.5.5 0 0 0-.5.5v5h-3v-5c0-1.933 1.567-3.5 3.5-3.5h9c.5523 0 1-.4477 1-1s-.4477-1-1-1h-9c-1.933 0-3.5-1.567-3.5-3.5V2z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M46 22v14c0 3.3137-2.6863 6-6 6H8c-3.3137 0-6-2.6863-6-6V22c0-3.3137 2.6863-6 6-6h32c3.3137 0 6 2.6863 6 6m-23.48 5.5H19.5v3h3.02zm2.98 0h3.02v3H25.5zm9 6h-21v3h21zm-15-12h3.02v3H19.5zm9.02 0H25.5v3h3.02zm2.98 6h3.02v3H31.5zm3.02-6H31.5v3h3.02zm2.98 6h3.02v3H37.5zm3.02 6H37.5v3h3.02zm-3.02-12h3.02v3H37.5zm-26.98 6H7.5v3h3.02zm-3.02 6h3.02v3H7.5zm3.02-12H7.5v3h3.02zm2.98 6h3.02v3H13.5zm3.02-6H13.5v3h3.02z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Keyboard',
  48
);

export const LanguageIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="m21.0066 28.5555-3.4634-6.8713C17.5432 12.4417 12.3116 4 3 4H2v42h3.2284v-6.6316h6.3462c2.105 0 3.8499-1.6315 3.991-3.7318l.3063-4.5577 3.93-.3544c1.0546-.0951 1.6813-1.2235 1.2047-2.169"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M43.5 14c1.933 0 3.5 1.567 3.5 3.5v16c0 1.933-1.567 3.5-3.5 3.5H21v-1l4-4V17.5c0-1.933 1.567-3.5 3.5-3.5zM30 33h7v-3h-7zm0-9v3h12v-3zm0-3h12v-3H30z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Language',
  48
);

export const LaptopAlertIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M33.5193 6.4338c1.0969-1.9112 3.8657-1.9126 4.9618.0007l7.6385 13.3095c1.089 1.8962-.2871 4.256-2.4814 4.256H28.3618c-2.1937 0-3.5683-2.3607-2.4814-4.256zM37.5005 8.5v7h-3v-7zm-1.5 9c-1.2427 0-2.25 1.0073-2.25 2.25s1.0073 2.25 2.25 2.25 2.25-1.0074 2.25-2.25-1.0074-2.25-2.25-2.25M45 27v3h-3v-3z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M1 33v4c0 2.2091 1.7909 4 4 4h38c2.2091 0 4-1.7909 4-4v-4H32v2c0 .5523-.4477 1-1 1H17c-.5523 0-1-.4477-1-1v-2zm2-21.5C3 7.9102 5.9101 5 9.5 5H29v3h-3c0 1.1046-.8954 2-2 2s-2-.8954-2-2H9.5C7.567 8 6 9.567 6 11.5V30H3z"
      key="1"
    />,
  ],
  'LaptopAlert',
  48
);

export const LaptopChartColsIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M1 33v4c0 2.2091 1.7909 4 4 4h38c2.2091 0 4-1.7909 4-4v-4H32v2c0 .5523-.4477 1-1 1H17c-.5523 0-1-.4477-1-1v-2zM9.5 5C5.9102 5 3 7.9101 3 11.5V30h3V11.5C6 9.567 7.567 8 9.5 8H22c0 1.1046.8954 2 2 2s2-.8954 2-2h12.5c1.933 0 3.5 1.567 3.5 3.5V30h3V11.5C45 7.9102 42.0899 5 38.5 5z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M21 30V13h6v17zm10 0V18h6v12zm-20 0v-6h6v6z"
      key="1"
    />,
  ],
  'LaptopChartCols',
  48
);

export const LaptopChartPieIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M1 33v4c0 2.2091 1.7909 4 4 4h38c2.2091 0 4-1.7909 4-4v-4H32v2c0 .5523-.4477 1-1 1H17c-.5523 0-1-.4477-1-1v-2zM9.5 5C5.9102 5 3 7.9101 3 11.5V30h3V11.5C6 9.567 7.567 8 9.5 8H22c0 1.1046.8954 2 2 2s2-.8954 2-2h12.5c1.933 0 3.5 1.567 3.5 3.5V30h3V11.5C45 7.9102 42.0899 5 38.5 5z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M24 30c4.6944 0 8.5-3.8056 8.5-8.5H24V13c-4.6944 0-8.5 3.8056-8.5 8.5S19.3056 30 24 30"
      key="1"
    />,
  ],
  'LaptopChartPie',
  48
);

export const LaptopCodeIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M1 33v4c0 2.2091 1.7909 4 4 4h38c2.2091 0 4-1.7909 4-4v-4H32v2c0 .5523-.4477 1-1 1H17c-.5523 0-1-.4477-1-1v-2zM9.5 5C5.9102 5 3 7.9101 3 11.5V30h3V11.5C6 9.567 7.567 8 9.5 8H22c0 1.1046.8954 2 2 2s2-.8954 2-2h12.5c1.933 0 3.5 1.567 3.5 3.5V30h3V11.5C45 7.9102 42.0899 5 38.5 5z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21 24.5h9v3h-9zm-8.5 3.6213L19.1213 21.5 12.5 14.8787 10.3787 17l4.5 4.5-4.5 4.5z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'LaptopCode',
  48
);

export const ListCheckIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M36 46c3.3106 0 6-2.6711 6-5.9879V7.9879C42 4.6711 39.3106 2 36 2H12C8.6884 2 6 4.6761 6 7.992v32.0095C6 43.3156 8.6867 46 12 46zM25.1213 9 17 17.1213 10.8787 11 13 8.8787l4 4 6-6zm0 12L23 18.8787l-6 6-4-4L10.8787 23 17 29.1213zM12 35h10v3H12zm17 0v3h7v-3zm0-11h7v3h-7zm0-12v3h7v-3z"
    clipRule="evenodd"
  />,
  'ListCheck',
  48
);

export const ListTreeIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 9.5h10v3H7zm0 12.9998h10v3H7z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 2v33.5h8v3H6V2z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M44 19H20v10h24zm0-13H20v10h24zm0 26H20v10h24z"
      key="2"
    />,
  ],
  'ListTree',
  48
);

export const ManualRefundIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M24 43h18v4H24zm8-23.9824V3H6v38h15v-3H9V6h20v13.9365a6.96 6.96 0 0 1 3-.9189"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m35 21-2 8v-7c-2.3416 0-4.4979 1.436-4.5 3.9966V29l-.6702.8043a7.894 7.894 0 0 0 .0381 10.1533h10.6899l1.497-10.1362a6 6 0 0 0-.1886-2.6007l-2.5738-14.5324c-.1691-.9551-.9993-1.6512-1.9693-1.6512H35z"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 23.3969V11.2941c-1.3255 0-2.4-1.0271-2.4-2.2941h-9.2c0 1.267-1.0745 2.2941-2.4 2.2941v21.4118c1.3255 0 2.4 1.0271 2.4 2.2941h8.6009A10.895 10.895 0 0 1 25.5 27.914v-1.9199a6.98 6.98 0 0 1 .5-2.5972M19 26c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'ManualRefund',
  48
);

export const MapPinIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M14.5 4.5137 2 9.2953v33.1238l12.5-4.7847z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M37.5 24.5c-4.9385 0-9 3.8653-9 8.7024 0 4.7987 3.7532 8.7023 8.4637 11.9301L37.5 45.5l.5363-.3675C42.7468 41.9047 46.5 38.0011 46.5 33.2024c0-4.8371-4.0615-8.7024-9-8.7024m0 6.5c-1.3807 0-2.5 1.1193-2.5 2.5s1.1193 2.5 2.5 2.5 2.5-1.1193 2.5-2.5-1.1193-2.5-2.5-2.5"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M30.0191 43.2472 17.5 37.7701V4.5422l13 5.6875v13.4701c-3.0033 2.1012-5 5.5301-5 9.5025 0 3.9937 1.9194 7.3157 4.5191 10.0449M46 24.9413c-2.195-2.1395-5.2236-3.4412-8.5-3.4412a12.23 12.23 0 0 0-4 .6704V10.3657L46 5.5811z"
      key="2"
    />,
  ],
  'MapPin',
  48
);

export const MatIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M46 14c0-3.3137-2.6863-6-6-6H19.8916c.0701.49.1084.9906.1084 1.5V13h19c1.1046 0 2 .8954 2 2v22c0 1.1046-.8954 2-2 2H19.8283a3 3 0 0 1-.7072 1.1211A3 3 0 0 1 17 41h-.042L17 44h23c3.3137 0 6-2.6863 6-6zM2 36V9.5C2 5.3579 5.3579 2 9.5 2S17 5.3579 17 9.5V36h-1v-1c0-3.3137-2.6863-6-6-6H9c-3.3137 0-6 2.6863-6 6v1z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M2 36V9.5C2 5.3579 5.3579 2 9.5 2S17 5.3579 17 9.5V38h-1v-3c0-3.3137-2.6863-6-6-6H9c-3.3137 0-6 2.6863-6 6v1z"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M16.9902 35.1143C16.7895 31.1514 13.5128 28 9.5 28s-7.2895 3.1514-7.4902 7.1143L2 36c0 4.4183 3.5817 8 8 8h7v-3h-7c-2.7614 0-5-2.2386-5-5v-.5C5 33.0147 7.0147 31 9.5 31s4.5 2.0147 4.5 4.5V38h3v-2.5zM20 16h18v20H20z"
      key="2"
    />,
  ],
  'Mat',
  48
);

export const MessageBubbleUserIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 14C5.567 14 4 15.567 4 17.5v18C4 37.433 5.567 39 7.5 39h28c1.933 0 3.5-1.567 3.5-3.5V23h3v12.5c0 3.5899-2.9101 6.5-6.5 6.5h-28C3.9102 42 1 39.0898 1 35.5v-18C1 13.9101 3.9101 11 7.5 11H20v3z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 4.5C23 2.567 24.567 1 26.5 1h17C45.433 1 47 2.567 47 4.5v12c0 1.933-1.567 3.5-3.5 3.5h-7.2063L28 25.3317V20h-1.5c-1.933 0-3.5-1.567-3.5-3.5zM11 24c0-3.0376 2.4624-5.5 5.5-5.5S22 20.9624 22 24s-2.4624 5.5-5.5 5.5S11 27.0376 11 24M6 41.5C6 35.701 10.701 31 16.5 31S27 35.701 27 41.5z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'MessageBubbleUser',
  48
);

export const MessagesIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 9c0-2.7614 2.2386-5 5-5h24c2.7614 0 5 2.2386 5 5v15c0 2.7614-2.2386 5-5 5h-8.6775L8.5 38.9522V29H7c-2.7614 0-5-2.2386-5-5z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M39 11h1.5c3.0376 0 5.5 2.4624 5.5 5.5v15c0 3.0376-2.4624 5.5-5.5 5.5H40v10.4284L25.5162 37H20.5v-3h5.9838L37 41.5716V34h3.5c1.3807 0 2.5-1.1193 2.5-2.5v-15c0-1.3807-1.1193-2.5-2.5-2.5H39z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Messages',
  48
);

export const MobileChatBubbleIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 8.5c0-.8284.6716-1.5 1.5-1.5h5c.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5h-5c-.8284 0-1.5-.6716-1.5-1.5"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M23 29.5c0-1.3807 1.1193-2.5 2.5-2.5h16c1.3807 0 2.5 1.1193 2.5 2.5v10c0 1.3807-1.1193 2.5-2.5 2.5H29.0554L23 46.0794z"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M20 43h-4c-1.6569 0-3-1.3432-3-3V8c0-1.6569 1.3431-3 3-3h16c1.6569 0 3 1.3431 3 3v16h3V8c0-3.3137-2.6863-6-6-6H16c-3.3137 0-6 2.6863-6 6v32c0 3.3137 2.6863 6 6 6h4z"
      key="2"
    />,
  ],
  'MobileChatBubble',
  48
);

export const MobileCreditCardIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M47 30c0-2.7614-2.2386-5-5-5H25c-2.7614 0-5 2.2386-5 5v1h27z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 41v-6h27v6c0 2.7614-2.2386 5-5 5H25c-2.7614 0-5-2.2386-5-5m5-2.5v3h5v-3z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M32 5c1.6569 0 3 1.3431 3 3v14h3V8c0-3.3137-2.6863-6-6-6H16c-3.3137 0-6 2.6863-6 6v32c0 3.3137 2.6863 6 6 6h1.125v-3H16c-1.6569 0-3-1.3431-3-3V8c0-1.6569 1.3432-3 3-3z"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 8.5c0-.8284.6716-1.5 1.5-1.5h5c.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5h-5c-.8284 0-1.5-.6716-1.5-1.5"
      clipRule="evenodd"
      key="3"
    />,
  ],
  'MobileCreditCard',
  48
);

export const MobileSecureIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 8.5c0-.8284.6716-1.5 1.5-1.5h5c.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5h-5c-.8284 0-1.5-.6716-1.5-1.5"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M29 43H16c-1.6569 0-3-1.3432-3-3V8c0-1.6569 1.3431-3 3-3h16c1.6569 0 3 1.3431 3 3v15h3V8c0-3.3137-2.6863-6-6-6H16c-3.3137 0-6 2.6863-6 6v32c0 3.3137 2.6863 6 6 6h13z"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M45 36.195v-8.2678s-4.8515-1-8-1-8 1-8 1v8.2678c0 3.1011 2.032 5.3011 3.9639 6.6941.9732.7017 1.9436 1.2158 2.6691 1.5543.4465.2083.9009.398 1.367.5567.4661-.1587.9205-.3484 1.367-.5567.7255-.3385 1.6959-.8526 2.6691-1.5543C42.968 41.4961 45 39.2961 45 36.195"
      key="2"
    />,
  ],
  'MobileSecure',
  48
);

export const MobileTicketIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 8.5c0-.8284.6716-1.5 1.5-1.5h5c.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5h-5c-.8284 0-1.5-.6716-1.5-1.5m23.1465 29.2101L44 37.9V43H23v-5.0995l.832-.1863c1.518-.3398 2.5957-1.6744 2.5957-3.2142s-1.0777-2.8744-2.5957-3.2142L23 31.0995V26h21v5.1l-.8535.1899c-1.5176.3376-2.5959 1.671-2.5959 3.2101s1.0783 2.8725 2.5959 3.2101"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M20 43h-4c-1.6569 0-3-1.3432-3-3V8c0-1.6569 1.3431-3 3-3h16c1.6569 0 3 1.3431 3 3v15h3V8c0-3.3137-2.6863-6-6-6H16c-3.3137 0-6 2.6863-6 6v32c0 3.3137 2.6863 6 6 6h4z"
      key="1"
    />,
  ],
  'MobileTicket',
  48
);

export const MoneyBillsIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 5h36v3H6zm-5 6h46v32H1zm3 3v26h40V14z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 17c0 1.6569-1.3431 3-3 3v14c1.6569 0 3 1.3431 3 3h28c0-1.6569 1.3431-3 3-3V20c-1.6569 0-3-1.3431-3-3zm19 10c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5m3.5-1.5h5v3h-5zm-22 0v3h5v-3z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'MoneyBills',
  48
);

export const MonitorMobileIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 29v11H11.5v-3H19v-8z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 26c0 3.3137 2.6863 6 6 6h14V22c0-4.4183 3.5817-8 8-8h10v-3c0-3.3137-2.6863-6-6-6H8c-3.3137 0-6 2.6863-6 6zM19.0002 7 23 7.0002l-.0002 1.0001c-.0001 1.1045-.8954 1.9998-1.9999 1.9998S18.9999 9.1046 19 8z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m33.5001 18.0001-.0001 2h1.9999L35.5 18l2 .0001-.0001 2.5c-.0001.8284-.6716 1.5-1.5 1.5H33c-.8285 0-1.5-.6717-1.5-1.5001l.0001-2.5z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M41 40V22c0-1.1046-.8954-2-2-2h-9c-1.1046 0-2 .8954-2 2v18c0 1.1046.8954 2 2 2h9c1.1046 0 2-.8954 2-2m3-18v18c0 2.7614-2.2386 5-5 5h-9c-2.7614 0-5-2.2386-5-5V22c0-2.7614 2.2386-5 5-5h9c2.7614 0 5 2.2386 5 5"
      clipRule="evenodd"
      key="3"
    />,
  ],
  'MonitorMobile',
  48
);

export const MoveToRightIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M44 9.5C44 6.4624 41.5376 4 38.5 4h-6C29.4624 4 27 6.4624 27 9.5v29c0 3.0376 2.4624 5.5 5.5 5.5h6c3.0376 0 5.5-2.4624 5.5-5.5zM18 14v8.5h3V14zM7 14v8.5H4V14zm11 11.5V34h3v-8.5zm-11 0V34H4v-8.5zM18 37v1.5c0 1.3807-1.1193 2.5-2.5 2.5H14v3h1.5c3.0376 0 5.5-2.4624 5.5-5.5V37zm0-26V9.5C18 8.1193 16.8807 7 15.5 7H14V4h1.5C18.5376 4 21 6.4624 21 9.5V11zM7 37v1.5C7 39.8807 8.1193 41 9.5 41H11v3H9.5C6.4624 44 4 41.5376 4 38.5V37zm0-26V9.5C7 8.1193 8.1193 7 9.5 7H11V4H9.5C6.4624 4 4 6.4624 4 9.5V11z"
    clipRule="evenodd"
  />,
  'MoveToRight',
  48
);

export const NameCardIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.5 35v11h-3V35z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 43h20v3H14z"
      clipRule="evenodd"
      key="1"
    />,
    <path fill="currentColor" d="M32 31H16v6h16z" key="2" />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 4C4.2386 4 2 6.2386 2 9v21c0 2.7614 2.2386 5 5 5h6v-4c0-1.6569 1.3431-3 3-3h16c1.6569 0 3 1.3431 3 3v4h6c2.7614 0 5-2.2386 5-5V9c0-2.7614-2.2386-5-5-5zm5 8v3h16v-3zm19 3h5v-3h-5zm-10 4v3h-9v-3z"
      clipRule="evenodd"
      key="3"
    />,
  ],
  'NameCard',
  48
);

export const PersonWheelchairIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M41 42c0-.5523-.4477-1-1-1s-1 .4477-1 1 .4477 1 1 1 1-.4477 1-1m3 0c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4m-26.5-1H17v-3h.5c1.3807 0 2.5-1.1193 2.5-2.5V35h3v.5c0 3.0376-2.4624 5.5-5.5 5.5"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M22.4082 16.542C22.1753 14.5236 20.4663 13 18.4346 13h-3.1895a4 4 0 0 0-3.2109 1.6152l-3.5225 4.7442a3.501 3.501 0 0 0-.3672 3.7138l4.1356 7.0907c.5091.8949 1.6088 1.264 2.5547.8574 1.0136-.4359 1.4904-1.6043 1.0712-2.625l-2.5488-6.5728 2.0976-2.765 1.6018 8.0743C21.3527 27.3818 25 30.3891 25 35c0 4.4183-3.5817 8-8 8s-8-3.5817-8-8c0-1.2209.2736-2.3779.7627-3.4131l-2.8565-.9648C6.3236 31.9637 6 33.444 6 35c0 6.0751 4.9249 11 11 11s11-4.9249 11-11c0-1.191-.1919-2.337-.542-3.4111l2.9707-.6221 5.0156 6.3359 3.0713-1.9668-3.6623-7.5722a4 4 0 0 0-3.8322-2.2517l-6.9954.4052zM19 10.5c2.4853 0 4.5-2.0147 4.5-4.5S21.4853 1.5 19 1.5 14.5 3.5147 14.5 6s2.0147 4.5 4.5 4.5"
      key="1"
    />,
  ],
  'PersonWheelchair',
  48
);

export const PhoneVolumeIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27 4h1.5C37.0604 4 44 10.9396 44 19.5V21h-3v-1.5C41 12.5964 35.4036 7 28.5 7H27z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27 11h1.5c4.6944 0 8.5 3.8056 8.5 8.5V21h-3v-1.5c0-3.0376-2.4624-5.5-5.5-5.5H27zM15.1398 2.8192l6.2612 14.0975-5.7307 4.5845a33.82 33.82 0 0 0 10.8323 10.8319l4.5815-5.729 14.0971 6.2598-2.5538 9.8234c-.501 1.9273-2.3726 3.2381-4.3928 2.8963C18.7551 42.2887 5.6894 29.2466 2.3903 9.7672c-.3424-2.0213.9699-3.8937 2.8985-4.3938z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'PhoneVolume',
  48
);

export const PivotIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M46 36c0 3.3137-2.6863 6-6 6H17v-3h23c1.6569 0 3-1.3431 3-3V19h3zM2 12c0-3.3137 2.6863-6 6-6h32c3.3137 0 6 2.6863 6 6v4H2zm0 7.5V36c0 3.3137 2.6863 6 6 6h6V19.5z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m29.4346 22.6055-4.6992 4.2519h6.5273c2.1066 0 3.5525-1.5129 3.5527-3.0713V19h3v4.7861c-.0002 3.4906-3.0787 6.0713-6.5527 6.0713h-6.21l4.3819 3.9649-2.0127 2.2246-8.6573-7.833 8.6573-7.833z"
      key="1"
    />,
  ],
  'Pivot',
  48
);

export const PopcornIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M38.333 40.7334c-.3703 3.0073-2.9251 5.2665-5.9551 5.2666H15.6221c-3.03-.0001-5.5848-2.2593-5.9551-5.2666L6.869 18h34.262zM14.1855 21l2.1153 22h3.0137l-2.1153-22zM22.5 21v22h3V21zm8.3008 0-2.1153 22h3.0137l2.1153-22z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M19.2002 2c1.4172 0 2.7185.5022 3.7275 1.337C27.278.3136 33.7502 2.95 34.4873 8.2704c1.5073-.0243 2.9581.3694 4.1172 1.1602C40.0487 10.416 41 11.9983 41 14v1H31v-1c0-2.2091-1.7909-4-4-4-1.5546 0-2.9015.8872-3.5635 2.1826A2.49 2.49 0 0 0 22.5 12c-1.3807 0-2.5 1.1193-2.5 2.5 0 .1712.017.3385.0498.5H7v-1c0-2.0691 1.0128-3.6729 2.5264-4.6338 1.1199-.711 2.4913-1.0603 3.9111-1.0361C13.1074 5.1053 15.7113 2 19.2002 2"
      key="1"
    />,
  ],
  'Popcorn',
  48
);

export const PresentationScreenChartColsIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m29.9292 37.5398 5.1106 8.031 2.531-1.6106-5.1106-8.031zm-11.8584 0-5.1106 8.031-2.531-1.6106 5.1106-8.031zM25.5 36.5V44h-3v-7.5zm0-35.5v5.5h-3V1z"
      clipRule="evenodd"
      key="0"
    />,
    <path fill="currentColor" d="M46.2808 32H1.7192l1.5 6h41.5616z" key="1" />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M41 10.5C41 8.567 39.433 7 37.5 7h-27C8.567 7 7 8.567 7 10.5V29H4V10.5C4 6.9102 6.9101 4 10.5 4h27c3.5899 0 6.5 2.9101 6.5 6.5V29h-3z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      d="M21 29V12h6v17zm10 0V17h6v12zm-20 0v-6h6v6z"
      key="3"
    />,
  ],
  'PresentationScreenChartCols',
  48
);

export const PresentationScreenChartLineIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m29.9292 37.5398 5.1106 8.031 2.531-1.6106-5.1106-8.031zm-11.8584 0-5.1106 8.031-2.531-1.6106 5.1106-8.031zM25.5 36.5V44h-3v-7.5zm0-35.5v5.5h-3V1z"
      clipRule="evenodd"
      key="0"
    />,
    <path fill="currentColor" d="M46.2808 32H1.7192l1.5 6h41.5616z" key="1" />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M41 10.5C41 8.567 39.433 7 37.5 7h-27C8.567 7 7 8.567 7 10.5V29H4V10.5C4 6.9102 6.9101 4 10.5 4h27c3.5899 0 6.5 2.9101 6.5 6.5V29h-3z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M38.1212 14.0269 26.7693 25.095l-7.3846-7.2-7.4115 7.2262-2.0943-2.148 9.5058-9.2681 7.3846 7.2 9.2576-9.0262z"
      clipRule="evenodd"
      key="3"
    />,
  ],
  'PresentationScreenChartLine',
  48
);

export const PresentationScreenChartPieIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m29.9292 37.5398 5.1106 8.031 2.531-1.6106-5.1106-8.031zm-11.8584 0-5.1106 8.031-2.531-1.6106 5.1106-8.031zM25.5 36.5V44h-3v-7.5zm0-35.5v5.5h-3V1z"
      clipRule="evenodd"
      key="0"
    />,
    <path fill="currentColor" d="M46.2808 32H1.7192l1.5 6h41.5616z" key="1" />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M41 10.5C41 8.567 39.433 7 37.5 7h-27C8.567 7 7 8.567 7 10.5V29H4V10.5C4 6.9102 6.9101 4 10.5 4h27c3.5899 0 6.5 2.9101 6.5 6.5V29h-3z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      d="M24 28c4.6944 0 8.5-3.8056 8.5-8.5H24V11c-4.6944 0-8.5 3.8056-8.5 8.5S19.3056 28 24 28"
      key="3"
    />,
  ],
  'PresentationScreenChartPie',
  48
);

export const PresentationIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M13 12c2.4853 0 4.5-2.0147 4.5-4.5S15.4853 3 13 3 8.5 5.0147 8.5 7.5 10.5147 12 13 12"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.0118 46 7 22l-.794 7.3959c-.0672.834-.7637 1.4766-1.6004 1.4766-.9188 0-1.6501-.7695-1.6035-1.6871l.5375-10.57a2.707 2.707 0 0 1 1.2019-2.1149A14.873 14.873 0 0 1 13 14h14.3796C28.2745 14 29 14.7255 29 15.6204c0 .7951-.577 1.4728-1.362 1.5996L19 18.6154 17.9883 46h-3.9882V31.8644h-2V46zm3.0664-21.4197L12.3507 16h1.2987l1.2724 8.5803L13 26.1942zm18.851 12.9595 5.1106 8.031 2.531-1.6106-5.1106-8.031z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="m44.7808 38 1.5-6H23v6zM41 12.5c0-1.933-1.567-3.5-3.5-3.5H22V6h15.5c3.5899 0 6.5 2.9101 6.5 6.5V29h-3z"
      key="2"
    />,
  ],
  'Presentation',
  48
);

export const PriceZoneIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.5 23.5V6h-14C4.9102 6 2 8.9101 2 12.5v25C2 41.0899 4.9101 44 8.5 44h25c3.5899 0 6.5-2.9101 6.5-6.5v-14zM8.5 9C6.567 9 5 10.567 5 12.5v11h14.5V9zm11 17.5H5v11C5 39.433 6.567 41 8.5 41h11zm3 0H37v11c0 1.933-1.567 3.5-3.5 3.5h-11z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M38.5 1.5c3.3137 0 6 2.6863 6 6v13h-19v-19z"
      key="1"
    />,
  ],
  'PriceZone',
  48
);

export const PrintTicketIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 3v8.8777l26 .1272V3zM3 21v16h5V26c0-1.6569 1.3431-3 3-3h26a3 3 0 0 1 3 3v11h5V21c0-3.3137-2.6863-6-6-6H9c-3.3137 0-6 2.6863-6 6m9.5-3c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5h1c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M37 45h-7.7998l-.291-1.3008c-.5165-2.3124-2.5554-3.9551-4.9092-3.9551s-4.3927 1.6427-4.9092 3.9551L18.7998 45H11V26h26zM15 31c-.8284 0-1.5.6716-1.5 1.5S14.1716 34 15 34s1.5-.6716 1.5-1.5S15.8284 31 15 31m6 0c-.8284 0-1.5.6716-1.5 1.5S20.1716 34 21 34s1.5-.6716 1.5-1.5S21.8284 31 21 31m6 0c-.8284 0-1.5.6716-1.5 1.5S26.1716 34 27 34s1.5-.6716 1.5-1.5S27.8284 31 27 31m6 0c-.8284 0-1.5.6716-1.5 1.5S32.1716 34 33 34s1.5-.6716 1.5-1.5S33.8284 31 33 31"
      key="1"
    />,
  ],
  'PrintTicket',
  48
);

export const PrintIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 3v8.8777l26 .1272V3zM3 21v16h5V26c0-1.6569 1.3431-3 3-3h26a3 3 0 0 1 3 3v11h5V21c0-3.3137-2.6863-6-6-6H9c-3.3137 0-6 2.6863-6 6m9.5-3c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5h1c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 45V26h26v19zm5-8h9v3h-9zm7-6v3h9v-3zm5 6h4v3h-4zm-12-6v3h4v-3z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Print',
  48
);

export const PuzzlePiecesIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M22.5 22.5h-4.1c-.4633-2.2822-2.481-4-4.9-4s-4.4367 1.7178-4.9 4H4V10c0-3.3137 2.6863-6 6-6h12.5v7.5h2c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-2zm3 21.5v-7.5h-2c-1.1046 0-2-.8954-2-2s.8954-2 2-2h2v-7h4.1c.4633 2.2822 2.481 4 4.9 4s4.4367-1.7178 4.9-4H44V38c0 3.3137-2.6863 6-6 6z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M25.5 22.5v-4.1c2.2822-.4633 4-2.481 4-4.9s-1.7178-4.4367-4-4.9V4H38c3.3137 0 6 2.6863 6 6v12.5h-7.5v2c0 1.1046-.8954 2-2 2s-2-.8954-2-2v-2zM4 25.5h7.5v-2c0-1.1046.8954-2 2-2s2 .8954 2 2v2h7v4.1c-2.2822.4633-4 2.481-4 4.9s1.7178 4.4367 4 4.9V44H10c-3.3137 0-6-2.6863-6-6z"
      key="1"
    />,
  ],
  'PuzzlePieces',
  48
);

export const ReceiptIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M41 8c0-3.3137-2.6863-6-6-6H13C9.6863 2 7 4.6863 7 8v38l5-3.75 4 3 4-3 4 3 4-3 4 3 4-3L41 46zm-26 8h11v-3H15zm0 8v-3h11v3zm18-8h-4v-3h4zm0 8v-3h-4v3zm-18 8h11v-3H15zm18 0v-3h-4v3z"
    clipRule="evenodd"
  />,
  'Receipt',
  48
);

export const ReloadIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.4999 5.5c10.2173 0 18.5 8.2827 18.5 18.5v1.5h3V24c0-11.8741-9.6259-21.5-21.5-21.5-8.146 0-15.231 4.53-18.8784 11.2035l-.06-.0269-.6105 1.3625a22 22 0 0 0-.1614.3603l2.7433 1.214.15-.3345C10.61 9.9144 17.041 5.5 24.4998 5.5"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 3v11h11v3H4V3zm16.5 39.5C13.2827 42.5 5 34.2173 5 24v-1.5H2V24c0 11.8741 9.6259 21.5 21.5 21.5 8.146 0 15.231-4.5301 18.8784-11.2035l.0599.0269.6107-1.3625q.0822-.1794.1614-.3603l-2.7434-1.214-.1499.3345C37.3899 38.0856 30.9588 42.5 23.5 42.5"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M41 45V34H30v-3h14v14z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'Reload',
  48
);

export const ReservedTagIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M9.3413 35H5.6392c-2.4366-.0001-4.2878-2.153-3.9648-4.5322L4.855 14.0664z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M46.2002 34.1621C46.7336 36.6521 44.8356 39 42.2891 39H17.3086c-2.3577 0-4.3956-1.6469-4.8897-3.9521L6.8379 9h33.9707zM19.2891 28H36l-1.7891-8H17.5z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'ReservedTag',
  48
);

export const RestaurantMenuIcon = createSvgIcon(
  [
    <path fill="currentColor" d="M42 6h3v36h-3z" key="0" />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M33 2c3.3137 0 6 2.6863 6 6v28H6V8c0-3.3137 2.6863-6 6-6zM17 9c-1.5032 0-2.7764.8398-3.6367 2.0225C12.5023 12.2064 12 13.7928 12 15.5s.5023 3.2936 1.3633 4.4775c.5559.7643 1.2853 1.3828 2.1367 1.7266V32h3V21.7041c.8514-.3438 1.5808-.9623 2.1367-1.7266C21.4977 18.7936 22 17.2072 22 15.5s-.5023-3.2936-1.3633-4.4775C19.7764 9.8398 18.5032 9 17 9m13 0c-2.7614 0-5 2.2386-5 5v12h4v6h3V9z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M39 40c0 3.3137-2.6863 6-6 6H12c-3.3137 0-6-2.6863-6-6v-1h33z"
      key="2"
    />,
  ],
  'RestaurantMenu',
  48
);

export const RocketIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.1173 13.4734C12.2144 12.2155 13.816 11.5 15.4909 11.5h5.5099v3h-5.5099c-.8345 0-1.6193.3687-2.1602 1.0006l-6.3565 6.5217 12.8369 2.7228-.6224 2.9347-18.163-3.8524zM33.5 32.5099V27h3v5.5099c0 1.6749-.7156 3.2765-1.9734 4.3736L24.1615 46.9848l-3.3517-16.1805 2.9377-.6086 2.2411 10.8195 6.5475-6.3765c.6032-.5164.9639-1.295.9639-2.1288M2.9957 42.8247c.0143-.7333.0617-1.7425.1953-2.8416.1332-1.0952.3548-2.3045.7264-3.4286.3679-1.1126.9075-2.2183 1.7228-3.0336 2.8848-2.8849 6.8142-2.2798 8.9664-.1276 2.1521 2.1522 2.7573 6.0815-.1276 8.9664-.3772.3771-1.4093 1.1527-2.2536 1.7733-.8453.6214-1.7006 1.2289-2.5561 1.8361l-1.3138-2.1206-5.3033 1.4464c-.0338-.8238-.0726-1.6454-.0565-2.4702"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m45.9943 3.6285.1527-1.7757-1.7757.1527c-18.048 1.552-28.0898 10.6374-31.3179 22.3874l-.2311.8412 9.9433 9.9434.8412-.2311c11.7501-3.2281 20.8354-13.2699 22.3875-31.318M32.5957 7.5957l1.5983.9465a15 15 0 0 1 5.2636 5.2635l.9464 1.5983c1.1322-2.9833 1.9588-6.3821 2.4163-10.2246-3.8424.4575-7.2412 1.2842-10.2246 2.4163M24 18.5c0-3.0376 2.4624-5.5 5.5-5.5s5.5 2.4624 5.5 5.5-2.4624 5.5-5.5 5.5-5.5-2.4625-5.5-5.5"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Rocket',
  48
);

export const ScannerUsbIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path
        fillRule="evenodd"
        d="M0 37h2.5a.5.5 0 0 0 .5-.5v-9c0-2.2091 1.7909-4 4-4s4 1.7909 4 4v9a.5.5 0 0 0 .5.5h5v3h-5C9.567 40 8 38.433 8 36.5v-9c0-.5523-.4477-1-1-1s-1 .4477-1 1v9C6 38.433 4.433 40 2.5 40H0z"
        clipRule="evenodd"
      />
      <path d="M36 2c3.3137 0 6 2.6863 6 6v32c0 3.3137-2.6863 6-6 6H20c-3.3137 0-6-2.6863-6-6V8c0-3.3137 2.6863-6 6-6zm-8 38c-.8284 0-1.5.6716-1.5 1.5S27.1716 43 28 43s1.5-.6716 1.5-1.5S28.8284 40 28 40M19 6c-.5523 0-1 .4477-1 1v29c0 .5523.4477 1 1 1h18c.5523 0 1-.4477 1-1V7c0-.5523-.4477-1-1-1z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'ScannerUsb',
  48
);

export const ScreenshareIcon = createSvgIcon(
  [
    <path fill="currentColor" d="m10.4385 44 4-4h19.1229l4 4z" key="0" />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 6c-3.3137 0-6 2.6863-6 6v19c0 3.3137 2.6863 6 6 6h32c3.3137 0 6-2.6863 6-6V12c0-3.3137-2.6863-6-6-6zm17.5 25h-3v-7.4948H14L24 12l10 11.5052h-8.5z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Screenshare',
  48
);

export const ScrollHorizontalIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M18.5 9.4997 4 9.4998V6.5001L18.5 6.5zm11 0h14.4999V6.5H29.5z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M1.8784 8.0005 8.648 1.231l2.121 2.121-4.6464 4.6485 4.6562 4.6572-2.121 2.1211zm44.2429-.0003-6.7705-6.7705-2.1211 2.1211 4.6484 4.6494-4.6455 4.6456 2.1211 2.121zM16.5 23.9573v6.3219c0 .8303.2584 1.64.7393 2.3168l4.7062 6.6237a3 3 0 0 1 .5545 1.7376V43l1.4109.4938a26 26 0 0 0 17.1782 0L42.5 43l1.5234-15.9955c.2757-2.8954-1.5648-5.5716-4.3671-6.35L26.5 17V6c0-1.3807-1.1193-2.5-2.5-2.5S21.5 4.6193 21.5 6v23h-1l-1-8.8834c-1.723.428-3 1.9852-3 3.8407"
      key="1"
    />,
  ],
  'ScrollHorizontal',
  48
);

export const SeatAddIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 41h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3zm18 0h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3zM6.211 21.1055c1.5982-.4356 3.2476.5072 3.6835 2.1054L12.291 32h23.418l2.3965-8.7891a3 3 0 0 1 .0732-.2304c1.7113-.0916 3.3306-.5273 4.791-1.2393.8384.7324 1.2372 1.9019.9248 3.0479l-2.3974 8.79c-.712 2.6099-3.0828 4.4206-5.7881 4.4209H12.291c-2.7054-.0002-5.076-1.8109-5.788-4.4209l-2.3975-8.79c-.4358-1.5984.507-3.2477 2.1054-3.6836M27.5 3C25.9306 5.0892 25 7.6858 25 10.5c0 6.088 4.3524 11.1582 10.1152 12.2715L33.417 29H14.583l-1.7939-6.5781c-.3257-1.194-.9902-2.2052-1.8614-2.958l.7979-12.7598C11.8805 4.6155 13.6205 3 15.7148 3z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M47 10.5c0 5.2467-4.2533 9.5-9.5 9.5S28 15.7467 28 10.5 32.2533 1 37.5 1 47 5.2533 47 10.5m-8-5h-3V9h-3.5v3H36v3.5h3V12h3.5V9H39z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'SeatAdd',
  48
);

export const SeatCheckIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 41h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3zm18 0h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3zM6.211 21.1055c1.5982-.4356 3.2476.5072 3.6835 2.1054L12.291 32h23.418l2.3965-8.7891a3 3 0 0 1 .0732-.2304c1.7113-.0916 3.3306-.5273 4.791-1.2393.8384.7324 1.2372 1.9019.9248 3.0479l-2.3974 8.79c-.712 2.6099-3.0828 4.4206-5.7881 4.4209H12.291c-2.7054-.0002-5.076-1.8109-5.788-4.4209l-2.3975-8.79c-.4358-1.5984.507-3.2477 2.1054-3.6836M27.5 3C25.9306 5.0892 25 7.6858 25 10.5c0 6.088 4.3524 11.1582 10.1152 12.2715L33.417 29H14.583l-1.7939-6.5781c-.3257-1.194-.9902-2.2052-1.8614-2.958l.7979-12.7598C11.8805 4.6155 13.6205 3 15.7148 3z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M47 10.5c0 5.2467-4.2533 9.5-9.5 9.5S28 15.7467 28 10.5 32.2533 1 37.5 1 47 5.2533 47 10.5m-3.8811-2.6009-2.2198-2.018-4.9508 5.4459L33.5 8.8787 31.3787 11l4.673 4.673z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'SeatCheck',
  48
);

export const SeatGroupIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M3 23c0-1.6569 1.3431-3 3-3h6c1.6569 0 3 1.3431 3 3v9H3zm15 0c0-1.6569 1.3431-3 3-3h6c1.6569 0 3 1.3431 3 3v9H18zm15 0c0-1.6569 1.3431-3 3-3h6c1.6569 0 3 1.3431 3 3v9H33zM17.5 34h13v1c0 1.6569-1.3431 3-3 3h-7c-1.6569 0-3-1.3431-3-3zm15 0h13v1c0 1.6569-1.3431 3-3 3h-7c-1.6569 0-3-1.3431-3-3zm-30 0h13v1c0 1.6569-1.3431 3-3 3h-7c-1.6568 0-3-1.3431-3-3zM5 13c0-1.1046.8954-2 2-2h4c1.1046 0 2 .8954 2 2v5H5zm15 0c0-1.1046.8954-2 2-2h4c1.1046 0 2 .8954 2 2v5h-8zm15 0c0-1.1046.8954-2 2-2h4c1.1046 0 2 .8954 2 2v5h-8z"
      key="0"
    />,
    <rect
      width="46"
      height="3"
      x="1"
      y="40"
      fill="currentColor"
      rx="1.5"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M22.5 38h3v3h-3zm15 0h3v3h-3zm-30 0h3v3h-3zM6 6c0-1.1046.8954-2 2-2h2c1.1046 0 2 .8954 2 2v3H6zm15 0c0-1.1046.8954-2 2-2h2c1.1046 0 2 .8954 2 2v3h-6zm15 0c0-1.1046.8954-2 2-2h2c1.1046 0 2 .8954 2 2v3h-6z"
      key="2"
    />,
  ],
  'SeatGroup',
  48
);

export const SeatMoveIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 41h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3zm18 0h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3zm8.1055-17.7891c.4359-1.5983 2.0852-2.5411 3.6836-2.1054 1.5981.436 2.5411 2.0853 2.1054 3.6836l-2.3974 8.79c-.712 2.6099-3.0828 4.4206-5.7881 4.4209H12.291c-2.7054-.0002-5.076-1.8109-5.788-4.4209l-2.3975-8.79c-.4358-1.5984.507-3.2477 2.1054-3.6836 1.5983-.4356 3.2477.5072 3.6836 2.1054L12.291 32h23.418zM32.2852 3a4 4 0 0 1 1.1865.1797L23 11.0342l12.9541 9.7148a6 6 0 0 0-.7432 1.6729L33.417 29H14.583l-1.7939-6.5781c-.3257-1.194-.9902-2.2052-1.8614-2.958l.7979-12.7598C11.8805 4.6155 13.6205 3 15.7148 3z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m47 11.0339-6.7119 5.0339V6zm-18.9999 0 6.7118 5.0339V6z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'SeatMove',
  48
);

export const SeatPriceIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 41h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3zm18 0h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3zM6.211 21.1055c1.5982-.4356 3.2476.5072 3.6835 2.1054L12.291 32h23.418l2.3965-8.7891a3 3 0 0 1 .0732-.2304c1.7113-.0916 3.3306-.5273 4.791-1.2393.8384.7324 1.2372 1.9019.9248 3.0479l-2.3974 8.79c-.712 2.6099-3.0828 4.4206-5.7881 4.4209H12.291c-2.7054-.0002-5.076-1.8109-5.788-4.4209l-2.3975-8.79c-.4358-1.5984.507-3.2477 2.1054-3.6836M27.5 3C25.9306 5.0892 25 7.6858 25 10.5c0 6.088 4.3524 11.1582 10.1152 12.2715L33.417 29H14.583l-1.7939-6.5781c-.3257-1.194-.9902-2.2052-1.8614-2.958l.7979-12.7598C11.8805 4.6155 13.6205 3 15.7148 3z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M37.5 20c-5.2467 0-9.5-4.2533-9.5-9.5S32.2533 1 37.5 1 47 5.2533 47 10.5 42.7467 20 37.5 20M39 6.5h-3v8h3z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'SeatPrice',
  48
);

export const SeatRankingIcon = createSvgIcon(
  [
    <path fill="currentColor" d="m40 8-3-7-3 7-7 3 7 3 3 7 3-7 7-3z" key="0" />,
    <path
      fill="currentColor"
      d="M32.2852 3c.1951 0 .3872.0139.5752.041l-1.1456 2.6738-5.8964 2.5274a3.0006 3.0006 0 0 0 0 5.5156l5.8964 2.5264 2.5274 5.8974c.1744.4069.432.761.748 1.0459L33.417 29H14.583l-1.7939-6.5781c-.3257-1.1941-.9902-2.2051-1.8614-2.958l.7979-12.7598C11.8805 4.6155 13.6205 3 15.7148 3z"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M38.1054 23.211c.4359-1.5984 2.0852-2.5412 3.6836-2.1055 1.5983.4359 2.5412 2.0852 2.1054 3.6836l-2.3974 8.79c-.7121 2.61-3.0827 4.4207-5.7881 4.4209h-23.418c-2.7054-.0002-5.076-1.8108-5.788-4.4209l-2.3975-8.79c-.4358-1.5984.507-3.2477 2.1054-3.6836 1.5984-.4357 3.2477.5071 3.6836 2.1055L12.291 32h23.418zM12 41h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3zm18 0h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3z"
      key="2"
    />,
  ],
  'SeatRanking',
  48
);

export const SeatRemoveIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 41h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3zm18 0h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3zM6.211 21.1055c1.5982-.4356 3.2476.5072 3.6835 2.1054L12.291 32h23.418l2.3965-8.7891a3 3 0 0 1 .0732-.2304c1.7113-.0916 3.3306-.5273 4.791-1.2393.8384.7324 1.2372 1.9019.9248 3.0479l-2.3974 8.79c-.712 2.6099-3.0828 4.4206-5.7881 4.4209H12.291c-2.7054-.0002-5.076-1.8109-5.788-4.4209l-2.3975-8.79c-.4358-1.5984.507-3.2477 2.1054-3.6836M27.5 3C25.9306 5.0892 25 7.6858 25 10.5c0 6.088 4.3524 11.1582 10.1152 12.2715L33.417 29H14.583l-1.7939-6.5781c-.3257-1.194-.9902-2.2052-1.8614-2.958l.7979-12.7598C11.8805 4.6155 13.6205 3 15.7148 3z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M47 10.5c0 5.2467-4.2533 9.5-9.5 9.5S28 15.7467 28 10.5 32.2533 1 37.5 1 47 5.2533 47 10.5M32.5 9v3h10V9z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'SeatRemove',
  48
);

export const SeatTimeIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 41h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3zm18 0h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3zM6.211 21.1055c1.5982-.4356 3.2476.5072 3.6835 2.1054L12.291 32h23.418l2.3965-8.7891a3 3 0 0 1 .0732-.2304c1.7113-.0916 3.3306-.5273 4.791-1.2393.8384.7324 1.2372 1.9019.9248 3.0479l-2.3974 8.79c-.712 2.6099-3.0828 4.4206-5.7881 4.4209H12.291c-2.7054-.0002-5.076-1.8109-5.788-4.4209l-2.3975-8.79c-.4358-1.5984.507-3.2477 2.1054-3.6836M27.5 3C25.9306 5.0892 25 7.6858 25 10.5c0 6.088 4.3524 11.1582 10.1152 12.2715L33.417 29H14.583l-1.7939-6.5781c-.3257-1.194-.9902-2.2052-1.8614-2.958l.7979-12.7598C11.8805 4.6155 13.6205 3 15.7148 3z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M37.5 20c5.2467 0 9.5-4.2533 9.5-9.5S42.7467 1 37.5 1 28 5.2533 28 10.5s4.2533 9.5 9.5 9.5M39 5.5h-3v5.7719l5.3487 3.8206 1.7438-2.4412L39 9.7281z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'SeatTime',
  48
);

export const SeatIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M32.2852 3c2.0943 0 3.8343 1.6155 3.9892 3.7041l.7969 12.7598c-.8709.7528-1.5348 1.7642-1.8604 2.958L33.417 29H14.583l-1.7939-6.5781c-.3257-1.1941-.9902-2.2051-1.8614-2.958l.7979-12.7598C11.8805 4.6155 13.6205 3 15.7148 3z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M38.1054 23.211c.4359-1.5984 2.0852-2.5412 3.6836-2.1055 1.5983.4359 2.5412 2.0852 2.1054 3.6836l-2.3974 8.79c-.7121 2.61-3.0827 4.4207-5.7881 4.4209h-23.418c-2.7054-.0002-5.076-1.8108-5.788-4.4209l-2.3975-8.79c-.4358-1.5984.507-3.2477 2.1054-3.6836 1.5984-.4357 3.2477.5071 3.6836 2.1055L12.291 32h23.418zM12 41h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3zm18 0h6v3c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3z"
      key="1"
    />,
  ],
  'Seat',
  48
);

export const SecureWalletIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M34 4c2.7614 0 5 2.2386 5 5h-3v-.5c0-.8284-.6716-1.5-1.5-1.5h-25C8.1193 7 7 8.1193 7 9.5S8.1193 12 9.5 12H38c3.3137 0 6 2.6863 6 6v20c0 3.3137-2.6863 6-6 6H19.1074C20.2267 42.424 21 40.524 21 38.2812V26.9131c-.0253-.0052-6.679-1.375-11-1.375-1.8103 0-4.0298.2417-6 .5215V9c0-2.7614 2.2386-5 5-5zm.959 19C32.22 23.0001 30 25.2384 30 28s2.22 4.9999 4.959 5H41V23z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M18 38.1949v-8.2678s-4.8515-1-8-1-8 1-8 1v8.2678c0 3.1011 2.032 5.3011 3.964 6.6941.9731.7017 1.9435 1.2158 2.669 1.5543.4465.2083.9009.398 1.367.5567.4661-.1587.9205-.3484 1.367-.5567.7255-.3385 1.6959-.8526 2.6691-1.5543C15.968 43.496 18 41.296 18 38.1949"
      key="1"
    />,
  ],
  'SecureWallet',
  48
);

export const SecurityGateIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 1h34v43h-3V4H10v40H7z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M24 16c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4m4.1545 30h-8.3081l-1.5228-13.5333L15 30.6583l1.3676-8.9331c.1978-1.2894 1.0104-2.3653 2.1404-2.8084C19.7394 18.434 22.0657 18 24.0016 18c.9639 0 3.4048.1085 5.4322.8933 1.1483.4449 1.9991 1.5244 2.1985 2.8319L33 30.6583l-3.3236 1.8084z"
      key="1"
    />,
  ],
  'SecurityGate',
  48
);

export const SelectAreaIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m32.9431 35.0568 2.1254-2.1173.004.004 9.0566 9.0566-2.1213 2.1214z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m27.5161 41.8982 14.3823-14.3823-20.3747-5.9927zM7 15v7.5H4V15zm37 0v7.5h-3V15zM7 25.5V33H4v-7.5zM33 7h-7.5V4H33zM22.5 7H15V4h7.5zm0 37H15v-3h7.5zM4 8c0-2.2091 1.7909-4 4-4h4v3H8c-.5523 0-1 .4477-1 1v4H4zm0 32c0 2.2091 1.7909 4 4 4h4v-3H8c-.5523 0-1-.4477-1-1v-4H4zM44 8c0-2.2091-1.7909-4-4-4h-4v3h4c.5523 0 1 .4477 1 1v4h3z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'SelectArea',
  48
);

export const ServerIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 28v-8h3v8zm27 0v-8h3v8z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 8c0-2.2091 1.7909-4 4-4h32c2.2091 0 4 1.7909 4 4v10c0 2.2091-1.7909 4-4 4H8c-2.2091 0-4-1.7909-4-4zm5 7v3h7v-3zm20 0c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2m9.0032-2.0001c.0018 1.1046-.8922 2.0015-1.9968 2.0032s-2.0014-.8922-2.0032-1.9968.8922-2.0014 1.9968-2.0032c1.1046-.0017 2.0014.8922 2.0032 1.9968M4 30c0-2.2091 1.7909-4 4-4h32c2.2091 0 4 1.7909 4 4v10c0 2.2091-1.7909 4-4 4H8c-2.2091 0-4-1.7909-4-4zm5 7v3h7v-3zm20 0c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2m9.0032-2.0001c.0018 1.1046-.8922 2.0015-1.9968 2.0032s-2.0014-.8922-2.0032-1.9968.8922-2.0014 1.9968-2.0032c1.1046-.0017 2.0014.8922 2.0032 1.9968"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Server',
  48
);

export const ShieldUserIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m24 2.7046.6357.5235c4.5957 3.7847 10.6976 3.778 15.7859 3.7724Q40.7131 7 41 7h1v18.4286c0 6.9123-4.5719 11.816-8.9188 14.9209-2.1897 1.5641-4.373 2.71-6.0054 3.4645-1.0046.4643-2.027.8872-3.0758 1.241-1.0488-.3538-2.0712-.7767-3.0758-1.241-1.6324-.7545-3.8157-1.9004-6.0054-3.4645C10.5719 37.2446 6 32.3409 6 25.4286V7h1q.2868.0001.5784.0005c5.0883.0056 11.1902.0123 15.7859-3.7724zM24.0002 31c4.0231 0 7.6885 1.5335 10.4428 4.0458-.9206.9301-1.9047 1.7471-2.8752 2.4543-1.8249 1.3296-3.6442 2.3036-5.0046 2.945-.8371.3947-1.6892.7542-2.5631 1.0549-.874-.3007-1.726-.6602-2.5632-1.0549-1.3604-.6414-3.1797-1.6154-5.0045-2.945-.9706-.7072-1.9546-1.5241-2.8751-2.4542C16.3115 32.5336 19.977 31 24.0002 31m-.0001-3c3.5898 0 6.5-2.9101 6.5-6.5s-2.9102-6.5-6.5-6.5c-3.5899 0-6.5 2.9101-6.5 6.5s2.9101 6.5 6.5 6.5"
    clipRule="evenodd"
  />,
  'ShieldUser',
  48
);

export const SignLanguageIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="m19.2545 35.8382 3.3299-2.3238a2.373 2.373 0 0 1 2.8389.0912c1.138.9081 1.1977 2.6173.1258 3.6027l-3.6381 3.3443c-.5652.6172-1.2498 1.0563-2.005 1.3656-4.6006 1.8843-10.507 2.3098-14.8234-.1568L2 40l4.5-5 .2544-6.574a5.84 5.84 0 0 1 1.9341-4.1191l9.6273-8.9415c.8582-.7703 2.1412-.8268 3.0638-.1349 1.2376.9282 1.2962 2.7642.1204 3.7695L14 25.7675l.0526.0746c5.2494-1.8859 8.4393-.8106 12.0271 2.6138.8688.8292.8222 2.2113-.0391 3.0482-.8062.7833-2.075.838-3.0436.2677-1.4647-.8626-3.3074-1.6756-4.5971-1.7718-2.588-.193-4.2653 2.0635-3.3923 4.4333.6202 1.6833 2.6947 2.3696 4.2469 1.4049m-8.5504-24.3109c1.3348.0002 2.3671 1.1708 2.2002 2.4952l-.3887 2.8173-4.9345 4.4297L8.5 13.5c.1249-1.123 1.0741-1.9727 2.2041-1.9727"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M29.9995 3c5.4415 0 9.581 4.7802 8.6865 10.0312l-.9053 5.3126c-.3642 2.1372-1.6053 3.9465-3.3261 5.0996 0 .8257-.2843 2.2436.3408 2.915 1.299 1.3941 5.3994 2.9917 8.1875 3.9883 1.2046.4306 2.0164 1.5616 2.0166 2.8408V36H29.2886c.1021-1.0303-.0924-2.0833-.5782-3.0186 1.3728-1.8949 1.3996-4.6264-.3613-6.496a14 14 0 0 0-.3633-.3555c-1.5945-1.5551-3.3219-2.9382-4.5762-4.8135l.0997-.0889c2.4923-2.1931 2.4293-6.078-.0782-8.1963-.6594-.5265-1.4059-.9351-2.2314-1.1337C21.0292 7.1119 24.953 3.0003 29.9995 3"
      key="1"
    />,
  ],
  'SignLanguage',
  48
);

export const SparksIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M25 14a1 1 0 0 0-1-1 9.01 9.01 0 0 1-6.361-2.639A9.01 9.01 0 0 1 15 4a1.0002 1.0002 0 0 0-1.7071-.7071A1 1 0 0 0 13 4a9.01 9.01 0 0 1-2.639 6.361A9.01 9.01 0 0 1 4 13a1.0002 1.0002 0 0 0-.7071 1.7071C3.4804 14.8946 3.7348 15 4 15a9.01 9.01 0 0 1 6.361 2.639A9.01 9.01 0 0 1 13 24a1.0001 1.0001 0 0 0 2 0 9.01 9.01 0 0 1 2.639-6.361A9.01 9.01 0 0 1 24 15a1 1 0 0 0 1-1m19 19a9.01 9.01 0 0 1-6.361-2.639A9.01 9.01 0 0 1 35 24a1.0001 1.0001 0 0 0-2 0 9.01 9.01 0 0 1-2.639 6.361A9.01 9.01 0 0 1 24 33a1.0001 1.0001 0 0 0 0 2 9.01 9.01 0 0 1 6.361 2.639A9.01 9.01 0 0 1 33 44a1.0001 1.0001 0 0 0 2 0 9.01 9.01 0 0 1 2.639-6.361A9.01 9.01 0 0 1 44 35a1.0001 1.0001 0 0 0 0-2m-28 4a5.0063 5.0063 0 0 1-5-5 1.0001 1.0001 0 0 0-2 0 5.006 5.006 0 0 1-5 5 1.0002 1.0002 0 0 0-.7071 1.7071C3.4804 38.8946 3.7348 39 4 39a5.006 5.006 0 0 1 5 5 1 1 0 1 0 2 0 5.0063 5.0063 0 0 1 5-5 1.0001 1.0001 0 0 0 0-2m16-26a5.0063 5.0063 0 0 1 5 5 1.0001 1.0001 0 0 0 2 0 5.0063 5.0063 0 0 1 5-5 1.0001 1.0001 0 0 0 0-2 5.006 5.006 0 0 1-5-5 1.0002 1.0002 0 0 0-1.7071-.7071A1 1 0 0 0 37 4a5.006 5.006 0 0 1-5 5 1 1 0 1 0 0 2"
  />,
  'Sparks',
  48
);

export const SquareSlidersIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M10 4c-3.3137 0-6 2.6863-6 6v28c0 3.3137 2.6863 6 6 6h28c3.3137 0 6-2.6863 6-6V10c0-3.3137-2.6863-6-6-6zm23.7092 11.5C33.1159 16.9659 31.6787 18 30 18c-2.2091 0-4-1.7909-4-4s1.7909-4 4-4c1.6787 0 3.1159 1.0341 3.7092 2.5h4.2907v3zM10 12.5h12v3H10zM30 38c1.6787 0 3.1159-1.0341 3.7092-2.5h4.2907v-3h-4.2907C33.1159 31.0341 31.6787 30 30 30c-2.2091 0-4 1.7909-4 4s1.7909 4 4 4m-20-5.5h12v3H10zm7.9999-4.5c-1.6787 0-3.1159-1.0341-3.7092-2.5H10v-3h4.2907c.5933-1.4659 2.0305-2.5 3.7092-2.5 2.2091 0 4 1.7909 4 4s-1.7909 4-4 4m20-5.5h-12v3h12z"
    clipRule="evenodd"
  />,
  'SquareSliders',
  48
);

export const StackAddIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 8h30v3H9zm6-6h18v3H15z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M46 28.8936c-2.1346-1.8746-4.931-3.0137-7.9951-3.0137-6.6964 0-12.125 5.4286-12.125 12.125 0 2.1815.5795 4.2266 1.5879 5.9951H2V14h44z"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M47.5049 38.005c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5 4.2533-9.5 9.5-9.5 9.5 4.2533 9.5 9.5m-8-5h-3v3.5h-3.5v3h3.5v3.5h3v-3.5h3.5v-3h-3.5z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'StackAdd',
  48
);

export const StackCheckIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 8h30v3H9zm6-6h18v3H15z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M46 28.8936c-2.1346-1.8746-4.931-3.0137-7.9951-3.0137-6.6964 0-12.125 5.4286-12.125 12.125 0 2.1815.5795 4.2266 1.5879 5.9951H2V14h44z"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M47.5 38.5c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5S32.7533 29 38 29s9.5 4.2533 9.5 9.5m-3.8811-2.6009-2.2198-2.018-4.9508 5.4459L34 36.8787 31.8787 39l4.673 4.673z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'StackCheck',
  48
);

export const StackEditIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 8h30v3H9zm6-6h18v3H15z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M46 24.6777c-2.8111-1.2721-6.2352-.7531-8.5459 1.5577L24.6035 39.0869 24.1865 44H2V14h44z"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M39.5759 28.3568c1.8091-1.8091 4.7422-1.8091 6.5513 0s1.809 4.7422 0 6.5513l-12.076 12.0761-7.1594.6079.6081-7.1593z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'StackEdit',
  48
);

export const StackMoveIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 8h30v3H9zm6-6h18v3H15z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m46 35.5332-8.2881-6.2158V29l-.2119.1582L37.2881 29v.3174L23 40.0342 28.2881 44H2V14h44z"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m28.0001 40.0339 6.7118 5.0339V35zm18.9999 0-6.7119 5.0339V35z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'StackMove',
  48
);

export const StackRefreshIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 8h30v3H9zm6-6h18v3H15z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M46 28.8936c-2.1346-1.8746-4.931-3.0137-7.9951-3.0137-6.6964 0-12.125 5.4286-12.125 12.125 0 2.1815.5795 4.2266 1.5879 5.9951H2V14h44z"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M32.5 47.5v-4h4v-3h-7v7z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M29.7785 42.7624a10 10 0 0 1-.1462-.2614l2.6291-1.4448.1226.2189c1.1295 1.932 3.2229 3.2249 5.6161 3.2249 3.3136 0 6.05-2.4808 6.4497-5.6856l.1856-1.4885 2.9769.3712-.1856 1.4885c-.5845 4.6878-4.5809 8.3144-9.4266 8.3144-2.9761 0-5.631-1.3689-7.3716-3.5074l-.1223.0685zm1.5864-4.0883.1856-1.4885c.3996-3.2048 3.1361-5.6856 6.4496-5.6856 2.4182 0 4.5303 1.32 5.6511 3.2854l.084.1517 2.6327-1.4381a9 9 0 0 0-.1001-.1811l-.7227-1.3054-.117.0648c-1.7394-2.1786-4.4196-3.5773-7.428-3.5773-4.8457 0-8.842 3.6266-9.4266 8.3144l-.1856 1.4885z"
      clipRule="evenodd"
      key="3"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M43.5 28.5v4h-4v3h7v-7z"
      clipRule="evenodd"
      key="4"
    />,
  ],
  'StackRefresh',
  48
);

export const StackRemoveIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 8h30v3H9zm6-6h18v3H15z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M46 28.8936c-2.1346-1.8746-4.931-3.0137-7.9951-3.0137-6.6964 0-12.125 5.4286-12.125 12.125 0 2.1815.5795 4.2266 1.5879 5.9951H2V14h44z"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M47.5 38.5c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5S32.7533 29 38 29s9.5 4.2533 9.5 9.5M33 37v3h10v-3z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'StackRemove',
  48
);

export const StackIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M9 8h30v3H9zm6-6h18v3H15zM2 14h44v30H2z"
    clipRule="evenodd"
  />,
  'Stack',
  48
);

export const StageCurtainsIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M46.0007 28.334c-.9286.7305-2.2773 1.6176-3.8575 2.0127-1.4428.3607-3.1149.3234-4.9384-.7197-3.0374-1.7617-4.8515-4.8524-5.8975-8.4063-.5627-1.912-.9137-3.9921-1.1152-6.1348.2783-.1902.5485-.3912.8076-.6054 1.8999 1.5707 4.3373 2.5194 7 2.5195 3.1538 0 5.9953-1.3297 8.001-3.4561zM2 28.334c.9286.7305 2.2773 1.6176 3.8574 2.0127 1.4429.3607 3.115.3234 4.9385-.7197 3.0374-1.7617 4.8515-4.8524 5.8975-8.4063.5627-1.912.9137-3.9921 1.1152-6.1348a11 11 0 0 1-.8076-.6054c-1.8999 1.5707-4.3373 2.5194-7 2.5195C6.8472 17 4.0057 15.6703 2 13.5439zM46.0007 42H33.0359v-1.1084c0-3.1095.8541-6.1479 2.4521-8.792 2.6392 1.5919 5.2034 1.702 7.3828 1.1572 1.1834-.2958 2.2389-.7816 3.1299-1.2988zM2 42h12.9648v-1.1084c0-3.1095-.8541-6.1479-2.4521-8.792-2.6392 1.5919-5.2034 1.702-7.3828 1.1572C3.9464 32.961 2.891 32.4752 2 31.958z"
      key="0"
    />,
    <path fill="currentColor" d="M43 6h3v36h-3zM2 6h3v36H2z" key="1" />,
    <path
      fill="currentColor"
      d="M46 6c0 4.4183-3.5817 8-8 8-3.0133 0-5.6357-1.6669-7-4.128C29.6357 12.3332 27.0133 14 24 14s-5.6357-1.6669-7-4.128C15.6357 12.3332 13.0133 14 10 14c-4.4183 0-8-3.5817-8-8z"
      key="2"
    />,
  ],
  'StageCurtains',
  48
);

export const StatisticsIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m17.0608 9.0607-6 6-2.1213-2.1214 5.9999-6zm8.8784 6-6-6 2.1214-2.1214 6 6zm13.1214-6-6 6-2.1214-2.1214 6-6z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 14.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5S9 16.8284 9 16s-.6716-1.5-1.5-1.5M3 16c0-2.4853 2.0147-4.5 4.5-4.5S12 13.5147 12 16s-2.0147 4.5-4.5 4.5S3 18.4853 3 16m26.5-1.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5S31 16.8284 31 16s-.6716-1.5-1.5-1.5M25 16c0-2.4853 2.0147-4.5 4.5-4.5S34 13.5147 34 16s-2.0147 4.5-4.5 4.5S25 18.4853 25 16M18.5 4.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5S20 6.8284 20 6s-.6716-1.5-1.5-1.5M14 6c0-2.4853 2.0147-4.5 4.5-4.5S23 3.5147 23 6s-2.0147 4.5-4.5 4.5S14 8.4853 14 6m26.5-1.5c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5S42 6.8284 42 6s-.6716-1.5-1.5-1.5M36 6c0-2.4853 2.0147-4.5 4.5-4.5S45 3.5147 45 6s-2.0147 4.5-4.5 4.5S36 8.4853 36 6"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M4 34h7v10H4zm22 0h7v10h-7zM15 20h7v24h-7zm22 0h7v24h-7z"
      key="2"
    />,
  ],
  'Statistics',
  48
);

export const SurfaceIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.909 24c2.2001 3.0277 5.0841 5 9.091 5s6.8909-1.9723 9.0911-5l.7671 1.0561c1.0114 1.3923 2.2925 2.5027 3.7351 3.2597 1.3849.7268 3.842.6848 5.4974.6844L44 29v12.9998L43.0912 42c-1.8488.0005-4.6681-.4427-6.4333-1.3691-1.3486-.7076-2.5542-1.6633-3.5671-2.8125-2.2642 2.5681-5.5837 4.1814-9.0908 4.1814s-6.8265-1.6133-9.0908-4.1814c-1.0129 1.1492-2.2185 2.1049-3.567 2.8125-1.7653.9264-4.5846 1.3696-6.4334 1.3691L4 41.9998V29l.9093.0002c1.6554.0004 4.1125.0424 5.4975-.6844 1.4425-.757 2.7236-1.8674 3.735-3.2597z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.909 6c2.2001 3.0277 5.0841 4.8529 9.091 4.8529S30.8909 9.0277 33.0911 6l.7671 1.0561c1.0114 1.3923 2.2925 2.5027 3.7351 3.2597 1.3849.7268 3.842 1.1429 5.4974 1.1425L44 11.458v12.5418L43.0912 24c-1.8488.0005-4.6681-.4427-6.4333-1.3691-1.3486-.7076-2.5542-1.6633-3.5671-2.8125-2.2642 2.5681-5.5837 4.1814-9.0908 4.1814s-6.8265-1.6133-9.0908-4.1814c-1.0129 1.1492-2.2185 2.1049-3.567 2.8125-1.7653.9264-4.5846 1.3696-6.4334 1.3691L4 23.9998V11.458l.9093.0003c1.6554.0004 4.1125-.4157 5.4975-1.1425 1.4425-.757 2.7236-1.8674 3.735-3.2597z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Surface',
  48
);

export const TableRowsColsIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M44 38c0 3.3137-2.6863 6-6 6H10a6 6 0 0 1-.6135-.031C6.361 43.6618 4 41.1066 4 38V10c0-1.5367.5777-2.9385 1.5278-4a6 6 0 0 1 .5457-.5369C7.1258 4.5516 8.4985 4 10 4h28c3.3137 0 6 2.6863 6 6zM19 12V7h-3v5H7v3h9v7.5H7v3h9V33H7v3h9v5h3v-5h22v-3H19v-7.5h22v-3H19V15h22v-3z"
    clipRule="evenodd"
  />,
  'TableRowsCols',
  48
);

export const TabletMobileFilledIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M39 20c2.7614 0 5 2.2386 5 5v16c0 2.7614-2.2386 5-5 5H29c-2.7614 0-5-2.2386-5-5V25c0-2.7614 2.2386-5 5-5zm-7.5 20c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5h5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5z"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M10 2C6.6863 2 4 4.6863 4 8v26c0 3.3137 2.6863 6 6 6h11V25c0-4.4183 3.5817-8 8-8h6V8c0-3.3137-2.6863-6-6-6z"
      key="1"
    />,
  ],
  'TabletMobileFilled',
  48
);

export const TabletMobileIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 38c-3.3137 0-6-2.6863-6-6V10c0-3.3137 2.6863-6 6-6h26c3.3137 0 6 2.6863 6 6v4h-3v-4c0-1.6569-1.3431-3-3-3H10c-1.6569 0-3 1.3431-3 3v22c0 1.6569 1.3431 3 3 3h12v3z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M31.5 23.25c0-.6904.5596-1.25 1.25-1.25h3.5c.6904 0 1.25.5596 1.25 1.25s-.5596 1.25-1.25 1.25h-3.5c-.6904 0-1.25-.5596-1.25-1.25M9 21c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M44 21c0-2.2091-1.7909-4-4-4H29c-2.2091 0-4 1.7909-4 4v20c0 2.2091 1.7909 4 4 4h11c2.2091 0 4-1.7909 4-4zm-15-1h11c.5523 0 1 .4477 1 1v20c0 .5523-.4477 1-1 1H29c-.5523 0-1-.4477-1-1V21c0-.5523.4477-1 1-1"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'TabletMobile',
  48
);

export const TagClockIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M36 20.5c5.2467 0 9.5-4.2533 9.5-9.5S41.2467 1.5 36 1.5s-9.5 4.2533-9.5 9.5 4.2533 9.5 9.5 9.5M37.5 6h-3v5.7719l5.3487 3.8206 1.7438-2.4412L37.5 10.2281z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.1645 4.7634 24.4226 4H4v20.4226l18.6762 18.1518c2.3523 2.2863 6.1048 2.2596 8.4244-.06l11.4138-11.4137c2.3196-2.3196 2.3463-6.0721.06-8.4245l-.6486-.6673C40.1623 22.9601 38.1442 23.5 36 23.5c-6.9036 0-12.5-5.5964-12.5-12.5 0-2.2713.6058-4.401 1.6645-6.2366M17 21c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'TagClock',
  48
);

export const TagIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M2 2h21.2132l20.9583 20.9583c2.3431 2.3431 2.3431 6.1421 0 8.4853l-12.728 12.728c-2.3432 2.3431-6.1421 2.3431-8.4853 0L18 39.2133V19.0004c1.2144-.9122 2-2.3646 2-4.0004 0-2.7614-2.2386-5-5-5s-5 2.2386-5 5 2.2386 5 5 5v26h-3V33.2133L2 23.2132z"
  />,
  'Tag',
  48
);

export const TextbookIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M36 2c3.3137 0 6 2.6863 6 6v32c0 3.3137-2.6863 6-6 6H14V2zM21 5v15.8682l7-4.667 7 4.667V5zM11 46H6V2h5z"
  />,
  'Textbook',
  48
);

export const TheaterIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M14 11.3516a8.25 8.25 0 0 0 1.0693.6709c-.1801 3.6885-1.2131 6.6119-3.1474 8.3662-1.108.9349-2.6026 1.3282-4.1006 1.2802C6.1725 21.6161 4.73 21.0376 4 20.3271v-8.9755C5.4127 12.4011 7.184 13 9 13s3.5873-.5989 5-1.6484m20 0a8.25 8.25 0 0 1-1.0693.6709c.1801 3.6885 1.2131 6.6119 3.1474 8.3662 1.108.9349 2.6026 1.3282 4.1006 1.2802 1.6488-.0528 3.0913-.6313 3.8213-1.3418v-8.9755C42.5873 12.4011 40.816 13 39 13s-3.5873-.5989-5-1.6484M24 5.5c0 2.4853-2.2386 4.5-5 4.5s-5-2.0147-5-4.5c0 2.4853-2.2386 4.5-5 4.5S4 7.9853 4 5.5V5h40v.5c0 2.4853-2.2386 4.5-5 4.5s-5-2.0147-5-4.5c0 2.4853-2.2386 4.5-5 4.5s-5-2.0147-5-4.5M26 44v-2c0-1.1046.8954-2 2-2h3c1.1046 0 2 .8954 2 2v2zm-5.5-8v-2c0-1.1046.8954-2 2-2h3c1.1046 0 2 .8954 2 2v2zm-11 0v-2c0-1.1046.8954-2 2-2h3c1.1046 0 2 .8954 2 2v2zm22 0v-2c0-1.1046.8954-2 2-2h3c1.1046 0 2 .8954 2 2v2zm5.5 8v-2c0-1.1046.8954-2 2-2h3c1.1046 0 2 .8954 2 2v2zm-22 0v-2c0-1.1046.8954-2 2-2h3c1.1046 0 2 .8954 2 2v2zM4 44v-2c0-1.1046.8954-2 2-2h3c1.1046 0 2 .8954 2 2v2zm8.583-21.6113a11.99 11.99 0 0 1 .8457 4.4189V28H4v-5.2607c1.0918.5602 2.4234.8859 3.7568.9287 1.6135.0516 3.3604-.3058 4.8262-1.2793m22.834 0a11.99 11.99 0 0 0-.8457 4.4189V28H44v-5.2607c-1.0918.5602-2.4234.8859-3.7568.9287-1.6134.0516-3.3604-.3058-4.8262-1.2793"
  />,
  'Theater',
  48
);

export const TheatreMasksIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M22.5 23H16c0 3.6978 2.8674 6.724 6.5 6.9805v7.9746c-5.0594-.3042-9.3971-2.1542-12.5762-5.2627-3.4898-3.4125-5.509-8.27-5.6142-14.0518L3.9824 5.1729l.7022-.2335C9.9112 3.2002 15.335 2.235 22.5 2.0313zm-7-11.5c-1.2262 0-2.457.3373-3.4141 1.1055C11.0933 13.4023 10.5 14.5849 10.5 16v1h3v-1c0-.5175.1901-.8348.4639-1.0547.3097-.2486.8293-.4453 1.5361-.4453s1.2264.1967 1.5361.4453c.2738.2199.4639.5372.4639 1.0547v1h3v-1c0-1.4151-.5933-2.5977-1.5859-3.3945C17.957 11.8373 16.7262 11.5 15.5 11.5m10-1.5c7.1649.2037 12.5888 1.169 17.8154 2.9082l.7022.2334-.3272 13.4678c-.1051 5.7817-2.1244 10.6393-5.6142 14.0517-3.1791 3.1085-7.5168 4.9585-12.5762 5.2627V33.5186c2.9892.2134 5 2.323 5 4.4814v1h3v-1c0-4.1878-3.7346-7.2619-8-7.4863zM29 26h7v-3h-7z"
    clipRule="evenodd"
  />,
  'TheatreMasks',
  48
);

export const TicketDesignIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path
        fillRule="evenodd"
        d="M32.0563 36.3891C31.4507 35.1498 31 33.7908 31 32.4569 31 27.6909 34.6216 25 38 25s7 2.6909 7 7.4569c0 1.3312-.4509 2.6887-1.0563 3.9271-.6108 1.2493-1.4147 2.4498-2.2018 3.4852-.7893 1.0384-1.5763 1.9298-2.1649 2.5608-.508.5448-1.0389 1.0596-1.577 1.57-.5377-.51-1.0685-1.0239-1.5766-1.5677-.5886-.6302-1.3757-1.5204-2.1651-2.5581-.7872-1.0348-1.5913-2.2351-2.202-3.4851"
        clipRule="evenodd"
      />
      <path d="M41.0615 22.5036 43.0426 9.897C43.5293 6.7998 41.1351 4 37.9999 4s-5.5295 2.8-5.0428 5.8972l1.981 12.6065C35.9346 22.1718 36.9715 22 38 22c1.0284 0 2.0651.1717 3.0615.5036M30.5107 6a8.03 8.03 0 0 0-.6171 3H6v6.5996c3.5735 1.2018 6.0342 4.564 6.0342 8.4004S9.5734 31.1975 6 32.3994V39h24.0576c.5767.9866 1.2114 1.8989 1.8135 2.6904.0797.1048.1599.2078.2393.3096H5c-1.1046 0-2-.8954-2-2v-9.9473l1.4648-.332c2.6721-.6049 4.5694-2.98 4.5694-5.7207s-1.8973-5.1158-4.5694-5.7207L3 17.9473V8c0-1.1046.8954-2 2-2zM49 28.4688a5.84 5.84 0 0 0 2.498 1.2451l1.502.3379V40c0 1.1046-.8954 2-2 2h-2v-3h1v-6.5938a8.8 8.8 0 0 1-1-.3994zM51 6c1.1046 0 2 .8954 2 2v9.9482l-1.502.3379A5.84 5.84 0 0 0 49 19.5303v-3.5391a8.8 8.8 0 0 1 1-.3984V9h-1V6z" />
      <circle cx="19.5" cy="38.5" r="1.5" />
      <circle cx="19.5" cy="32.5" r="1.5" />
      <circle cx="19.5" cy="26.5" r="1.5" />
      <circle cx="19.5" cy="20.5" r="1.5" />
      <circle cx="19.5" cy="14.5" r="1.5" />
      <circle cx="19.5" cy="8.5" r="1.5" />
    </g>,
    <defs key="1"></defs>,
  ],
  'TicketDesign',
  48
);

export const TicketSendIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M41.1586 17.1742 42 17.362V22c0 1.1046-.8954 2-2 2H16c-1.1046 0-2-.8954-2-2v-4.6375l.8202-.1842c1.4964-.336 2.5589-1.6557 2.5589-3.1783s-1.0625-2.8423-2.5589-3.1783L14 10.6375V6c0-1.1046.8954-2 2-2h24c1.1046 0 2 .8954 2 2v4.638l-.8414.1878c-1.4961.3338-2.5591 1.6523-2.5591 3.1742s1.063 2.8404 2.5591 3.1742"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m45.7412 37.7064-16.6705 6.7244a8.79 8.79 0 0 1-4.7524.4145L11 42.3122V31.1731l1.1727-1.0178C13.7763 28.7636 15.8089 28 17.9095 28c2.0777 0 4.0896.7471 5.6857 2.1113l.9048.7733h3.375c2.4838 0 4.4976 2.0639 4.5 4.6109v.5815h-9.5625v.5769l9.2199.9456c1.1519.1181 2.2032-.6794 2.4303-1.8437l.1623-.8327 10.3445-1.0381C46.0722 33.8221 47 34.7223 47 35.8549c0 .8268-.5024 1.5657-1.2588 1.8515M8 28v17H4V28z"
      key="1"
    />,
  ],
  'TicketSend',
  48
);

export const TicketShieldIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m35.0167 25.0877.9539.2122V31H12.5v-5.6995l.9299-.2082c1.6965-.3798 2.901-1.8713 2.901-3.5923s-1.2045-3.2125-2.901-3.5923l-.9299-.2082V12h23.4706v5.7001l-.9539.2122c-1.6962.3773-2.9013 1.8676-2.9013 3.5877s1.2051 3.2104 2.9013 3.5877"
      clipRule="evenodd"
      key="0"
    />,
    <path
      stroke="currentColor"
      strokeWidth="3"
      d="M42 25.724V7.2954s-10.7991-4-18-4-18 4-18 4V25.724c0 6.9123 4.5719 11.816 8.9188 14.9209 2.1897 1.5641 4.373 2.71 6.0054 3.4645 1.0046.4643 2.027.8872 3.0758 1.241 1.0488-.3538 2.0712-.7767 3.0758-1.241 1.6324-.7545 3.8157-1.9004 6.0054-3.4645C37.4281 37.54 42 32.6363 42 25.724Z"
      key="1"
    />,
  ],
  'TicketShield',
  48
);

export const TicketsSecureIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M16.0869 8A1.5 1.5 0 0 0 16 8.5c0 .8284.6716 1.5 1.5 1.5S19 9.3284 19 8.5a1.5 1.5 0 0 0-.0869-.5H43c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617 0 .2358.0168.4683.0498.6963-1.0307-.0956-2.0413-.1572-2.9492-.1572-4.3292 0-11 1.375-11 1.375v11.3671c0 .5971.0567 1.17.1582 1.7188h-7.2451c-.2061-.5823-.7602-1-1.4131-1s-1.207.4177-1.4131 1H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 27.2635 8.0684 25.2839 8.0684 23s-1.5934-4.2635-3.838-4.7676L3 17.9561V10c0-1.1046.8954-2 2-2zM17.5 31c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 2h34v3H7z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M45 36.195v-8.2678s-4.8515-1-8-1-8 1-8 1v8.2678c0 3.1011 2.032 5.3011 3.9639 6.6941.9732.7017 1.9436 1.2158 2.6691 1.5543.4465.2083.9009.398 1.367.5567.4661-.1587.9205-.3484 1.367-.5567.7255-.3385 1.6959-.8526 2.6691-1.5543C42.968 41.4961 45 39.2961 45 36.195"
      key="2"
    />,
  ],
  'TicketsSecure',
  48
);

export const TicketsSendIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m43.0001 18.3235-4.8053-3.0579 1.6106-2.531 6.1947 3.9421V19.5h-3zM5 18.3235l4.8053-3.0579-1.6106-2.531L2 16.6767V19.5h3z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="m24 30.0334 20.5039-11.7165L46 18v20c0 3.3137-2.6863 6-6 6H8c-3.3137 0-6-2.6863-6-6V18h1z"
      key="1"
    />,
    <path
      fill="currentColor"
      d="m30.4004 43-.3574-1.585c-.6355-2.8184-3.1459-4.8213-6.043-4.8213s-5.4075 2.0029-6.043 4.8213L17.5996 43H8V4h9.5986l.3516 1.545c.6396 2.819 3.1513 4.8202 6.0498 4.8202s5.4102-2.0013 6.0498-4.8203L30.4014 4H40v39zm2.3594-36c-1.2151 3.7682-4.7412 6.3652-8.7598 6.3652S16.4564 10.7681 15.2412 7H11v33h4.2363c1.1995-3.7889 4.7324-6.4063 8.7637-6.4063S31.5652 36.2109 32.7646 40H37V7z"
      key="2"
    />,
    <path fill="currentColor" d="M26 19h3v16h-3zm-7 16h3V19h-3z" key="3" />,
  ],
  'TicketsSend',
  48
);

export const TicketsIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M43 12c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617s1.5947 4.261 3.8389 4.7617L45 32.043V40c0 1.1046-.8954 2-2 2H18.9131c-.2061-.5823-.7602-1-1.4131-1s-1.207.4177-1.4131 1H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 31.2635 8.0684 29.2839 8.0684 27s-1.5934-4.2635-3.838-4.7676L3 21.9561V14c0-1.1046.8954-2 2-2h11.0869a1.5 1.5 0 0 0-.0869.5c0 .8284.6716 1.5 1.5 1.5s1.5-.6716 1.5-1.5a1.5 1.5 0 0 0-.0869-.5zM17.5 35c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 6h34v3H7z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Tickets',
  48
);

export const TicketsAddIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M43 8c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617 0 1.2627.4879 2.4319 1.3037 3.3096a12.13 12.13 0 0 0-3.1982-.4297c-6.6948 0-12.1223 5.4259-12.125 12.1201h-6.9668c-.2061-.5823-.7602-1-1.4131-1s-1.207.4177-1.4131 1H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 27.2635 8.0684 25.2839 8.0684 23s-1.5934-4.2635-3.838-4.7676L3 17.9561V10c0-1.1046.8954-2 2-2h11.0869A1.5 1.5 0 0 0 16 8.5c0 .8284.6716 1.5 1.5 1.5S19 9.3284 19 8.5a1.5 1.5 0 0 0-.0869-.5zM17.5 31c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5M45 28.043v.0615c-.0423-.03-.0842-.0604-.127-.0899zM17.5 25c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 2h34v3H7zm40.5049 36.0049c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5 4.2533-9.5 9.5-9.5 9.5 4.2533 9.5 9.5m-8-5h-3v3.5h-3.5v3h3.5v3.5h3v-3.5h3.5v-3h-3.5z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'TicketsAdd',
  48
);

export const TicketsAlertIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M43 8c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617 0 1.2627.4879 2.4319 1.3037 3.3096a12.13 12.13 0 0 0-3.1982-.4297c-6.6948 0-12.1223 5.4259-12.125 12.1201h-6.9668c-.2061-.5823-.7602-1-1.4131-1s-1.207.4177-1.4131 1H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 27.2635 8.0684 25.2839 8.0684 23s-1.5934-4.2635-3.838-4.7676L3 17.9561V10c0-1.1046.8954-2 2-2h11.0869A1.5 1.5 0 0 0 16 8.5c0 .8284.6716 1.5 1.5 1.5S19 9.3284 19 8.5a1.5 1.5 0 0 0-.0869-.5zM17.5 31c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5M45 28.043v.0615c-.0423-.03-.0842-.0604-.127-.0899zM17.5 25c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 2h34v3H7z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M38.0049 28.5049c5.2467 0 9.5 4.2533 9.5 9.5s-4.2533 9.5-9.5 9.5-9.5-4.2533-9.5-9.5 4.2533-9.5 9.5-9.5M38 40c-.9665 0-1.75.7835-1.75 1.75s.7835 1.75 1.75 1.75 1.75-.7835 1.75-1.75S38.9665 40 38 40m-1.5-2h3v-4.9639h-3z"
      key="2"
    />,
  ],
  'TicketsAlert',
  48
);

export const TicketsCheckIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M43 8c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617 0 1.2627.4879 2.4319 1.3037 3.3096a12.13 12.13 0 0 0-3.1982-.4297c-6.6948 0-12.1223 5.4259-12.125 12.1201h-6.9668c-.2061-.5823-.7602-1-1.4131-1s-1.207.4177-1.4131 1H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 27.2635 8.0684 25.2839 8.0684 23s-1.5934-4.2635-3.838-4.7676L3 17.9561V10c0-1.1046.8954-2 2-2h11.0869A1.5 1.5 0 0 0 16 8.5c0 .8284.6716 1.5 1.5 1.5S19 9.3284 19 8.5a1.5 1.5 0 0 0-.0869-.5zM17.5 31c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5M45 28.043v.0615c-.0423-.03-.0842-.0604-.127-.0899zM17.5 25c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 2h34v3H7zm40.5 36.5c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5S32.7533 29 38 29s9.5 4.2533 9.5 9.5m-3.8811-2.6009-2.2198-2.018-4.9508 5.4459L34 36.8787 31.8787 39l4.673 4.673z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'TicketsCheck',
  48
);

export const TicketsDiscountIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M16.0869 8A1.5 1.5 0 0 0 16 8.5c0 .8284.6716 1.5 1.5 1.5S19 9.3284 19 8.5a1.5 1.5 0 0 0-.0869-.5H43c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617s1.5947 4.261 3.8389 4.7617l.1103.0244-4.0615 4.0625C39.0563 29.0587 36.5191 27 33.5 27c-3.5899 0-6.5 2.9101-6.5 6.5 0 1.7474.6907 3.3323 1.8125 4.5h-9.8994c-.2061-.5823-.7602-1-1.4131-1s-1.207.4177-1.4131 1H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 27.2635 8.0684 25.2839 8.0684 23s-1.5934-4.2635-3.838-4.7676L3 17.9561V10c0-1.1046.8954-2 2-2zM33.5 30c1.933 0 3.5 1.567 3.5 3.5S35.433 37 33.5 37 30 35.433 30 33.5s1.567-3.5 3.5-3.5m-16 1c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 2h34v3H7zm40.6213 30.5L32.5 47.6213 30.3787 45.5 45.5 30.3787z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M37 33.5c0-1.933-1.567-3.5-3.5-3.5S30 31.567 30 33.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5m11 11c0-1.933-1.567-3.5-3.5-3.5S41 42.567 41 44.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5"
      key="2"
    />,
  ],
  'TicketsDiscount',
  48
);

export const TicketsEditIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M43 8c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617a4.84 4.84 0 0 0 .2373 1.499 7.6 7.6 0 0 0-2.6826 1.7364L25.6904 38h-6.7773c-.2061-.5823-.7602-1-1.4131-1s-1.207.4177-1.4131 1H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 27.2635 8.0684 25.2839 8.0684 23s-1.5934-4.2635-3.838-4.7676L3 17.9561V10c0-1.1046.8954-2 2-2h11.0869A1.5 1.5 0 0 0 16 8.5c0 .8284.6716 1.5 1.5 1.5S19 9.3284 19 8.5a1.5 1.5 0 0 0-.0869-.5zM17.5 31c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 2h34v3H7zm32.5759 26.3568c1.8091-1.8091 4.7422-1.8091 6.5513 0s1.809 4.7422 0 6.5513l-12.076 12.0761-7.1594.6079.6081-7.1593z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'TicketsEdit',
  48
);

export const TicketsGetIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M43 8c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617 0 1.2627.4879 2.4319 1.3037 3.3096a12.13 12.13 0 0 0-3.1982-.4297c-6.6948 0-12.1223 5.4259-12.125 12.1201h-6.9668c-.2061-.5823-.7602-1-1.4131-1s-1.207.4177-1.4131 1H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 27.2635 8.0684 25.2839 8.0684 23s-1.5934-4.2635-3.838-4.7676L3 17.9561V10c0-1.1046.8954-2 2-2h11.0869A1.5 1.5 0 0 0 16 8.5c0 .8284.6716 1.5 1.5 1.5S19 9.3284 19 8.5a1.5 1.5 0 0 0-.0869-.5zM17.5 31c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5M45 28.043v.0615c-.0423-.03-.0842-.0604-.127-.0899zM17.5 25c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 2h34v3H7zm40.5 36.5c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5S32.7533 29 38 29s9.5 4.2533 9.5 9.5m-8 .3787 2.1449-2.1449 2.1213 2.1213-5.7661 5.7662-5.7695-5.7695 2.1214-2.1213 2.148 2.1481V33.5h3z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'TicketsGet',
  48
);

export const TicketsMoveIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M16.0869 8A1.5 1.5 0 0 0 16 8.5c0 .8284.6716 1.5 1.5 1.5S19 9.3284 19 8.5a1.5 1.5 0 0 0-.0869-.5H43c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617s1.5947 4.261 3.8389 4.7617L45 28.043v6.7402l-7.2881-5.4658V29l-.2129.1582L37.2881 29v.3174L25.7119 38h-6.7988c-.2061-.5823-.7602-1-1.4131-1s-1.207.4177-1.4131 1H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 27.2635 8.0684 25.2839 8.0684 23s-1.5934-4.2635-3.838-4.7676L3 17.9561V10c0-1.1046.8954-2 2-2zM17.5 31c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 2h34v3H7zm21.0001 38.0339 6.7118 5.0339V35zm18.9999 0-6.7119 5.0339V35z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'TicketsMove',
  48
);

export const TicketsRefreshIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M43 8c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617 0 1.2627.4879 2.4319 1.3037 3.3096a12.13 12.13 0 0 0-3.1982-.4297c-6.6948 0-12.1223 5.4259-12.125 12.1201h-6.9668c-.2061-.5823-.7602-1-1.4131-1s-1.207.4177-1.4131 1H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 27.2635 8.0684 25.2839 8.0684 23s-1.5934-4.2635-3.838-4.7676L3 17.9561V10c0-1.1046.8954-2 2-2h11.0869A1.5 1.5 0 0 0 16 8.5c0 .8284.6716 1.5 1.5 1.5S19 9.3284 19 8.5a1.5 1.5 0 0 0-.0869-.5zM17.5 31c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5M45 28.043v.0615c-.0423-.03-.0842-.0604-.127-.0899zM17.5 25c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 2h34v3H7zm25.5 45.5v-4h4v-3h-7v7z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M29.7785 42.7624a10 10 0 0 1-.1462-.2614l2.6291-1.4448.1226.2189c1.1295 1.932 3.2229 3.2249 5.6161 3.2249 3.3136 0 6.05-2.4808 6.4497-5.6856l.1856-1.4885 2.9769.3712-.1856 1.4885c-.5845 4.6878-4.5809 8.3144-9.4266 8.3144-2.9761 0-5.631-1.3689-7.3716-3.5074l-.1223.0685zm1.5864-4.0883.1856-1.4885c.3996-3.2048 3.1361-5.6856 6.4496-5.6856 2.4182 0 4.5303 1.32 5.6511 3.2854l.084.1517 2.6327-1.4381a9 9 0 0 0-.1001-.1811l-.7227-1.3054-.117.0648c-1.7394-2.1786-4.4196-3.5773-7.428-3.5773-4.8457 0-8.842 3.6266-9.4266 8.3144l-.1856 1.4885z"
      clipRule="evenodd"
      key="2"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M43.5 28.5v4h-4v3h7v-7z"
      clipRule="evenodd"
      key="3"
    />,
  ],
  'TicketsRefresh',
  48
);

export const TicketsRemoveIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M43 8c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617 0 1.2627.4879 2.4319 1.3037 3.3096a12.13 12.13 0 0 0-3.1982-.4297c-6.6948 0-12.1223 5.4259-12.125 12.1201h-6.9668c-.2061-.5823-.7602-1-1.4131-1s-1.207.4177-1.4131 1H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 27.2635 8.0684 25.2839 8.0684 23s-1.5934-4.2635-3.838-4.7676L3 17.9561V10c0-1.1046.8954-2 2-2h11.0869A1.5 1.5 0 0 0 16 8.5c0 .8284.6716 1.5 1.5 1.5S19 9.3284 19 8.5a1.5 1.5 0 0 0-.0869-.5zM17.5 31c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5M45 28.043v.0615c-.0423-.03-.0842-.0604-.127-.0899zM17.5 25c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 2h34v3H7zm40.5 36.5c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5S32.7533 29 38 29s9.5 4.2533 9.5 9.5M33 37v3h10v-3z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'TicketsRemove',
  48
);

export const TicketsReturnIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M43 8c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617s1.5947 4.261 3.8389 4.7617L45 28.043v3.0556c-1.4942-.8666-3.2296-1.3632-5.0811-1.3632h-.6377l-.6083-.5713-5.6993-5.6993c-.3905-.3904-1.0235-.3904-1.414 0L21.4648 33.5596c-.3904.3905-.3904 1.0235 0 1.414L24.4912 38h-5.5781c-.2061-.5823-.7602-1-1.4131-1s-1.207.4177-1.4131 1H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 27.2635 8.0684 25.2839 8.0684 23s-1.5934-4.2635-3.838-4.7676L3 17.9561V10c0-1.1046.8954-2 2-2h11.0869A1.5 1.5 0 0 0 16 8.5c0 .8284.6716 1.5 1.5 1.5S19 9.3284 19 8.5a1.5 1.5 0 0 0-.0869-.5zM17.5 31c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 2h34v3H7z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="m34.4307 29.1641-3.5703 3.5713h9.0585c3.9447 0 7.1433 3.1979 7.1436 7.1425 0 3.9448-3.1987 7.1436-7.1436 7.1436h-2.5507V43.96h2.5507c2.2542 0 4.0821-1.8279 4.0821-4.0821-.0003-2.2539-1.8281-4.081-4.0821-4.081h-9.0595l3.5713 3.5713-2.1641 2.165L25 34.2666 32.2666 27z"
      key="2"
    />,
  ],
  'TicketsReturn',
  48
);

export const TicketsStarIcon = createSvgIcon(
  [
    <g fill="currentColor" key="0">
      <path d="M43 8c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617s1.5947 4.261 3.8389 4.7617L45 28.043v6.4062l-1.7158-.7344-2.5264-5.8964a3.0005 3.0005 0 0 0-5.5156 0l-2.5274 5.8964-5.8964 2.5274A3 3 0 0 0 25.1729 38h-6.2598c-.2061-.5823-.7602-1-1.4131-1s-1.207.4177-1.4131 1H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 27.2635 8.0684 25.2839 8.0684 23s-1.5934-4.2635-3.838-4.7676L3 17.9561V10c0-1.1046.8954-2 2-2h11.0869A1.5 1.5 0 0 0 16 8.5c0 .8284.6716 1.5 1.5 1.5S19 9.3284 19 8.5a1.5 1.5 0 0 0-.0869-.5zM17.5 31c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5" />
      <path fillRule="evenodd" d="M7 2h34v3H7z" clipRule="evenodd" />
      <path d="m41 36-3-7-3 7-7 3 7 3 3 7 3-7 7-3z" />
    </g>,
    <defs key="1"></defs>,
  ],
  'TicketsStar',
  48
);

export const TicketsTimeIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M43 8c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617 0 1.2627.4879 2.4319 1.3037 3.3096a12.13 12.13 0 0 0-3.1982-.4297c-6.6948 0-12.1223 5.4259-12.125 12.1201h-6.9668c-.2061-.5823-.7602-1-1.4131-1s-1.207.4177-1.4131 1H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 27.2635 8.0684 25.2839 8.0684 23s-1.5934-4.2635-3.838-4.7676L3 17.9561V10c0-1.1046.8954-2 2-2h11.0869A1.5 1.5 0 0 0 16 8.5c0 .8284.6716 1.5 1.5 1.5S19 9.3284 19 8.5a1.5 1.5 0 0 0-.0869-.5zM17.5 31c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5M45 28.043v.0615c-.0423-.03-.0842-.0604-.127-.0899zM17.5 25c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5m0-6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 2h34v3H7zm31 46c5.2467 0 9.5-4.2533 9.5-9.5S43.2467 29 38 29s-9.5 4.2533-9.5 9.5S32.7533 48 38 48m1.5-14.5h-3v5.7719l5.3487 3.8206 1.7438-2.4412L39.5 37.7281z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'TicketsTime',
  48
);

export const TicketsUserIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M43 12c1.1046 0 2 .8954 2 2v7.957l-1.2617.2813c-2.2442.5007-3.8389 2.4789-3.8389 4.7617s1.5947 4.261 3.8389 4.7617L45 32.043V40c0 1.1046-.8954 2-2 2H5c-1.1046 0-2-.8954-2-2v-7.9561l1.2305-.2763C6.475 31.2635 8.0684 29.2839 8.0684 27s-1.5934-4.2635-3.838-4.7676L3 21.9561V14c0-1.1046.8954-2 2-2zM24 26.9004c-4.4183 0-8 3.6261-8 8.0996h16c0-4.4735-3.5817-8.0996-8-8.0996M24 17c-2.2091 0-3.9999 1.8131-4 4.0498 0 2.2368 1.7908 4.0498 4 4.0498s4-1.813 4-4.0498C27.9999 18.8131 26.2091 17 24 17"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 6h34v3H7z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'TicketsUser',
  48
);

export const TriangleWarningIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M28.7533 6.6394c-2.1208-3.5192-7.384-3.5192-9.5047 0L2.7532 34.0174C.5807 37.6226 3.3417 42 7.5056 42h32.9892c4.1639 0 6.9249-4.3775 4.7523-7.9827zM25.5 14v14h-3V14zM24 36c1.3807 0 2.5-1.1193 2.5-2.5S25.3807 31 24 31s-2.5 1.1193-2.5 2.5S22.6193 36 24 36"
    clipRule="evenodd"
  />,
  'TriangleWarning',
  48
);

export const UnlinkIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m25.5907 18.4553-.9803.2376c-1.3713.369-2.6675 1.0911-3.7469 2.1705-3.2799 3.2799-3.2799 8.5975 0 11.8773l6.2993 6.2994c3.2799 3.2799 8.5975 3.2799 11.8774 0 3.2798-3.2798 3.2798-8.5975 0-11.8773l-4.7969-4.7968 2.1213-2.1214 4.7969 4.7969c4.4514 4.4514 4.4514 11.6685 0 16.1199s-11.6686 4.4515-16.12 0l-6.2994-6.2993c-4.4514-4.4514-4.4514-11.6686 0-16.12 1.4609-1.4608 3.2235-2.4443 5.0888-2.9462l.9802-.2376z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.8418 8.9645c-3.2798-3.2798-8.5975-3.2798-11.8773 0-3.2798 3.2799-3.2798 8.5975 0 11.8773l4.7929 4.7929-2.1213 2.1214-4.793-4.7929c-4.4513-4.4514-4.4513-11.6686 0-16.12 4.4515-4.4514 11.6686-4.4514 16.12 0l6.2994 6.2994c4.4514 4.4514 4.4514 11.6685 0 16.1199-1.4644 1.4644-3.232 2.4491-5.1024 2.9499l-.9682.2471-.7759-2.898.9682-.247c1.3751-.3682 2.675-1.0912 3.757-2.1733 3.2798-3.2798 3.2798-8.5975 0-11.8773zm15.7071-4.7001-3 5.1961-2.598-1.5 3-5.1961zm-19.5 35.7749-3 5.1962-2.598-1.5 3-5.1962zM45.2355 14.049l-5.1962 3-1.5-2.5981 5.1962-3zm-35.7749 19.5-5.1962 3-1.5-2.5981 5.1961-3z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'Unlink',
  48
);

export const UpdateIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="m31.5113 32.5.0392-.3144c.3996-3.2048 3.1361-5.6856 6.4496-5.6856 2.4182 0 4.5302 1.32 5.6511 3.2854l.0839.1517 2.6328-1.4381c-.2682-.4978-.6232-.9539-.9398-1.4217-1.7394-2.1786-4.4196-3.5773-7.428-3.5773-4.8457 0-8.842 3.6266-9.4266 8.3144l-.0855.6856zm12.9777 1h3.0232l-.0855.6856c-.5845 4.6878-4.5809 8.3144-9.4266 8.3144-2.9761 0-5.631-1.3689-7.3716-3.5074-.3385-.49-.7132-.9665-.9962-1.4916l2.6291-1.4448.1227.2189c1.1294 1.932 3.2228 3.2249 5.616 3.2249 3.3136 0 6.05-2.4808 6.4497-5.6856z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M40 30.5h6.5V24zm-4 5h-6.5V42z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M23.2667 6C14.564 6 7.3985 12.5504 6.904 20.8784 3.4514 22.3242 1 25.6398 1 29.5455 1 34.8048 5.4253 39 10.8 39h15.7v-3.3652c-.7776-.6307-1.222-1.6364-1.089-2.7032l.1856-1.4884c.7694-6.17 6.025-10.9432 12.4035-10.9432.5493 0 1.0903.0355 1.6208.1043C38.9879 12.4055 31.8734 6 23.2667 6"
      key="2"
    />,
  ],
  'Update',
  48
);

export const UserGlobeIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M46.9177 17h-6.0093a21.48 21.48 0 0 1-3.1804 9.8383l-1.1184 1.8019C42.0935 27.3474 46.2864 22.7104 46.9177 17m0-3h-6.0093a21.48 21.48 0 0 0-3.1804-9.8383L36.6096 2.36C42.0935 3.6526 46.2865 8.2896 46.9177 14M30.3906 2.3599C24.9067 3.6526 20.7137 8.2896 20.0825 14h6.0093a21.48 21.48 0 0 1 3.1804-9.8383zM20.0825 17c.6313 5.7104 4.8242 10.3474 10.3081 11.6402l-1.1184-1.8019A21.48 21.48 0 0 1 26.0918 17zm15.0966 8.2563-1.679 2.705-1.679-2.705A18.48 18.48 0 0 1 29.1003 17h8.7996a18.48 18.48 0 0 1-2.7208 8.2563m0-19.5125-1.679-2.705-1.679 2.705A18.48 18.48 0 0 0 29.1003 14h8.7996a18.48 18.48 0 0 0-2.7208-8.2562M12.5 29c3.0376 0 5.5-2.4624 5.5-5.5S15.5376 18 12.5 18 7 20.4624 7 23.5 9.4624 29 12.5 29m11.4981 12.5725-.7713.1795c-7.1487 1.664-14.3046 1.664-21.4533 0l-.7713-.1795C1.1194 35.6519 6.2892 31 12.5001 31c6.211 0 11.3808 4.6519 11.498 10.5725"
  />,
  'UserGlobe',
  48
);

export const UserPositionIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m16.0671 33.6161-1.4601.3439c-2.5302.5959-4.5335 1.4043-5.8652 2.2932C7.3659 37.1715 7 37.9615 7 38.4746c0 .3945.205.9442.956 1.6184.7503.6737 1.9207 1.3491 3.495 1.947 3.1381 1.1916 7.5745 1.9599 12.549 1.9599s9.4109-.7683 12.549-1.9599c1.5743-.5979 2.7447-1.2733 3.4951-1.947.751-.6742.9559-1.2239.9559-1.6184 0-.5131-.3659-1.3031-1.7418-2.2214-1.3317-.8889-3.335-1.6973-5.8652-2.2932l-1.4601-.3439.6877-2.9201 1.4601.3439c2.7298.6429 5.1081 1.5601 6.843 2.7181C42.6144 34.8865 44 36.4645 44 38.4746c0 1.5455-.8304 2.844-1.9517 3.8507-1.122 1.0073-2.6608 1.8458-4.4343 2.5192-3.5576 1.351-8.3713 2.1554-13.614 2.1554s-10.0564-.8044-13.614-2.1554c-1.7735-.6734-3.3123-1.5119-4.4343-2.5192C4.8304 41.3186 4 40.0201 4 38.4746c0-2.0101 1.3856-3.5881 3.0763-4.7166 1.7349-1.158 4.1132-2.0752 6.843-2.7181l1.4601-.3439z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M24 9c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4m4.1545 30h-8.3081l-1.5228-13.5333L15 23.6583l1.3676-8.9331c.1978-1.2894 1.0104-2.3653 2.1404-2.8084C19.7394 11.434 22.0657 11 24.0016 11c.9639 0 3.4048.1085 5.4322.8933 1.1483.4449 1.9991 1.5244 2.1985 2.8319L33 23.6583l-3.3236 1.8084z"
      key="1"
    />,
  ],
  'UserPosition',
  48
);

export const UsersChatIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 34c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5m24 0c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 6.3835C18 5.0672 19.066 4 20.381 4h15.238C36.934 4 38 5.0671 38 6.3835v9.3435c0 1.3164-1.066 2.3836-2.381 2.3836H23.7671L18 22zM2.1382 44.3345C2.9318 39.6043 7.044 36 12 36s9.0682 3.6043 9.8618 8.3345l.1565.9331-3.2037.7219a31 31 0 0 1-13.6292 0l-3.2037-.7219zm23.8755 0C26.8073 39.6043 30.9195 36 35.8755 36s9.0682 3.6043 9.8618 8.3345l.1565.9331-3.2037.7219a31 31 0 0 1-13.6292 0l-3.2037-.7219z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'UsersChat',
  48
);

export const UsersCheckIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 34c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5m24 0c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M33.5 12.5c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5S18.7533 3 24 3s9.5 4.2533 9.5 9.5m-3.8811-2.6009-2.2198-2.018-4.9508 5.4459L20 10.8787 17.8787 13l4.673 4.673zM2.1385 44.3345C2.932 39.6043 7.0443 36 12.0002 36s9.0682 3.6043 9.8618 8.3345l.1566.9331-3.2038.7219a31 31 0 0 1-13.6292 0l-3.2037-.7219zm23.8755 0C26.8075 39.6043 30.9197 36 35.8757 36s9.0682 3.6043 9.8618 8.3345l.1565.9331-3.2037.7219a31 31 0 0 1-13.6292 0l-3.2037-.7219z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'UsersCheck',
  48
);

export const UsersMinusIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 34c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5m24 0c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M33.5 12.5c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5S18.7533 3 24 3s9.5 4.2533 9.5 9.5M19 11v3h10v-3zM2.1382 44.3345C2.9318 39.6043 7.044 36 12 36s9.0682 3.6043 9.8618 8.3345l.1565.9331-3.2037.7219a31 31 0 0 1-13.6292 0l-3.2037-.7219zm23.8755 0C26.8073 39.6043 30.9195 36 35.8755 36s9.0682 3.6043 9.8618 8.3345l.1565.9331-3.2037.7219a31 31 0 0 1-13.6292 0l-3.2037-.7219z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'UsersMinus',
  48
);

export const UsersPinIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 34c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5m24 0c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 3c-4.9385 0-9 3.8653-9 8.7024 0 4.7987 3.7532 8.7023 8.4637 11.9301L24 24l.5363-.3675C29.2468 20.4047 33 16.5011 33 11.7024 33 6.8653 28.9385 3 24 3m0 6c-1.3807 0-2.5 1.1193-2.5 2.5S22.6193 14 24 14s2.5-1.1193 2.5-2.5S25.3807 9 24 9M2.1385 44.3345C2.932 39.6043 7.0443 36 12.0002 36s9.0682 3.6043 9.8618 8.3345l.1566.9331-3.2038.7219a31 31 0 0 1-13.6292 0l-3.2037-.7219zm23.8755 0C26.8075 39.6043 30.9197 36 35.8757 36s9.0682 3.6043 9.8618 8.3345l.1565.9331-3.2037.7219a31 31 0 0 1-13.6292 0l-3.2037-.7219z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'UsersPin',
  48
);

export const UsersPlusIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 34c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5m24 0c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M33.5 12.5c0 5.2467-4.2533 9.5-9.5 9.5s-9.5-4.2533-9.5-9.5S18.7533 3 24 3s9.5 4.2533 9.5 9.5m-8-5h-3V11H19v3h3.5v3.5h3V14H29v-3h-3.5zM2.1385 44.3345C2.932 39.6043 7.0443 36 12.0002 36s9.0682 3.6043 9.8618 8.3345l.1566.9331-3.2038.7219a31 31 0 0 1-13.6292 0l-3.2037-.7219zm23.8755 0C26.8075 39.6043 30.9197 36 35.8757 36s9.0682 3.6043 9.8618 8.3345l.1565.9331-3.2037.7219a31 31 0 0 1-13.6292 0l-3.2037-.7219z"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'UsersPlus',
  48
);

export const UsersSegmentIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12 22c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5m24 0c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.1385 32.3345C2.932 27.6043 7.0443 24 12.0002 24s9.0682 3.6043 9.8618 8.3345l.1566.9331-3.2038.7219a31 31 0 0 1-13.6292 0l-3.2037-.7219zm23.8755 0C26.8075 27.6043 30.9197 24 35.8757 24s9.0682 3.6043 9.8618 8.3345l.1565.9331-3.2037.7219a31 31 0 0 1-13.6292 0l-3.2037-.7219zM21.75 3.75c0-1.2426 1.0074-2.25 2.25-2.25s2.25 1.0074 2.25 2.25S25.2426 6 24 6s-2.25-1.0074-2.25-2.25m7.9207.6806c.4755-1.148 1.7917-1.6933 2.9397-1.2177 1.1481.4755 1.6933 1.7917 1.2177 2.9397-.4755 1.148-1.7917 1.6933-2.9397 1.2177-1.1481-.4755-1.6933-1.7917-1.2177-2.9397m-11.3411-.0003c.4755 1.148-.0696 2.4643-1.2177 2.9398s-2.4642-.0697-2.9398-1.2177c-.4755-1.148.0697-2.4642 1.2177-2.9398 1.1481-.4755 2.4643.0697 2.9398 1.2177m7.9202 39.3199c0 1.2427-1.0074 2.25-2.25 2.25s-2.25-1.0073-2.25-2.25 1.0074-2.25 2.25-2.25 2.25 1.0074 2.25 2.25m-7.9207-.6805c-.4755 1.148-1.7917 1.6932-2.9397 1.2177s-1.6933-1.7917-1.2177-2.9398c.4755-1.148 1.7917-1.6932 2.9397-1.2177s1.6933 1.7917 1.2177 2.9398m11.3411.0002c-.4755-1.148.0696-2.4642 1.2177-2.9397s2.4642.0696 2.9398 1.2176c.4755 1.1481-.0697 2.4643-1.2177 2.9398-1.1481.4756-2.4643-.0696-2.9398-1.2177"
      clipRule="evenodd"
      key="1"
    />,
  ],
  'UsersSegment',
  48
);

export const UsersIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M12.5237 32.4437v2.4192c0 2.6105-4.8997 3.3356-6.92 4.1594C3.4701 39.6307 2 41.5721 2 43.7808V45h30v-1.2192c0-2.2087-1.4702-4.1501-3.6036-4.7585-2.0204-.8238-6.9201-1.5489-6.9201-4.1594V32.625c2.8483-.231 4.7283-1.2606 6.6034-2.9733-2.9013-3.2489-2.7902-6.9267-2.7902-9.4017 0-4.5563-3.7113-8.25-8.2895-8.25-4.5781 0-8.2895 3.6937-8.2895 8.25 0 2.475.1113 6.1528-2.79 9.4017 1.875 1.7127 3.755 2.561 6.6032 2.792"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M31.1898 37H46v-2.9601c0-1.2804-.8129-2.4125-2.0193-2.8416-2.8905-1.0281-7.1983-2.695-8.537-4.1453-.272-.2948-.3402-.7039-.3402-1.105v-1.8848c1.7784-1.188 3.0606-3.0525 3.4369-5.2548l.9352-5.4732C40.4 7.925 36.1229 3 30.5 3c-4.4214 0-8.0106 3.045-8.8933 6.9767 4.0608 1.8111 6.683 5.9116 6.6827 10.3462-.0001 2.5528-.0003 5.0594 2.0279 7.3305l.6587.7376c.7299.8173.6661 2.0698-.143 2.8089l-.7301.6669c-1.4216 1.2984-2.928 2.3263-4.7495 2.9851z"
      key="1"
    />,
  ],
  'Users',
  48
);

export const ViewPlusSignIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 17c0-5.5228 4.4772-10 10-10s10 4.4772 10 10-4.4772 10-10 10-10-4.4772-10-10m32 20c0 5.5228-4.4772 10-10 10s-10-4.4772-10-10 4.4772-10 10-10 10 4.4772 10 10m-8.5-5.5v4h4v3h-4v4h-3v-4h-4v-3h4v-4z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      d="M8.6508 15.6397C11.8605 12.321 16.8511 9 24 9s12.1394 3.321 15.3491 6.6397c1.6075 1.6621 2.7686 3.3245 3.5268 4.5696.361.5928.6883 1.1864.977 1.7906-.2888.6043-.6168 1.1993-.977 1.7908a26.2 26.2 0 0 1-1.0475 1.586l2.5089 1.6485a29.2 29.2 0 0 0 1.1009-1.6742c.6544-1.0747 1.1983-2.1969 1.6944-3.351-.4961-1.1541-1.0399-2.2763-1.6944-3.351-.8451-1.3877-2.1368-3.2381-3.9327-5.0949C37.9059 9.8321 32.1835 6 24 6S10.094 9.8322 6.4944 13.5541c-1.7959 1.8568-3.0876 3.7072-3.9327 5.0949-.6563 1.0778-1.1966 2.1933-1.6948 3.3509.498 1.1577 1.0384 2.2732 1.6948 3.3511.845 1.3877 2.1368 3.2381 3.9327 5.0949 3.4566 3.5741 8.8708 7.2498 16.542 7.5362l.1188-2.9977c-6.6992-.2492-11.4227-3.4377-14.5044-6.6241-1.6075-1.6621-2.7686-3.3245-3.5268-4.5696-.3537-.5808-.6912-1.175-.981-1.7907.2898-.6157.6273-1.2099.981-1.7907.7582-1.2451 1.9193-2.9075 3.5268-4.5696"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.5 1v3.5h-3V1zm13.0488 3.585-2 3.464-2.5981-1.5 2-3.464zm-29.0978 0 1.9999 3.464 2.5981-1.5-2-3.464z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'ViewPlusSign',
  48
);

export const VirtualSpaceIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="m13.0253 16.9547 1.1457 14.8328c2.8795-.4997 6.2373-.788 9.829-.788s6.9495.2883 9.829.788l1.0891-14.8791c1.9476-.6083 5.5416-1.3086 7.6133-3.9089H45v-1c0-1.3132-.8828-2.3636-1.9932-3.1511-1.1363-.806-2.7157-1.4909-4.5773-2.0494C34.6935 5.6782 29.5921 4.9995 24 4.9995S13.3065 5.6782 9.5705 6.799c-1.8616.5585-3.441 1.2434-4.5773 2.0494C3.8828 9.6359 3 10.6863 3 11.9995v1h2c2.172 1.4714 8.2696 3.9128 8.0253 3.9552"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.9999 31.0125c-3.5661 0-6.8951.2862-9.7435.7806l-.513-2.9559c3.0351-.5267 6.5369-.8247 10.2565-.8247s7.2214.298 10.2565.8247l-.513 2.9559c-2.8484-.4944-6.1774-.7806-9.7435-.7806"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.0057 8c5.2194-.0196 10.0346.6146 13.4516 1.6161 1.7213.5046 2.9911 1.0747 3.7756 1.6334.4992.3555.8067.6103.7379 1.2233-.0843.2668-.3959.7169-1.4712 1.27-1.3186.6783-3.3913 1.2867-6.2537 1.7789l-1.2458.2142v26.6642l1.7645-.3162c2.3513-.4213 4.7434-1.0871 6.5882-1.967.9181-.4379 1.7779-.9649 2.4294-1.6015.6501-.6351 1.2179-1.5087 1.2179-2.5989V12.3672c.131-1.5818-.9223-2.7748-2.027-3.5614-1.1737-.8358-2.8045-1.5211-4.672-2.0685C34.5412 5.6353 29.4273 4.9798 23.9972 5c-5.4886.0002-10.6133.6755-14.3631 1.7823-1.862.5497-3.4828 1.2338-4.6447 2.0629C3.9045 9.6192 2.8506 10.8056 3 12.378v23.5385c0 1.0902.5677 1.9638 1.2178 2.5989.6515.6366 1.5114 1.1636 2.4294 1.6015 1.8448.8799 4.2369 1.5457 6.5882 1.967L15 42.4001V15.7359l-1.2459-.2142c-2.8624-.4922-4.935-1.1006-6.2537-1.7789-1.036-.5329-1.363-.9701-1.461-1.24-.0821-.6329.1684-.8416.6924-1.2156.7734-.5519 2.0338-1.1206 3.7515-1.6276C13.8924 8.6533 18.7202 8 24.0001 8zM6.0001 16.3435v19.573c0 .0028-.0006.0325.0349.1017.0398.0777.1217.1973.2794.3514.3248.3173.8615.6756 1.6244 1.0395 1.1047.5269 2.5225.9903 4.0613 1.3555V18.2481c-2.404-.4772-4.3956-1.0782-5.8719-1.8376a10 10 0 0 1-.1281-.067m36 0v19.573c0 .0028.0005.0325-.0349.1017-.0399.0777-.1218.1973-.2795.3514-.3247.3173-.8614.6756-1.6244 1.0395-1.1047.5269-2.5225.9903-4.0612 1.3555V18.2481c2.4039-.4772 4.3956-1.0782 5.8718-1.8376q.0643-.033.1282-.067"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'VirtualSpace',
  48
);

export const WalletIcon = createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M36 8.5V9h3c0-2.7614-2.2386-5-5-5H9C6.2386 4 4 6.2386 4 9v29.0001c0 3.3137 2.6863 6 6 6h28c3.3137 0 6-2.6863 6-6V18c0-3.3137-2.6863-6-6-6H9.5C8.1193 12 7 10.8807 7 9.5S8.1193 7 9.5 7h25c.8284 0 1.5.6716 1.5 1.5M41 33h-6.0408C32.2201 33 30 30.7617 30 28s2.2201-5 4.9592-5H41z"
    clipRule="evenodd"
  />,
  'Wallet',
  48
);

export const WatchIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M38 20h2c1.1046 0 2 .8954 2 2v4c0 1.1046-.8954 2-2 2h-2v-2h2v-4h-2z"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 7c-3.3137 0-6 2.6863-6 6v22c0 3.3137 2.6863 6 6 6h20c3.3137 0 6-2.6863 6-6V13c0-3.3137-2.6863-6-6-6zm11.5 7h-3v11.5H35v-3h-9.5z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M15.2793 47h17.4415l1-3H14.2793zm0-46h17.4415l1 3H14.2793z"
      key="2"
    />,
  ],
  'Watch',
  48
);

export const WidgetIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M40 6c3.3137 0 6 2.6863 6 6v24c0 3.3137-2.6863 6-6 6H8c-3.3137 0-6-2.6863-6-6V12c0-3.3137 2.6863-6 6-6zM28.3633 32.1787l-7.877-5.415-.8496-.584-.8506.584-11.6357 8 1.6992 2.4726 10.7861-7.416 7.878 5.416.8496.584.8506-.584 11.6357-8-1.6992-2.4726zM7 22.5h12v-3H7zM7 16h29v-3H7z"
  />,
  'Widget',
  48
);

export const WindowPaintbrushIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M32.0563 36.3891C31.4507 35.1498 31 33.7908 31 32.4569 31 27.6909 34.6216 25 38 25s7 2.6909 7 7.4569c0 1.3312-.4509 2.6887-1.0563 3.9271-.6108 1.2493-1.4147 2.4498-2.2018 3.4852-.7893 1.0384-1.5763 1.9298-2.1649 2.5608-.508.5448-1.0389 1.0596-1.577 1.57-.5377-.51-1.0685-1.0239-1.5766-1.5677-.5886-.6302-1.3757-1.5204-2.1651-2.5581-.7872-1.0348-1.5913-2.2351-2.202-3.4851"
      clipRule="evenodd"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28.7744 39c.5981 1.0796 1.2925 2.0949 1.9815 3H8c-3.3137 0-6-2.6863-6-6V12c0-3.3137 2.6863-6 6-6h22.5106c-.552 1.3263-.7593 2.8214-.5171 4.3629L31.3508 19H5v17c0 1.6569 1.3431 3 3 3zM8.5 10.5c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2m4 2c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      d="M41.0615 22.5036 43.0426 9.897C43.5293 6.7998 41.1351 4 37.9999 4s-5.5295 2.8-5.0428 5.8972l1.981 12.6065C35.9346 22.1718 36.9715 22 38 22c1.0284 0 2.0651.1717 3.0615.5036"
      key="2"
    />,
  ],
  'WindowPaintbrush',
  48
);

export const WineMenuIcon = createSvgIcon(
  [
    <path
      fill="currentColor"
      d="M16.5 1c1.1046 0 2 .8954 2 2v3h-7V3c0-1.1046.8954-2 2-2z"
      key="0"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m18.5 16.1094.8906.498A9.001 9.001 0 0 1 24 24.4639V42.5c0 1.933-1.567 3.5-3.5 3.5h-11C7.567 46 6 44.433 6 42.5V24.4639a9.001 9.001 0 0 1 4.6094-7.8565l.8906-.498V9h7zM9 26v13h8V26z"
      clipRule="evenodd"
      key="1"
    />,
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M42 44H26.8242A6.52 6.52 0 0 0 27 42.5V24.4639c0-4.0948-2.0865-7.8879-5.5-10.0869V4H42zm-8-10v3h4v-3zm-5-13h9v-3h-9zm-5-6h8v-3h-8zm11 0h3v-3h-3z"
      clipRule="evenodd"
      key="2"
    />,
  ],
  'WineMenu',
  48
);
